import { UUID } from '@macs-frontend/core/utils/uuid';
import { AppDate } from '@macs-frontend/core/utils/date';
import { AppDateTime } from '@macs-frontend/core/utils/datetime';
import { AppTime } from '@macs-frontend/core/utils/time';

import { gql } from 'apollo-angular';
import { Injectable } from '@angular/core';
import * as Apollo from 'apollo-angular';
export type Maybe<T> = T | null;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: string;
  String: string;
  Boolean: boolean;
  Int: number;
  Float: number;
  /** Example: 2005-08-15. */
  Date: AppDate;
  /** Example: 2005-08-15. */
  DateImmutable: AppDate;
  /** Format: RFC3339_EXTENDED. Example: 2005-08-15T15:52:01+00:00. */
  DateTime: AppDateTime;
  /** Format: RFC3339_EXTENDED. Example: 2005-08-15T15:52:01+00:00. */
  DateTimeImmutable: AppDateTime;
  JSON: any;
  UUID: UUID;
};



export type AbstractBudgetItem = {
  readonly __typename?: 'AbstractBudgetItem';
  readonly project: Project;
  readonly name: Scalars['String'];
  readonly qty: Scalars['Int'];
  readonly discount: Scalars['Int'];
  readonly unitPrice: Scalars['Int'];
  readonly billablePrice: Scalars['Int'];
  readonly description: Maybe<Scalars['String']>;
  readonly createdAt: Scalars['DateTimeImmutable'];
  readonly updatedAt: Scalars['DateTimeImmutable'];
  readonly uuid: Scalars['UUID'];
};

export type Action = {
  readonly __typename?: 'Action';
  readonly hotlineNumber: Maybe<Scalars['String']>;
  readonly firstScheduleStartTime: Maybe<Scalars['DateTimeImmutable']>;
  readonly lastScheduleEndTime: Maybe<Scalars['DateTimeImmutable']>;
  readonly tenant: Maybe<SimpleEntity>;
  readonly eventDuration: Scalars['Int'];
  readonly createdAt: Scalars['DateTimeImmutable'];
  readonly name: Maybe<Scalars['String']>;
  readonly status: Maybe<ActionStatus>;
  readonly code: Maybe<Scalars['String']>;
  readonly warehouse: Maybe<Scalars['String']>;
  readonly province: Maybe<Province>;
  readonly scheduleRemark: Maybe<Scalars['String']>;
  readonly logo: Maybe<Scalars['String']>;
  readonly notes: Maybe<Scalars['String']>;
  readonly projectLeader: Maybe<ProjectTeamMember>;
  readonly locationFeeCost: Maybe<Scalars['Int']>;
  readonly estimated: Maybe<Scalars['Int']>;
  readonly transported: Maybe<Scalars['Int']>;
  readonly contactPersons: ReadonlyArray<Maybe<ContactClientRole>>;
  readonly actionPlanningDate: Maybe<ActionPlanningDate>;
  readonly actionPlanningItem: Maybe<ActionPlanningItem>;
  readonly disposableMaterial: Maybe<MaterialGroupItem>;
  readonly actionTeam: ActionTeam;
  readonly parentActionTeam: Maybe<ActionTeam>;
  readonly transports: ReadonlyArray<Maybe<Transport>>;
  readonly actionType: Maybe<Scalars['String']>;
  readonly totalActionBillablePrice: Maybe<Scalars['Int']>;
  readonly actionLocation: Maybe<ActionLocation>;
  readonly warehouseDistance: Maybe<Scalars['Int']>;
  readonly bookingPersonsQuantity: Scalars['Int'];
  readonly bookedBookingPersonsCount: Scalars['Int'];
  readonly pendingBookingPersonsCount: Scalars['Int'];
  readonly controller: Maybe<ContactClientRole>;
  readonly contracts: ReadonlyArray<Maybe<Contract>>;
  readonly projectMaterialGroupItems: ReadonlyArray<Maybe<ProjectMaterialGroupItem>>;
  readonly actionTeamName: Maybe<Scalars['String']>;
  readonly actionTeamDescription: Maybe<Scalars['String']>;
  readonly actionMaterials: ReadonlyArray<Maybe<ActionMaterial>>;
  readonly actionServices: ReadonlyArray<Maybe<ActionService>>;
  readonly debriefing: Maybe<Form>;
  readonly tags: ReadonlyArray<Maybe<Tag>>;
  readonly number: Scalars['Int'];
  readonly bookingPersons: ReadonlyArray<Maybe<BookingPerson>>;
  readonly clientForm: Maybe<Form>;
  readonly companyForm: Maybe<Form>;
  readonly publication: Maybe<ActionPublication>;
  readonly tankCode: Maybe<Scalars['String']>;
  readonly gateCode: Maybe<Scalars['String']>;
  readonly project: Maybe<Project>;
  readonly confirmationStatus: Maybe<Scalars['String']>;
  readonly confirmedBy: Maybe<Scalars['String']>;
  readonly confirmedByClientUser: Maybe<User>;
  readonly clientUserSignature: Maybe<Scalars['String']>;
  readonly locationContactSignature: Maybe<Scalars['String']>;
  readonly progressPercentage: Scalars['Int'];
  readonly actionId: Scalars['String'];
  readonly numberOfIceBoxes: Scalars['Int'];
  readonly viaCompany: Scalars['Boolean'];
  readonly parentTeamCost: Maybe<TeamCost>;
  readonly teamCost: Maybe<TeamCost>;
  readonly cancellationReason: Maybe<Scalars['String']>;
  readonly clientStatus: Maybe<ActionClientStatus>;
  readonly locationContact: Maybe<ContactClientRole>;
  readonly flowContext: Maybe<ActionFlowContext>;
  readonly declineReason: Maybe<Scalars['String']>;
  readonly projectedSamples: Maybe<Scalars['Int']>;
  readonly projectedContacts: Maybe<Scalars['Int']>;
  readonly actualSamples: Maybe<Scalars['Int']>;
  readonly actualContacts: Maybe<Scalars['Int']>;
  readonly hiddenFromClient: Scalars['Boolean'];
  readonly promoReporter: Maybe<BookingPerson>;
  readonly updatedAt: Scalars['DateTimeImmutable'];
  readonly uuid: Scalars['UUID'];
};

export enum ActionClientStatus {
  ToPlan = 'TO_PLAN',
  Pending = 'PENDING',
  ApprovedByClient = 'APPROVED_BY_CLIENT',
  Confirmed = 'CONFIRMED',
  Ongoing = 'ONGOING',
  InProgress = 'IN_PROGRESS',
  Completed = 'COMPLETED',
  Published = 'PUBLISHED',
  Canceled = 'CANCELED',
  CanceledBy = 'CANCELED_BY'
}

export type ActionFlowContext = {
  readonly __typename?: 'ActionFlowContext';
  readonly isEditable: Scalars['Boolean'];
  readonly canRequestApproval: Scalars['Boolean'];
  readonly canApprove: Scalars['Boolean'];
  readonly canConfirm: Scalars['Boolean'];
};

export enum ActionFlowTransition {
  RequestApproval = 'REQUEST_APPROVAL',
  Approve = 'APPROVE',
  Confirm = 'CONFIRM',
  DeclineByClient = 'DECLINE_BY_CLIENT',
  DeclineByAgency = 'DECLINE_BY_AGENCY'
}

export enum ActionListType {
  ClientsPlanner = 'CLIENTS_PLANNER'
}

export type ActionLocation = {
  readonly __typename?: 'ActionLocation';
  readonly province: Maybe<Province>;
  readonly cityName: Maybe<Scalars['String']>;
  readonly action: Action;
  readonly companyDistance: Maybe<Distance>;
  readonly name: Maybe<Scalars['String']>;
  readonly address: Maybe<Scalars['String']>;
  readonly lat: Maybe<Scalars['Float']>;
  readonly lng: Maybe<Scalars['Float']>;
  readonly rawDataType: Scalars['String'];
  readonly rawData: Scalars['JSON'];
  readonly uuid: Scalars['UUID'];
  readonly createdAt: Scalars['DateTimeImmutable'];
  readonly updatedAt: Scalars['DateTimeImmutable'];
};

export type ActionMaterial = {
  readonly __typename?: 'ActionMaterial';
  readonly name: Scalars['String'];
  readonly actionTeamMaterialGroupItem: Maybe<MaterialGroupItem>;
  readonly qty: Scalars['Int'];
  readonly estimated: Maybe<Scalars['Float']>;
  readonly transported: Maybe<Scalars['Float']>;
  readonly inTray: Maybe<Scalars['Int']>;
  readonly inLayer: Maybe<Scalars['Int']>;
  readonly inPalet: Maybe<Scalars['Int']>;
  readonly unitPrice: Maybe<Scalars['Int']>;
  readonly billablePrice: Maybe<Scalars['Int']>;
  readonly action: Action;
  readonly type: Scalars['String'];
  readonly uuid: Scalars['UUID'];
  readonly createdAt: Scalars['DateTimeImmutable'];
  readonly updatedAt: Scalars['DateTimeImmutable'];
};

export type ActionPlanningDate = {
  readonly __typename?: 'ActionPlanningDate';
  readonly date: Maybe<Scalars['DateImmutable']>;
  readonly actionPlanningItem: Maybe<ActionPlanningItem>;
  readonly action: Action;
  readonly createdAt: Scalars['DateTimeImmutable'];
  readonly updatedAt: Scalars['DateTimeImmutable'];
  readonly uuid: Scalars['UUID'];
};

export type ActionPlanningItem = {
  readonly __typename?: 'ActionPlanningItem';
  readonly startDate: Maybe<Scalars['DateImmutable']>;
  readonly endDate: Maybe<Scalars['DateImmutable']>;
  readonly actionTeam: Maybe<ActionTeam>;
  readonly name: Maybe<Scalars['String']>;
  readonly numberOfActions: Maybe<Scalars['Int']>;
  readonly actionPlanningDates: ReadonlyArray<Maybe<ActionPlanningDate>>;
  readonly state: ActionPlanningItemState;
  readonly createdAt: Scalars['DateTimeImmutable'];
  readonly updatedAt: Scalars['DateTimeImmutable'];
  readonly uuid: Scalars['UUID'];
};

export type ActionPlanningItemDistributeDateInput = {
  readonly UUID: Scalars['UUID'];
  readonly date: Scalars['Date'];
};

export type ActionPlanningItemDistributeInput = {
  readonly UUID: Scalars['UUID'];
  readonly name: Scalars['String'];
  readonly startDate?: Maybe<Scalars['Date']>;
  readonly endDate?: Maybe<Scalars['Date']>;
  readonly actionTeamUUID: Scalars['UUID'];
  readonly actionPlanningDates: ReadonlyArray<ActionPlanningItemDistributeDateInput>;
};

export enum ActionPlanningItemState {
  ReadyForCreateActions = 'READY_FOR_CREATE_ACTIONS',
  CreatingActions = 'CREATING_ACTIONS',
  ActionsCreated = 'ACTIONS_CREATED'
}

export type ActionPublication = {
  readonly __typename?: 'ActionPublication';
  readonly publishedAt: Scalars['DateTimeImmutable'];
  readonly publishedBy: Maybe<User>;
  readonly intro: Maybe<Scalars['String']>;
  readonly items: ReadonlyArray<Maybe<ActionPublicationItem>>;
  readonly images: ReadonlyArray<Maybe<ActionPublicationImage>>;
  readonly uuid: Scalars['UUID'];
  readonly createdAt: Scalars['DateTimeImmutable'];
  readonly updatedAt: Scalars['DateTimeImmutable'];
};

export type ActionPublicationImage = {
  readonly __typename?: 'ActionPublicationImage';
  readonly position: Scalars['Int'];
  readonly source: ActionPublicationItemSource;
  readonly name: Scalars['String'];
  readonly path: Scalars['String'];
  readonly caption: Maybe<Scalars['String']>;
  readonly uuid: Scalars['UUID'];
  readonly createdAt: Scalars['DateTimeImmutable'];
  readonly updatedAt: Scalars['DateTimeImmutable'];
};

export type ActionPublicationItem = {
  readonly __typename?: 'ActionPublicationItem';
  readonly position: Scalars['Int'];
  readonly source: ActionPublicationItemSource;
  readonly formElement: Maybe<FormElement>;
  readonly label: Scalars['String'];
  readonly value: Maybe<Scalars['String']>;
  readonly originalValue: Maybe<Scalars['String']>;
  readonly overridden: Scalars['Boolean'];
  readonly uuid: Scalars['UUID'];
  readonly createdAt: Scalars['DateTimeImmutable'];
  readonly updatedAt: Scalars['DateTimeImmutable'];
};

export enum ActionPublicationItemSource {
  AmbassadorQac = 'AMBASSADOR_QAC',
  CompanyQac = 'COMPANY_QAC',
  Agency = 'AGENCY',
  CheckIn = 'CHECK_IN'
}

export type ActionService = {
  readonly __typename?: 'ActionService';
  readonly service: Maybe<Service>;
  readonly amount: Maybe<Scalars['Int']>;
  readonly billablePrice: Maybe<Scalars['Int']>;
  readonly billablePriceMargin: Maybe<Scalars['Float']>;
  readonly unitPrice: Maybe<Scalars['Int']>;
  readonly qty: Maybe<Scalars['Int']>;
  readonly description: Maybe<Scalars['String']>;
  readonly name: Scalars['String'];
  readonly action: Action;
  readonly uuid: Scalars['UUID'];
  readonly createdAt: Scalars['DateTimeImmutable'];
  readonly updatedAt: Scalars['DateTimeImmutable'];
};

export enum ActionStatus {
  NoLocation = 'NO_LOCATION',
  NoDate = 'NO_DATE',
  Pending = 'PENDING',
  ApprovedByClient = 'APPROVED_BY_CLIENT',
  Open = 'OPEN',
  InProgress = 'IN_PROGRESS',
  Ok = 'OK',
  Ongoing = 'ONGOING',
  Completed = 'COMPLETED',
  Published = 'PUBLISHED',
  Canceled = 'CANCELED',
  CanceledBy = 'CANCELED_BY'
}

export type ActionStatusCount = {
  readonly __typename?: 'ActionStatusCount';
  readonly status: Scalars['String'];
  readonly count: Scalars['Int'];
};

export type ActionTeam = {
  readonly __typename?: 'ActionTeam';
  readonly started: Scalars['Boolean'];
  readonly end: Scalars['Boolean'];
  readonly name: Scalars['String'];
  readonly description: Maybe<Scalars['String']>;
  readonly logo: Maybe<Scalars['String']>;
  readonly transports: ReadonlyArray<Transport>;
  readonly normalHours: Maybe<Scalars['DateTimeImmutable']>;
  readonly breakHours: Maybe<Scalars['DateTimeImmutable']>;
  readonly substractBreakHours: Maybe<Scalars['Boolean']>;
  readonly contactCount: Maybe<Scalars['Int']>;
  readonly services: ReadonlyArray<Maybe<Service>>;
  readonly warehouses: ReadonlyArray<Maybe<Warehouse>>;
  readonly scheduleStartLocations: ReadonlyArray<Maybe<ScheduleStartLocation>>;
  readonly scheduleAssignments: ReadonlyArray<Maybe<ScheduleAssignment>>;
  readonly project: Maybe<Project>;
  readonly compositionReservePercentage: Maybe<Scalars['Float']>;
  readonly compositionRoles: ReadonlyArray<Maybe<CompositionRole>>;
  readonly channelCalculationResult: ChannelCalculationResult;
  readonly channel: Channel;
  readonly billablePrice: Maybe<Scalars['Int']>;
  readonly unitPrice: Maybe<Scalars['Int']>;
  readonly margin: Maybe<Scalars['Float']>;
  readonly actions: Maybe<Scalars['Int']>;
  readonly actionPlanningItems: ReadonlyArray<Maybe<ActionPlanningItem>>;
  readonly materialGroupItems: ReadonlyArray<Maybe<MaterialGroupItem>>;
  readonly totalCost: Maybe<Scalars['Int']>;
  readonly realTeamCost: Maybe<Scalars['Int']>;
  readonly realActionsQty: Maybe<Scalars['Int']>;
  readonly action: Action;
  readonly compositionRolesTotalUnitPrice: Maybe<Scalars['Int']>;
  readonly compositionRolesTotalBillablePrice: Maybe<Scalars['Int']>;
  readonly servicesTotalUnitPrice: Maybe<Scalars['Int']>;
  readonly servicesTotalBillablePrice: Maybe<Scalars['Int']>;
  readonly transportsTotalUnitPrice: Maybe<Scalars['Int']>;
  readonly transportsTotalBillablePrice: Maybe<Scalars['Int']>;
  readonly isCustom: Maybe<Scalars['Boolean']>;
  readonly parent: Maybe<ActionTeam>;
  readonly children: ReadonlyArray<Maybe<ActionTeam>>;
  readonly startTime: Maybe<Scalars['Int']>;
  readonly endTime: Maybe<Scalars['Int']>;
  readonly transportRatesheet: Maybe<Ratesheet>;
  readonly compositionRoleRatesheet: Maybe<Ratesheet>;
  readonly warehouseRatesheet: Maybe<Ratesheet>;
  readonly serviceRatesheet: Maybe<Ratesheet>;
  readonly draft: Scalars['Boolean'];
  readonly budgetItem: Maybe<TeamCostBudgetItem>;
  readonly extraCost: Scalars['Int'];
  readonly substractBreakHoursForClient: Maybe<Scalars['Boolean']>;
  readonly substractBreakHoursForHR: Maybe<Scalars['Boolean']>;
  readonly startDate: Maybe<Scalars['DateTimeImmutable']>;
  readonly endDate: Maybe<Scalars['DateTimeImmutable']>;
  readonly startDateUTC: Maybe<Scalars['DateTimeImmutable']>;
  readonly endDateUTC: Maybe<Scalars['DateTimeImmutable']>;
  readonly viaCompanyStartDate: Maybe<Scalars['DateTimeImmutable']>;
  readonly viaCompanyEndDate: Maybe<Scalars['DateTimeImmutable']>;
  readonly viaCompanyStartDateUTC: Maybe<Scalars['DateTimeImmutable']>;
  readonly viaCompanyEndDateUTC: Maybe<Scalars['DateTimeImmutable']>;
  readonly directToEventStartDate: Maybe<Scalars['DateTimeImmutable']>;
  readonly directToEventEndDate: Maybe<Scalars['DateTimeImmutable']>;
  readonly directToEventStartDateUTC: Maybe<Scalars['DateTimeImmutable']>;
  readonly directToEventEndDateUTC: Maybe<Scalars['DateTimeImmutable']>;
  readonly feesBudgetItem: FeesBudgetItem;
  readonly customNumber: Scalars['Int'];
  readonly type: ActionTeamType;
  readonly tzOffset: Scalars['Int'];
  readonly contracts: ReadonlyArray<Maybe<Contract>>;
  readonly createdAt: Scalars['DateTimeImmutable'];
  readonly updatedAt: Scalars['DateTimeImmutable'];
  readonly uuid: Scalars['UUID'];
};

export type ActionTeamPaginator = {
  readonly __typename?: 'ActionTeamPaginator';
  readonly items: ReadonlyArray<ActionTeam>;
  readonly page: Scalars['Int'];
  readonly limit: Scalars['Int'];
  readonly total: Scalars['Int'];
  /**
   * *     Hash of query parameters.
   * *
   */
  readonly hash: Scalars['String'];
  readonly hasMore: Scalars['Boolean'];
};

export type ActionTeamQueryInput = {
  readonly sort?: Maybe<ReadonlyArray<ActionTeamSortItem>>;
  readonly uuids?: Maybe<ReadonlyArray<Scalars['UUID']>>;
  readonly projects?: Maybe<ReadonlyArray<Scalars['UUID']>>;
  readonly childrenOnly?: Maybe<Scalars['Boolean']>;
  /**
   * *    Accepts positive number, maximum `1000`.
   * *    Default `1`.
   * *
   */
  readonly page?: Maybe<Scalars['Int']>;
  /**
   * *    Accepts any positive number or zero, maximum `1000`.
   * *    Zero can be used for calculate totals.
   * *    Default `20`.
   * *
   */
  readonly limit?: Maybe<Scalars['Int']>;
  readonly search?: Maybe<Scalars['String']>;
};

export type ActionTeamRole = {
  readonly __typename?: 'ActionTeamRole';
  readonly name: Scalars['String'];
  readonly compositionRole: ReadonlyArray<Maybe<CompositionRole>>;
  readonly company: Company;
  readonly uuid: Scalars['UUID'];
  readonly createdAt: Scalars['DateTimeImmutable'];
  readonly updatedAt: Scalars['DateTimeImmutable'];
};

export type ActionTeamSortItem = {
  readonly by?: Maybe<ActionTeamSortType>;
  readonly direction?: Maybe<SortDirection>;
};

export enum ActionTeamSortType {
  Name = 'NAME'
}

export enum ActionTeamType {
  Main = 'MAIN',
  Child = 'CHILD',
  PickUp = 'PICK_UP',
  DropOff = 'DROP_OFF'
}

export type ActionsFilterQueryInput = {
  readonly filterType: ActionsFilterType;
  readonly sort?: Maybe<ReadonlyArray<ActionsSortItem>>;
  readonly uuids?: Maybe<ReadonlyArray<Scalars['UUID']>>;
  readonly projects?: Maybe<ReadonlyArray<Scalars['UUID']>>;
  readonly status?: Maybe<ReadonlyArray<Scalars['String']>>;
  readonly excludeStatus?: Maybe<ReadonlyArray<Scalars['String']>>;
  readonly includeStatusCounts?: Maybe<Scalars['Boolean']>;
  readonly clientStatus?: Maybe<ReadonlyArray<ActionClientStatus>>;
  readonly fromDate?: Maybe<Scalars['DateImmutable']>;
  readonly toDate?: Maybe<Scalars['DateImmutable']>;
  readonly location?: Maybe<ReadonlyArray<Scalars['String']>>;
  readonly actionType?: Maybe<ReadonlyArray<Scalars['UUID']>>;
  readonly actionPlanner?: Maybe<ReadonlyArray<Scalars['UUID']>>;
  readonly client?: Maybe<ReadonlyArray<Scalars['UUID']>>;
  readonly listType?: Maybe<ActionListType>;
  /**
   * *    Accepts positive number, maximum `1000`.
   * *    Default `1`.
   * *
   */
  readonly page?: Maybe<Scalars['Int']>;
  /**
   * *    Accepts any positive number or zero, maximum `1000`.
   * *    Zero can be used for calculate totals.
   * *    Default `20`.
   * *
   */
  readonly limit?: Maybe<Scalars['Int']>;
  readonly search?: Maybe<Scalars['String']>;
};

export enum ActionsFilterType {
  Project = 'PROJECT',
  Client = 'CLIENT',
  Location = 'LOCATION',
  ActionName = 'ACTION_NAME',
  Status = 'STATUS',
  ActionType = 'ACTION_TYPE',
  ActionPlanner = 'ACTION_PLANNER'
}

export type ActionsPaginator = {
  readonly __typename?: 'ActionsPaginator';
  readonly items: ReadonlyArray<Action>;
  readonly statusCounts: Maybe<ReadonlyArray<ActionStatusCount>>;
  readonly page: Scalars['Int'];
  readonly limit: Scalars['Int'];
  readonly total: Scalars['Int'];
  /**
   * *     Hash of query parameters.
   * *
   */
  readonly hash: Scalars['String'];
  readonly hasMore: Scalars['Boolean'];
};

export type ActionsQueryInput = {
  readonly sort?: Maybe<ReadonlyArray<ActionsSortItem>>;
  readonly uuids?: Maybe<ReadonlyArray<Scalars['UUID']>>;
  readonly projects?: Maybe<ReadonlyArray<Scalars['UUID']>>;
  readonly status?: Maybe<ReadonlyArray<Scalars['String']>>;
  readonly excludeStatus?: Maybe<ReadonlyArray<Scalars['String']>>;
  readonly includeStatusCounts?: Maybe<Scalars['Boolean']>;
  readonly clientStatus?: Maybe<ReadonlyArray<ActionClientStatus>>;
  readonly fromDate?: Maybe<Scalars['DateImmutable']>;
  readonly toDate?: Maybe<Scalars['DateImmutable']>;
  readonly location?: Maybe<ReadonlyArray<Scalars['String']>>;
  readonly actionType?: Maybe<ReadonlyArray<Scalars['UUID']>>;
  readonly actionPlanner?: Maybe<ReadonlyArray<Scalars['UUID']>>;
  readonly client?: Maybe<ReadonlyArray<Scalars['UUID']>>;
  readonly listType?: Maybe<ActionListType>;
  /**
   * *    Accepts positive number, maximum `1000`.
   * *    Default `1`.
   * *
   */
  readonly page?: Maybe<Scalars['Int']>;
  /**
   * *    Accepts any positive number or zero, maximum `1000`.
   * *    Zero can be used for calculate totals.
   * *    Default `20`.
   * *
   */
  readonly limit?: Maybe<Scalars['Int']>;
  readonly search?: Maybe<Scalars['String']>;
};

export type ActionsSortItem = {
  readonly by?: Maybe<ActionsSortType>;
  readonly direction?: Maybe<SortDirection>;
};

export enum ActionsSortType {
  Uuid = 'UUID',
  Name = 'NAME',
  Date = 'DATE',
  Project = 'PROJECT',
  Status = 'STATUS',
  Location = 'LOCATION',
  ActionType = 'ACTION_TYPE',
  ActionPlanner = 'ACTION_PLANNER'
}

export type ActualTotals = {
  readonly __typename?: 'ActualTotals';
  readonly sellPrice: Scalars['Float'];
  readonly costPrice: Scalars['Float'];
};

export type ActualsLine = {
  readonly __typename?: 'ActualsLine';
  readonly type: Scalars['String'];
  readonly bookingYear: Scalars['Int'];
  readonly bookingMonth: Scalars['Int'];
  readonly documentDate: Scalars['DateTimeImmutable'];
  readonly documentReference: Scalars['String'];
  readonly realCost: Scalars['Float'];
  readonly realSell: Scalars['Float'];
  readonly currency: Scalars['String'];
  readonly companyName: Scalars['String'];
  readonly cpReference: Scalars['String'];
  readonly cpDescription: Scalars['String'];
};

export type ActualsQueryInput = {
  readonly projectUUIDs?: Maybe<ReadonlyArray<Scalars['UUID']>>;
};

export type AddCompanyHolidayInput = {
  readonly date: Scalars['DateTimeImmutable'];
  readonly name: Scalars['String'];
};

export type AddLeaveHolidayAssignmentInput = {
  /** UUID of newly created entity. Optional, will be generated if not provided. */
  readonly uuid?: Maybe<Scalars['UUID']>;
  readonly userUUID: Scalars['UUID'];
  readonly leaveHolidayUUID: Scalars['UUID'];
  readonly date?: Maybe<Scalars['DateTimeImmutable']>;
  readonly startTime?: Maybe<Scalars['DateTimeImmutable']>;
  /** Duration in seconds */
  readonly duration?: Maybe<Scalars['Float']>;
};

export type AddProjectTaskAssignmentInput = {
  /** UUID of newly created entity. Optional, will be generated if not provided. */
  readonly uuid?: Maybe<Scalars['UUID']>;
  readonly userUUID: Scalars['UUID'];
  readonly projectTaskUUID: Scalars['UUID'];
  readonly date?: Maybe<Scalars['DateTimeImmutable']>;
  readonly startTime?: Maybe<Scalars['DateTimeImmutable']>;
  /** Duration in seconds */
  readonly duration?: Maybe<Scalars['Float']>;
  readonly note?: Maybe<Scalars['String']>;
  readonly addToProject?: Maybe<Scalars['Boolean']>;
};

export type AddQuantityTypeInput = {
  readonly uuid: Scalars['UUID'];
  readonly name: Scalars['String'];
};

export type AddTimeTrackInput = {
  readonly uuid: Scalars['UUID'];
  readonly projectTaskUUID: Scalars['UUID'];
  readonly date: Scalars['DateTimeImmutable'];
  readonly note?: Maybe<Scalars['String']>;
  readonly trackedSeconds?: Maybe<Scalars['Int']>;
  /**
   * *   If true, then all time entries with type DEFAULT for this date (and for this project task) will be deleted.
   * *
   */
  readonly deleteOthers?: Maybe<Scalars['Boolean']>;
  readonly start?: Maybe<Scalars['Boolean']>;
  readonly type?: Maybe<TimeTrackType>;
  /**
   * *   If true, an assignment will be created automatically for a corresponding user & projectTask
   * *
   */
  readonly autoAssign?: Maybe<Scalars['Boolean']>;
};

export type Age = {
  readonly __typename?: 'Age';
  readonly age: Maybe<Scalars['String']>;
  readonly targetGroup: Maybe<ChannelTargetGroup>;
  readonly uuid: Scalars['UUID'];
  readonly createdAt: Scalars['DateTimeImmutable'];
  readonly updatedAt: Scalars['DateTimeImmutable'];
};

export type AppSettings = {
  readonly __typename?: 'AppSettings';
  readonly lightMode: Scalars['Boolean'];
  readonly cmProjectsListViewSwitcher: Scalars['Boolean'];
  readonly cmBrandActivation: Scalars['Boolean'];
  readonly autoSaveInterval: Scalars['Int'];
  readonly showUninvoicedAmount: Scalars['Boolean'];
  readonly cmShowAgenda: Scalars['Boolean'];
  readonly tcShowMetrics: Scalars['Boolean'];
  readonly showBtDashboard: Scalars['Boolean'];
};

export type Availability = {
  readonly __typename?: 'Availability';
  readonly externalUser: Maybe<ExternalUser>;
  readonly date: Scalars['DateImmutable'];
  readonly from: Scalars['Int'];
  readonly to: Scalars['Int'];
  readonly available: Scalars['Boolean'];
  readonly fromDate: Scalars['DateTimeImmutable'];
  readonly toDate: Scalars['DateTimeImmutable'];
  readonly uuid: Scalars['UUID'];
  readonly createdAt: Scalars['DateTimeImmutable'];
  readonly updatedAt: Scalars['DateTimeImmutable'];
};

export enum AvailabilityStatus {
  Active = 'ACTIVE',
  Blacklist = 'BLACKLIST',
  Inactive = 'INACTIVE',
  Benched = 'BENCHED',
  Out = 'OUT'
}

export type BookingPerson = {
  readonly __typename?: 'BookingPerson';
  readonly lastMovementState: Scalars['String'];
  readonly nextMovementState: Maybe<Scalars['String']>;
  readonly printableContractIds: ReadonlyArray<Scalars['String']>;
  readonly isActionActive: Scalars['Boolean'];
  readonly performance: BookingPersonPerformance;
  readonly status: Scalars['String'];
  readonly externalUser: ExternalUser;
  readonly compositionRole: Maybe<CompositionRole>;
  readonly tcCompositionRole: Maybe<TcCompositionRole>;
  readonly confirmationToken: Maybe<Scalars['String']>;
  readonly eventDistance: Maybe<Distance>;
  readonly warehouseDistance: Maybe<Scalars['Int']>;
  readonly contracts: ReadonlyArray<Maybe<Contract>>;
  readonly rejectReason: Maybe<Scalars['String']>;
  readonly action: Action;
  readonly volunteered: Scalars['Boolean'];
  readonly debriefingAnswers: ReadonlyArray<Maybe<DebriefingAnswer>>;
  readonly movements: ReadonlyArray<Maybe<BookingPersonMovement>>;
  readonly arrivedAtCompany: Maybe<Scalars['DateTimeImmutable']>;
  readonly departedAtCompany: Maybe<Scalars['DateTimeImmutable']>;
  readonly arrivedAtVenue: Maybe<Scalars['DateTimeImmutable']>;
  readonly departedAtVenue: Maybe<Scalars['DateTimeImmutable']>;
  readonly pickUpPerson: Maybe<BookingPerson>;
  readonly dropOffPerson: Maybe<BookingPerson>;
  readonly bookedBy: Maybe<User>;
  readonly bookedDate: Maybe<Scalars['DateTimeImmutable']>;
  readonly bookedDateUTC: Maybe<Scalars['DateTimeImmutable']>;
  readonly startViaCompany: Scalars['Boolean'];
  readonly directToEvent: Scalars['Boolean'];
  readonly startTimeUTC: Maybe<Scalars['DateTimeImmutable']>;
  readonly endTimeUTC: Maybe<Scalars['DateTimeImmutable']>;
  readonly startTime: Maybe<Scalars['DateTimeImmutable']>;
  readonly endTime: Maybe<Scalars['DateTimeImmutable']>;
  readonly uuid: Scalars['UUID'];
  readonly createdAt: Scalars['DateTimeImmutable'];
  readonly updatedAt: Scalars['DateTimeImmutable'];
};

export type BookingPersonLateMovements = {
  readonly __typename?: 'BookingPersonLateMovements';
  readonly count: Scalars['Int'];
  readonly latenessType: Maybe<Scalars['String']>;
};

export type BookingPersonLateMovementsQueryInput = {
  readonly contractId: Scalars['UUID'];
};

export type BookingPersonMovement = {
  readonly __typename?: 'BookingPersonMovement';
  readonly bookingPerson: Maybe<BookingPerson>;
  readonly state: Scalars['String'];
  readonly lat: Maybe<Scalars['Float']>;
  readonly lng: Maybe<Scalars['Float']>;
  readonly companyDistance: Maybe<Distance>;
  readonly date: Scalars['DateTimeImmutable'];
  readonly dateUTC: Scalars['DateTimeImmutable'];
  readonly originalDate: Scalars['DateTimeImmutable'];
  readonly originalDateUTC: Scalars['DateTimeImmutable'];
  readonly movedBy: Maybe<User>;
  readonly createdAt: Scalars['DateTimeImmutable'];
  readonly updatedAt: Scalars['DateTimeImmutable'];
  readonly uuid: Scalars['UUID'];
};

export type BookingPersonMovementInput = {
  readonly uuid: Scalars['UUID'];
  readonly date?: Maybe<Scalars['DateTimeImmutable']>;
  readonly state: BookingPersonMovementState;
  readonly bookingPersonUuid?: Maybe<Scalars['UUID']>;
  readonly lat?: Maybe<Scalars['Float']>;
  readonly lng?: Maybe<Scalars['Float']>;
};

export enum BookingPersonMovementState {
  None = 'NONE',
  Arrived = 'ARRIVED',
  Moved = 'MOVED',
  Departed = 'DEPARTED',
  ArrivedPickup = 'ARRIVED_PICKUP',
  DepartedPickup = 'DEPARTED_PICKUP',
  ArrivedEvent = 'ARRIVED_EVENT',
  DepartedEvent = 'DEPARTED_EVENT',
  ArrivedDropoff = 'ARRIVED_DROPOFF',
  DepartedDropoff = 'DEPARTED_DROPOFF'
}

export type BookingPersonPerformance = {
  readonly __typename?: 'BookingPersonPerformance';
  readonly arrived: Maybe<Scalars['DateTimeImmutable']>;
  readonly departed: Maybe<Scalars['DateTimeImmutable']>;
  readonly comment: Maybe<Scalars['String']>;
  readonly file: Maybe<Scalars['String']>;
  readonly lateArrival: Maybe<Scalars['Boolean']>;
  readonly movements: Maybe<ReadonlyArray<Maybe<BookingPersonMovement>>>;
};

export type BookingPersonPerformanceInput = {
  readonly arrived?: Maybe<Scalars['DateTimeImmutable']>;
  readonly departed?: Maybe<Scalars['DateTimeImmutable']>;
  readonly comment?: Maybe<Scalars['String']>;
  readonly file?: Maybe<Scalars['String']>;
  readonly bookingPersonUuid?: Maybe<Scalars['UUID']>;
  readonly contractUuid?: Maybe<Scalars['UUID']>;
  readonly contractId?: Maybe<Scalars['UUID']>;
};

export type BookingPersonPerformanceQueryInput = {
  readonly bookingPersonUuid?: Maybe<Scalars['UUID']>;
  readonly contractUuid?: Maybe<Scalars['UUID']>;
  readonly contractId?: Maybe<Scalars['UUID']>;
};

export enum BookingPersonsAvailability {
  Available = 'AVAILABLE',
  AvailabilityNotSet = 'AVAILABILITY_NOT_SET',
  NotAvailable = 'NOT_AVAILABLE'
}

export type BookingPersonsPaginator = {
  readonly __typename?: 'BookingPersonsPaginator';
  readonly items: ReadonlyArray<BookingPersonsResultItem>;
  readonly page: Scalars['Int'];
  readonly limit: Scalars['Int'];
  readonly total: Scalars['Int'];
  /**
   * *     Hash of query parameters.
   * *
   */
  readonly hash: Scalars['String'];
  readonly hasMore: Scalars['Boolean'];
};

export type BookingPersonsQueryInput = {
  readonly sort?: Maybe<ReadonlyArray<BookingPersonsSortItem>>;
  readonly uuids?: Maybe<ReadonlyArray<Scalars['UUID']>>;
  readonly actionUuids?: Maybe<ReadonlyArray<Scalars['UUID']>>;
  readonly bookable?: Maybe<Scalars['Boolean']>;
  readonly volunteered?: Maybe<Scalars['Boolean']>;
  readonly treatCompletedActionAsBookable?: Maybe<Scalars['Boolean']>;
  readonly availabilities?: Maybe<ReadonlyArray<BookingPersonsAvailability>>;
  readonly languageCodes?: Maybe<ReadonlyArray<LanguageCode>>;
  readonly minimalKnowledge?: Maybe<KnowledgeLevel>;
  readonly preferredLanguage?: Maybe<ReadonlyArray<LanguageCode>>;
  readonly drivingLicenses?: Maybe<ReadonlyArray<ExternalUsersDrivingLicense>>;
  readonly tagsUuids?: Maybe<ReadonlyArray<Scalars['UUID']>>;
  /**
   * *     Accepts natural number.
   * *
   */
  readonly companyDistanceFrom?: Maybe<Scalars['Int']>;
  /**
   * *     Accepts natural number.
   * *
   */
  readonly companyDistanceTo?: Maybe<Scalars['Int']>;
  /**
   * *     Accepts natural number.
   * *
   */
  readonly eventDistanceFrom?: Maybe<Scalars['Int']>;
  /**
   * *     Accepts natural number.
   * *
   */
  readonly eventDistanceTo?: Maybe<Scalars['Int']>;
  readonly ownTransport?: Maybe<Scalars['Boolean']>;
  readonly studentWorkdaysFrom?: Maybe<Scalars['Int']>;
  readonly studentWorkdaysTo?: Maybe<Scalars['Int']>;
  readonly professionalStatuses?: Maybe<ReadonlyArray<ProfessionalStatusForPointHr>>;
  readonly degree?: Maybe<ReadonlyArray<Degree>>;
  readonly weightFrom?: Maybe<Scalars['Float']>;
  readonly weightTo?: Maybe<Scalars['Float']>;
  readonly heightFrom?: Maybe<Scalars['Float']>;
  readonly heightTo?: Maybe<Scalars['Float']>;
  readonly BMIFrom?: Maybe<Scalars['Float']>;
  readonly BMITo?: Maybe<Scalars['Float']>;
  /**
   * *    Accepts positive number, maximum `1000`.
   * *    Default `1`.
   * *
   */
  readonly page?: Maybe<Scalars['Int']>;
  /**
   * *    Accepts any positive number or zero, maximum `1000`.
   * *    Zero can be used for calculate totals.
   * *    Default `20`.
   * *
   */
  readonly limit?: Maybe<Scalars['Int']>;
  readonly search?: Maybe<Scalars['String']>;
};

export type BookingPersonsResultItem = {
  readonly __typename?: 'BookingPersonsResultItem';
  readonly bookingPerson: BookingPerson;
  readonly viaCompanyDistance: Scalars['Float'];
};

export type BookingPersonsSortItem = {
  readonly by?: Maybe<BookingPersonsSortType>;
  readonly direction?: Maybe<SortDirection>;
};

export enum BookingPersonsSortType {
  CompanyDistance = 'COMPANY_DISTANCE',
  FirstName = 'FIRST_NAME',
  LastName = 'LAST_NAME'
}

export type BookingPersonsStat = {
  readonly __typename?: 'BookingPersonsStat';
  readonly studentWorkdaysMin: Scalars['Int'];
  readonly studentWorkdaysMax: Scalars['Int'];
  readonly weightMin: Scalars['Float'];
  readonly weightMax: Scalars['Float'];
  readonly heightMin: Scalars['Float'];
  readonly heightMax: Scalars['Float'];
  readonly BMIMin: Scalars['Float'];
  readonly BMIMax: Scalars['Float'];
};

export type Brand = {
  readonly __typename?: 'Brand';
  readonly name: Scalars['String'];
  readonly projects: ReadonlyArray<Maybe<Project>>;
  readonly company: Maybe<Company>;
  readonly client: Maybe<Client>;
  readonly createdAt: Scalars['DateTimeImmutable'];
  readonly updatedAt: Scalars['DateTimeImmutable'];
  readonly uuid: Scalars['UUID'];
};

export type Briefing = {
  readonly __typename?: 'Briefing';
  readonly kind: Maybe<Scalars['String']>;
  readonly text: Maybe<Scalars['String']>;
  readonly name: Maybe<Scalars['String']>;
  readonly project: Project;
  readonly files: ReadonlyArray<Maybe<File>>;
  readonly createdAt: Scalars['DateTimeImmutable'];
  readonly updatedAt: Scalars['DateTimeImmutable'];
  readonly uuid: Scalars['UUID'];
};

export type BriefingInfoSettings = {
  readonly __typename?: 'BriefingInfoSettings';
  readonly budget: Maybe<Scalars['Int']>;
  readonly rateSheet: Maybe<Ratesheet>;
  readonly totalContacts: Maybe<Scalars['Int']>;
  readonly targetContacts: Maybe<Scalars['Int']>;
  readonly project: Project;
  readonly budgetSplits: ReadonlyArray<Maybe<BudgetSplit>>;
  readonly channelTargetGroups: ReadonlyArray<Maybe<ChannelTargetGroup>>;
  readonly productType: Maybe<ProductType>;
  readonly createdAt: Scalars['DateTimeImmutable'];
  readonly updatedAt: Scalars['DateTimeImmutable'];
  readonly uuid: Scalars['UUID'];
};

export type BudgetSplit = {
  readonly __typename?: 'BudgetSplit';
  readonly name: Maybe<Scalars['String']>;
  readonly amount: Maybe<Scalars['Int']>;
  readonly percent: Maybe<Scalars['Int']>;
  readonly briefingInfoSetting: Maybe<BriefingInfoSettings>;
  readonly type: Maybe<Scalars['String']>;
  readonly ratesheet: Maybe<Ratesheet>;
  readonly createdAt: Scalars['DateTimeImmutable'];
  readonly updatedAt: Scalars['DateTimeImmutable'];
  readonly uuid: Scalars['UUID'];
};

export type Cpo = {
  readonly __typename?: 'CPO';
  readonly project: Maybe<Project>;
  readonly amount: Scalars['Float'];
  readonly plannedInvoicingPeriod: Scalars['DateImmutable'];
  readonly remark: Maybe<Scalars['String']>;
  readonly status: Scalars['String'];
  readonly cpo: Maybe<Scalars['String']>;
  readonly createdAt: Scalars['DateTimeImmutable'];
  readonly updatedAt: Scalars['DateTimeImmutable'];
  readonly uuid: Scalars['UUID'];
};

export type Channel = {
  readonly __typename?: 'Channel';
  readonly name: Scalars['String'];
  readonly contactsPerAction: Scalars['Int'];
  readonly teamCost: Scalars['Int'];
  readonly extraCost: Scalars['Int'];
  readonly actionTeams: ReadonlyArray<Maybe<ActionTeam>>;
  readonly statistics: ChannelStatistics;
  readonly matches: ReadonlyArray<Maybe<ChannelMatch>>;
  readonly channelGroup: Maybe<ChannelGroup>;
  readonly channelSelectors: ReadonlyArray<Maybe<ChannelSelector>>;
  readonly uuid: Scalars['UUID'];
  readonly createdAt: Scalars['DateTimeImmutable'];
  readonly updatedAt: Scalars['DateTimeImmutable'];
};

export type ChannelCalculationResult = {
  readonly __typename?: 'ChannelCalculationResult';
  readonly actionTeam: Maybe<ActionTeam>;
  readonly totalBudget: Maybe<Scalars['Int']>;
  readonly reachBudget: Maybe<Scalars['Int']>;
  readonly percentageBudget: Maybe<Scalars['Int']>;
  readonly createdAt: Scalars['DateTimeImmutable'];
  readonly updatedAt: Scalars['DateTimeImmutable'];
  readonly uuid: Scalars['UUID'];
};

export type ChannelGroup = {
  readonly __typename?: 'ChannelGroup';
  readonly name: Maybe<Scalars['String']>;
  readonly channels: ReadonlyArray<Maybe<Channel>>;
  readonly channelGroupSelectors: ReadonlyArray<Maybe<ChannelGroupSelector>>;
  readonly uuid: Scalars['UUID'];
  readonly createdAt: Scalars['DateTimeImmutable'];
  readonly updatedAt: Scalars['DateTimeImmutable'];
};

export type ChannelGroupSelector = {
  readonly __typename?: 'ChannelGroupSelector';
  readonly project: Maybe<Project>;
  readonly isSelected: Maybe<Scalars['Boolean']>;
  readonly channelGroup: Maybe<ChannelGroup>;
  readonly position: Maybe<Scalars['Int']>;
  readonly uuid: Scalars['UUID'];
  readonly createdAt: Scalars['DateTimeImmutable'];
  readonly updatedAt: Scalars['DateTimeImmutable'];
};

export type ChannelMatch = {
  readonly __typename?: 'ChannelMatch';
  readonly match: Maybe<Scalars['Float']>;
  readonly channel: Maybe<Channel>;
  readonly project: Maybe<Project>;
  readonly uuid: Scalars['UUID'];
  readonly createdAt: Scalars['DateTimeImmutable'];
  readonly updatedAt: Scalars['DateTimeImmutable'];
};

export type ChannelSelector = {
  readonly __typename?: 'ChannelSelector';
  readonly isSelected: Maybe<Scalars['Boolean']>;
  readonly project: Maybe<Project>;
  readonly channel: Maybe<Channel>;
  readonly actions: Maybe<Scalars['Int']>;
  readonly budgetItems: ReadonlyArray<Maybe<FeesBudgetItem>>;
  readonly contactsPerAction: Scalars['Int'];
  readonly uuid: Scalars['UUID'];
  readonly createdAt: Scalars['DateTimeImmutable'];
  readonly updatedAt: Scalars['DateTimeImmutable'];
};

export type ChannelStatistics = {
  readonly __typename?: 'ChannelStatistics';
  readonly channel: Channel;
  readonly male: Scalars['Float'];
  readonly female: Scalars['Float'];
  readonly years1214: Scalars['Float'];
  readonly years1524: Scalars['Float'];
  readonly years2534: Scalars['Float'];
  readonly years3544: Scalars['Float'];
  readonly years4554: Scalars['Float'];
  readonly years5564: Scalars['Float'];
  readonly years65: Scalars['Float'];
  readonly uuid: Scalars['UUID'];
  readonly createdAt: Scalars['DateTimeImmutable'];
  readonly updatedAt: Scalars['DateTimeImmutable'];
};

export type ChannelTargetGroup = {
  readonly __typename?: 'ChannelTargetGroup';
  readonly ages: ReadonlyArray<Maybe<Age>>;
  readonly name: Maybe<Scalars['String']>;
  readonly briefingSetting: Maybe<BriefingInfoSettings>;
  readonly genders: ReadonlyArray<Maybe<TargetGroupsGender>>;
  readonly createdAt: Scalars['DateTimeImmutable'];
  readonly updatedAt: Scalars['DateTimeImmutable'];
  readonly uuid: Scalars['UUID'];
};

export type Client = {
  readonly __typename?: 'Client';
  readonly resolvedLogo: Maybe<Scalars['String']>;
  readonly name: Scalars['String'];
  readonly btwVat: Maybe<Scalars['String']>;
  readonly logo: Maybe<Scalars['String']>;
  readonly zip: Maybe<Scalars['String']>;
  readonly country: Maybe<GeoCountry>;
  readonly city: Maybe<GeoCity>;
  readonly language: Maybe<Scalars['String']>;
  readonly address: Maybe<Scalars['String']>;
  readonly address2: Maybe<Scalars['String']>;
  readonly company: Company;
  readonly category: Maybe<CompanyCategory>;
  readonly currency: Maybe<Currency>;
  readonly phones: ReadonlyArray<Maybe<ClientPhone>>;
  readonly emails: ReadonlyArray<Maybe<ClientEmail>>;
  readonly projects: ReadonlyArray<Maybe<Project>>;
  readonly generalProjects: ReadonlyArray<Maybe<GeneralProject>>;
  readonly bankAccount: Maybe<Scalars['String']>;
  readonly bic: Maybe<Scalars['String']>;
  readonly status: Scalars['String'];
  readonly timezone: Maybe<Timezone>;
  readonly estimates: ReadonlyArray<Maybe<Estimate>>;
  readonly invoices: ReadonlyArray<Maybe<Invoice>>;
  readonly contactClientRoles: ReadonlyArray<Maybe<ContactClientRole>>;
  readonly isLinkedToBookkeeping: Scalars['Boolean'];
  readonly moreInfo: Maybe<Scalars['String']>;
  readonly partyId: Maybe<Scalars['UUID']>;
  readonly defaultDueDateType: Maybe<Scalars['String']>;
  readonly ratesheets: ReadonlyArray<Maybe<Ratesheet>>;
  readonly clientUsers: ReadonlyArray<Maybe<ClientUser>>;
  readonly createdAt: Scalars['DateTimeImmutable'];
  readonly updatedAt: Scalars['DateTimeImmutable'];
  readonly uuid: Scalars['UUID'];
};

export type ClientEmail = {
  readonly __typename?: 'ClientEmail';
  readonly client: Maybe<Client>;
  readonly label: Maybe<Scalars['String']>;
  readonly email: Scalars['String'];
  readonly createdAt: Scalars['DateTimeImmutable'];
  readonly updatedAt: Scalars['DateTimeImmutable'];
  readonly uuid: Scalars['UUID'];
};

export type ClientPaginator = {
  readonly __typename?: 'ClientPaginator';
  readonly items: ReadonlyArray<Client>;
  readonly page: Scalars['Int'];
  readonly limit: Scalars['Int'];
  readonly total: Scalars['Int'];
  /**
   * *     Hash of query parameters.
   * *
   */
  readonly hash: Scalars['String'];
  readonly hasMore: Scalars['Boolean'];
};

export type ClientPhone = {
  readonly __typename?: 'ClientPhone';
  readonly client: Maybe<Client>;
  readonly label: Maybe<Scalars['String']>;
  readonly number: Scalars['String'];
  readonly createdAt: Scalars['DateTimeImmutable'];
  readonly updatedAt: Scalars['DateTimeImmutable'];
  readonly uuid: Scalars['UUID'];
};

export type ClientQueryInput = {
  readonly sort?: Maybe<ReadonlyArray<ClientSortItem>>;
  readonly forClientUser?: Maybe<Scalars['Boolean']>;
  /**
   * *    Accepts positive number, maximum `1000`.
   * *    Default `1`.
   * *
   */
  readonly page?: Maybe<Scalars['Int']>;
  /**
   * *    Accepts any positive number or zero, maximum `1000`.
   * *    Zero can be used for calculate totals.
   * *    Default `20`.
   * *
   */
  readonly limit?: Maybe<Scalars['Int']>;
  readonly search?: Maybe<Scalars['String']>;
  readonly UUIDs?: Maybe<ReadonlyArray<Scalars['UUID']>>;
  readonly excludeUUIDs?: Maybe<ReadonlyArray<Scalars['UUID']>>;
};

export type ClientSortItem = {
  readonly by?: Maybe<ClientSortType>;
  readonly direction?: Maybe<SortDirection>;
};

export enum ClientSortType {
  Name = 'NAME',
  CreatedAt = 'CREATED_AT'
}

export type ClientUser = {
  readonly __typename?: 'ClientUser';
  readonly client: Maybe<Client>;
  readonly user: Maybe<User>;
  readonly roles: ReadonlyArray<Maybe<Role>>;
  readonly createdAt: Scalars['DateTimeImmutable'];
  readonly updatedAt: Scalars['DateTimeImmutable'];
  readonly uuid: Scalars['UUID'];
};

export type Company = {
  readonly __typename?: 'Company';
  readonly name: Scalars['String'];
  readonly status: Maybe<Scalars['String']>;
  readonly companyGroup: Maybe<Scalars['String']>;
  readonly webAddress: Maybe<Scalars['String']>;
  readonly subDomain: Maybe<Scalars['String']>;
  readonly alternativeName: Maybe<Scalars['String']>;
  readonly emails: Maybe<ReadonlyArray<CompanyEmail>>;
  readonly phones: Maybe<ReadonlyArray<CompanyPhone>>;
  readonly logo: Maybe<Scalars['String']>;
  readonly brandColor: Maybe<Scalars['String']>;
  readonly isMain: Maybe<Scalars['Boolean']>;
  readonly billingAddress: Maybe<Scalars['String']>;
  readonly billingAddressFull: Maybe<Scalars['String']>;
  readonly state: Maybe<Scalars['String']>;
  readonly zip: Maybe<Scalars['String']>;
  readonly btwVat: Maybe<Scalars['String']>;
  readonly currencyFormat: Maybe<Scalars['String']>;
  readonly numberFormat: Maybe<Scalars['String']>;
  readonly fiscalYear: Maybe<Scalars['String']>;
  readonly timeFormat: Maybe<Scalars['String']>;
  readonly timeDisplay: Maybe<Scalars['String']>;
  readonly startWeek: Maybe<Scalars['String']>;
  readonly timerMode: Maybe<Scalars['String']>;
  readonly timerRounding: Maybe<Scalars['String']>;
  readonly users: Maybe<ReadonlyArray<User>>;
  readonly mainAccount: Maybe<User>;
  readonly defaultReviewer: Maybe<User>;
  readonly currency: Maybe<Currency>;
  readonly expenses: ReadonlyArray<Maybe<Expense>>;
  readonly expenseGroups: ReadonlyArray<Maybe<ExpenseGroup>>;
  readonly clients: ReadonlyArray<Maybe<Client>>;
  readonly tasks: ReadonlyArray<Maybe<Task>>;
  readonly taskGroups: ReadonlyArray<Maybe<TaskGroup>>;
  readonly fees: ReadonlyArray<Maybe<Fee>>;
  readonly teamTypes: ReadonlyArray<Maybe<TeamCostTeamType>>;
  readonly transports: ReadonlyArray<Maybe<DictionaryTransport>>;
  readonly feeGroups: ReadonlyArray<Maybe<FeeGroup>>;
  readonly projectGroups: ReadonlyArray<Maybe<ProjectGroup>>;
  readonly projects: ReadonlyArray<Maybe<Project>>;
  readonly generalProjects: ReadonlyArray<Maybe<GeneralProject>>;
  readonly contacts: ReadonlyArray<Maybe<Contact>>;
  readonly contracts: ReadonlyArray<Maybe<Contract>>;
  readonly plan: Maybe<Plan>;
  readonly categories: Maybe<ReadonlyArray<CompanyCategory>>;
  readonly userQty: Maybe<Scalars['Int']>;
  readonly legalAddress: Maybe<Scalars['String']>;
  readonly legalAddressFull: Maybe<Scalars['String']>;
  readonly legalCity: Maybe<GeoCity>;
  readonly legalState: Maybe<Scalars['String']>;
  readonly legalLocation: Maybe<CompanyLegalLocation>;
  readonly legalCountry: Maybe<GeoCountry>;
  readonly legalZip: Maybe<Scalars['String']>;
  readonly useLegalAddressForBilling: Maybe<Scalars['Boolean']>;
  readonly dateFormat: Maybe<Scalars['String']>;
  readonly roleUnits: ReadonlyArray<Maybe<RoleUnit>>;
  readonly timezone: Maybe<Timezone>;
  readonly externalUsers: ReadonlyArray<Maybe<ExternalUser>>;
  readonly country: Maybe<GeoCountry>;
  readonly city: Maybe<GeoCity>;
  readonly roles: ReadonlyArray<Maybe<Role>>;
  readonly fax: Maybe<Scalars['Int']>;
  readonly accountNumber: Maybe<Scalars['Int']>;
  readonly attentiaCompanyNumber: Maybe<Scalars['Int']>;
  readonly legalRemarksForEstimates: Maybe<Scalars['String']>;
  readonly legalRemarksForInvoices: Maybe<Scalars['String']>;
  readonly legalRemarksForSPOs: Maybe<Scalars['String']>;
  readonly RPRLocation: Maybe<Scalars['String']>;
  readonly iban: Maybe<Scalars['String']>;
  readonly bic: Maybe<Scalars['String']>;
  readonly signature: Maybe<Scalars['String']>;
  readonly initials: Maybe<Scalars['String']>;
  readonly financeId: Maybe<Scalars['String']>;
  readonly bookkeepingApiUrl: Maybe<Scalars['String']>;
  readonly bookkeepingUsername: Maybe<Scalars['String']>;
  readonly bookkeepingPassword: Maybe<Scalars['String']>;
  readonly plannerEmailEnabled: Maybe<Scalars['Boolean']>;
  readonly plannerEmailFrom: Maybe<Scalars['String']>;
  readonly plannerMailerDsn: Maybe<Scalars['String']>;
  readonly exactOnline: Maybe<Scalars['Boolean']>;
  readonly moreInfo: Maybe<Scalars['String']>;
  readonly defaultTaxRate: Maybe<TaxRate>;
  readonly defaultTeamCostViaCompany: Maybe<TeamCostViaCompany>;
  readonly representative: Maybe<Scalars['String']>;
  readonly language: Maybe<Scalars['String']>;
  readonly hourlyCostSource: Maybe<Scalars['String']>;
  readonly brands: ReadonlyArray<Maybe<Brand>>;
  readonly priceMode: Maybe<Scalars['String']>;
  readonly cpoReceivedEnabled: Maybe<Scalars['Boolean']>;
  readonly timeTrackingRequiresEstimate: Maybe<Scalars['Boolean']>;
  readonly defaultInvoiceItemType: Maybe<Scalars['String']>;
  readonly canCreateClientWithoutVat: Maybe<Scalars['Boolean']>;
  readonly btRequiredForValidatedEstimates: Maybe<Scalars['Boolean']>;
  readonly spoExpensesFromEstimatesOnly: Maybe<Scalars['Boolean']>;
  readonly showMarginsOnEstimatePreview: Maybe<Scalars['Boolean']>;
  readonly includeEstimateInInvoiceRequestPdf: Maybe<Scalars['Boolean']>;
  readonly requiredMinimumMargin: Maybe<Scalars['Int']>;
  readonly requiredMargin: Maybe<Scalars['Int']>;
  readonly allowSingleItems: Maybe<Scalars['Boolean']>;
  readonly useLegacyContractPdfTemplates: Maybe<Scalars['Boolean']>;
  readonly defaultNormalHours: Maybe<Scalars['DateTimeImmutable']>;
  readonly enableInvoiceTotalsAudit: Maybe<Scalars['Boolean']>;
  readonly pointhrUuid: Maybe<Scalars['String']>;
  readonly pointhrApiKey: Maybe<Scalars['String']>;
  readonly pointhrPassKey: Maybe<Scalars['String']>;
  readonly nssoNumber: Maybe<Scalars['String']>;
  readonly hotlineNumber: Maybe<Scalars['String']>;
  readonly pointhrEnabled: Maybe<Scalars['Boolean']>;
  readonly pointhrApiUrl: Maybe<Scalars['String']>;
  readonly children: ReadonlyArray<Maybe<Company>>;
  readonly isParent: Maybe<Scalars['Boolean']>;
  readonly contractTariffBase: ContractTariffBase;
  readonly createdAt: Scalars['DateTimeImmutable'];
  readonly updatedAt: Scalars['DateTimeImmutable'];
  readonly uuid: Scalars['UUID'];
};

export type CompanyCategory = {
  readonly __typename?: 'CompanyCategory';
  readonly name: Scalars['String'];
  readonly clients: ReadonlyArray<Maybe<Client>>;
  readonly suppliers: ReadonlyArray<Maybe<Supplier>>;
  readonly company: Company;
  readonly type: Scalars['String'];
  readonly createdAt: Scalars['DateTimeImmutable'];
  readonly updatedAt: Scalars['DateTimeImmutable'];
  readonly uuid: Scalars['UUID'];
};

export type CompanyEmail = {
  readonly __typename?: 'CompanyEmail';
  readonly company: Maybe<Company>;
  readonly label: Maybe<Scalars['String']>;
  readonly email: Scalars['String'];
  readonly createdAt: Scalars['DateTimeImmutable'];
  readonly updatedAt: Scalars['DateTimeImmutable'];
  readonly uuid: Scalars['UUID'];
};

export type CompanyHoliday = {
  readonly __typename?: 'CompanyHoliday';
  readonly date: Scalars['DateImmutable'];
  readonly name: Scalars['String'];
  readonly uuid: Scalars['UUID'];
  readonly createdAt: Scalars['DateTimeImmutable'];
  readonly updatedAt: Scalars['DateTimeImmutable'];
};

export type CompanyLegalLocation = {
  readonly __typename?: 'CompanyLegalLocation';
  readonly cityName: Maybe<Scalars['String']>;
  readonly company: Company;
  readonly name: Maybe<Scalars['String']>;
  readonly address: Maybe<Scalars['String']>;
  readonly lat: Maybe<Scalars['Float']>;
  readonly lng: Maybe<Scalars['Float']>;
  readonly rawDataType: Scalars['String'];
  readonly rawData: Scalars['JSON'];
  readonly uuid: Scalars['UUID'];
  readonly createdAt: Scalars['DateTimeImmutable'];
  readonly updatedAt: Scalars['DateTimeImmutable'];
};

export type CompanyPayrollCodeItem = {
  readonly __typename?: 'CompanyPayrollCodeItem';
  readonly key: Scalars['String'];
  readonly value: Scalars['String'];
  readonly defaultValue: Scalars['String'];
  readonly isCustom: Scalars['Boolean'];
  readonly description: Scalars['String'];
};

export type CompanyPayrollRule = {
  readonly __typename?: 'CompanyPayrollRule';
  readonly jointCommittee: TeamCostJointCommittee;
  readonly externalJcCode: Maybe<Scalars['String']>;
  readonly functionCategoryCode: Maybe<Scalars['String']>;
  readonly functionDescription: Maybe<Scalars['String']>;
  readonly contractType: Maybe<Scalars['String']>;
  readonly overtimeRatePercentage: Scalars['Int'];
  readonly saturdayOvertimeCode: Maybe<Scalars['String']>;
  readonly saturdayOvertimeRatePercentage: Maybe<Scalars['Int']>;
  readonly sundayOvertimeCode: Maybe<Scalars['String']>;
  readonly sundayOvertimeRatePercentage: Maybe<Scalars['Int']>;
  readonly holidayRatePercentage: Scalars['Int'];
  readonly daysPerWeek: Scalars['Int'];
  readonly hoursPerWeek: Scalars['Int'];
  readonly uuid: Scalars['UUID'];
  readonly createdAt: Scalars['DateTimeImmutable'];
  readonly updatedAt: Scalars['DateTimeImmutable'];
};

export type CompanyPhone = {
  readonly __typename?: 'CompanyPhone';
  readonly company: Maybe<Company>;
  readonly label: Maybe<Scalars['String']>;
  readonly number: Scalars['String'];
  readonly createdAt: Scalars['DateTimeImmutable'];
  readonly updatedAt: Scalars['DateTimeImmutable'];
  readonly uuid: Scalars['UUID'];
};

export type CompositionRole = {
  readonly __typename?: 'CompositionRole';
  readonly ratesheet: Maybe<Ratesheet>;
  readonly defaultCostPricePerHour: Maybe<Scalars['Int']>;
  readonly defaultSellPricePerHour: Maybe<Scalars['Int']>;
  readonly costPricePerHour: Maybe<Scalars['Int']>;
  readonly sellPricePerHour: Maybe<Scalars['Int']>;
  readonly overtimeCostPricePerHour: Maybe<Scalars['Int']>;
  readonly overtimeSellPricePerHour: Maybe<Scalars['Int']>;
  readonly transportCostPricePerDistanceUnit: Maybe<Scalars['Int']>;
  readonly transportSellPricePerDistanceUnit: Maybe<Scalars['Int']>;
  readonly transportDistance: Maybe<Scalars['Float']>;
  readonly planningCostPrice: Maybe<Scalars['Int']>;
  readonly planningSellPrice: Maybe<Scalars['Int']>;
  readonly mealAllowanceCostPrice: Maybe<Scalars['Int']>;
  readonly mealAllowanceSellPrice: Maybe<Scalars['Int']>;
  readonly dryCleaningCostPrice: Maybe<Scalars['Int']>;
  readonly dryCleaningSellPrice: Maybe<Scalars['Int']>;
  readonly normalRatePercentage: Scalars['Int'];
  readonly overtimeRatePercentage: Scalars['Int'];
  readonly actionTeam: Maybe<ActionTeam>;
  readonly scheduleStartLocation: Maybe<ScheduleStartLocation>;
  readonly quantity: Maybe<Scalars['Int']>;
  readonly amount: Maybe<Scalars['Int']>;
  readonly roleName: Scalars['String'];
  readonly holidayHourCostPrice: Maybe<Scalars['Int']>;
  readonly holidayHourSellPrice: Maybe<Scalars['Int']>;
  readonly holidayOvertimeCostPrice: Maybe<Scalars['Int']>;
  readonly holidayOvertimeSellPrice: Maybe<Scalars['Int']>;
  readonly costPrice: Maybe<Scalars['Int']>;
  readonly sellPrice: Maybe<Scalars['Int']>;
  readonly defaultCostPerHourUnitPrice: Maybe<Scalars['Int']>;
  readonly defaultCostPerHourBillablePrice: Maybe<Scalars['Int']>;
  readonly hourPricePercentage: Maybe<Scalars['Int']>;
  readonly hourPriceUnitPrice: Maybe<Scalars['Int']>;
  readonly hourPriceBillablePrice: Maybe<Scalars['Int']>;
  readonly overtimePricePercentage: Maybe<Scalars['Int']>;
  readonly overtimePriceUnitPrice: Maybe<Scalars['Int']>;
  readonly overtimePriceBillablePrice: Maybe<Scalars['Int']>;
  readonly holidayHourPricePercentage: Maybe<Scalars['Int']>;
  readonly holidayHourPriceUnitPrice: Maybe<Scalars['Int']>;
  readonly holidayHourPriceBillablePrice: Maybe<Scalars['Int']>;
  readonly holidayOvertimePricePercentage: Maybe<Scalars['Int']>;
  readonly holidayOvertimePriceUnitPrice: Maybe<Scalars['Int']>;
  readonly holidayOvertimePriceBillablePrice: Maybe<Scalars['Int']>;
  readonly distancePricePerKmUnitPrice: Maybe<Scalars['Int']>;
  readonly distancePricePerKmBillablePrice: Maybe<Scalars['Int']>;
  readonly ownCarViaUnitPrice: Maybe<Scalars['Int']>;
  readonly ownCarViaBillablePrice: Maybe<Scalars['Int']>;
  readonly ownCarDirectUnitPrice: Maybe<Scalars['Int']>;
  readonly ownCarDirectBillablePrice: Maybe<Scalars['Int']>;
  readonly distance: Maybe<Scalars['Float']>;
  readonly bookingPersons: ReadonlyArray<Maybe<BookingPerson>>;
  readonly fullness: Scalars['Int'];
  readonly actionTeamRole: Maybe<ActionTeamRole>;
  readonly parent: Maybe<CompositionRole>;
  readonly children: ReadonlyArray<Maybe<CompositionRole>>;
  readonly dataSource: Maybe<Scalars['String']>;
  readonly contracts: ReadonlyArray<Maybe<Contract>>;
  readonly createdAt: Scalars['DateTimeImmutable'];
  readonly updatedAt: Scalars['DateTimeImmutable'];
  readonly uuid: Scalars['UUID'];
};

export type Contact = {
  readonly __typename?: 'Contact';
  readonly firstName: Maybe<Scalars['String']>;
  readonly lastName: Maybe<Scalars['String']>;
  readonly birthDate: Maybe<Scalars['DateImmutable']>;
  readonly contactPhotoFilename: Maybe<Scalars['String']>;
  readonly phones: ReadonlyArray<Maybe<ContactPhone>>;
  readonly emails: ReadonlyArray<Maybe<ContactEmail>>;
  readonly status: Scalars['String'];
  readonly clientRoles: ReadonlyArray<Maybe<ContactClientRole>>;
  readonly supplierRoles: ReadonlyArray<Maybe<ContactSupplierRole>>;
  readonly contactLocations: ReadonlyArray<Maybe<ContactLocation>>;
  readonly user: Maybe<User>;
  readonly createdAt: Scalars['DateTimeImmutable'];
  readonly updatedAt: Scalars['DateTimeImmutable'];
  readonly uuid: Scalars['UUID'];
};

export type ContactClientRole = {
  readonly __typename?: 'ContactClientRole';
  readonly roleLabel: Maybe<Scalars['String']>;
  readonly contact: Maybe<Contact>;
  readonly client: Maybe<Client>;
  readonly actions: ReadonlyArray<Maybe<Action>>;
  readonly uuid: Scalars['UUID'];
  readonly createdAt: Scalars['DateTimeImmutable'];
  readonly updatedAt: Scalars['DateTimeImmutable'];
};

export type ContactClientRolesPaginator = {
  readonly __typename?: 'ContactClientRolesPaginator';
  readonly items: ReadonlyArray<ContactClientRole>;
  readonly page: Scalars['Int'];
  readonly limit: Scalars['Int'];
  readonly total: Scalars['Int'];
  /**
   * *     Hash of query parameters.
   * *
   */
  readonly hash: Scalars['String'];
  readonly hasMore: Scalars['Boolean'];
};

export type ContactClientRolesQueryInput = {
  readonly sort?: Maybe<ReadonlyArray<ContactClientRolesSortItem>>;
  readonly client?: Maybe<Scalars['UUID']>;
  readonly address?: Maybe<Scalars['String']>;
  /**
   * *    Accepts positive number, maximum `1000`.
   * *    Default `1`.
   * *
   */
  readonly page?: Maybe<Scalars['Int']>;
  /**
   * *    Accepts any positive number or zero, maximum `1000`.
   * *    Zero can be used for calculate totals.
   * *    Default `20`.
   * *
   */
  readonly limit?: Maybe<Scalars['Int']>;
  readonly search?: Maybe<Scalars['String']>;
  readonly UUIDs?: Maybe<ReadonlyArray<Scalars['UUID']>>;
  readonly excludeUUIDs?: Maybe<ReadonlyArray<Scalars['UUID']>>;
};

export type ContactClientRolesSortItem = {
  readonly by?: Maybe<ContactClientRolesSortType>;
  readonly direction?: Maybe<SortDirection>;
};

export enum ContactClientRolesSortType {
  LastName = 'LAST_NAME'
}

export type ContactEmail = {
  readonly __typename?: 'ContactEmail';
  readonly contact: Maybe<Contact>;
  readonly label: Maybe<Scalars['String']>;
  readonly email: Scalars['String'];
  readonly createdAt: Scalars['DateTimeImmutable'];
  readonly updatedAt: Scalars['DateTimeImmutable'];
  readonly uuid: Scalars['UUID'];
};

export type ContactLocation = {
  readonly __typename?: 'ContactLocation';
  readonly cityName: Maybe<Scalars['String']>;
  readonly contact: Maybe<Contact>;
  readonly name: Maybe<Scalars['String']>;
  readonly address: Maybe<Scalars['String']>;
  readonly lat: Maybe<Scalars['Float']>;
  readonly lng: Maybe<Scalars['Float']>;
  readonly rawDataType: Scalars['String'];
  readonly rawData: Scalars['JSON'];
  readonly uuid: Scalars['UUID'];
  readonly createdAt: Scalars['DateTimeImmutable'];
  readonly updatedAt: Scalars['DateTimeImmutable'];
};

export type ContactPhone = {
  readonly __typename?: 'ContactPhone';
  readonly contact: Maybe<Contact>;
  readonly label: Maybe<Scalars['String']>;
  readonly number: Scalars['String'];
  readonly createdAt: Scalars['DateTimeImmutable'];
  readonly updatedAt: Scalars['DateTimeImmutable'];
  readonly uuid: Scalars['UUID'];
};

export type ContactSupplierRole = {
  readonly __typename?: 'ContactSupplierRole';
  readonly roleLabel: Scalars['String'];
  readonly contact: Maybe<Contact>;
  readonly supplier: Maybe<Supplier>;
  readonly uuid: Scalars['UUID'];
  readonly createdAt: Scalars['DateTimeImmutable'];
  readonly updatedAt: Scalars['DateTimeImmutable'];
};

export type Contract = {
  readonly __typename?: 'Contract';
  readonly status: Maybe<ContractStatus>;
  readonly type: Scalars['String'];
  readonly tariff: Scalars['Int'];
  readonly costPrice: Scalars['Int'];
  readonly studentHours: Maybe<Scalars['Int']>;
  readonly contractArt13: Maybe<Scalars['String']>;
  readonly action: Maybe<Action>;
  readonly bookingPerson: Maybe<BookingPerson>;
  readonly externalUser: Maybe<ExternalUser>;
  readonly actionTeam: Maybe<ActionTeam>;
  readonly project: Maybe<Project>;
  readonly overtimeHours: Scalars['Int'];
  readonly normalHours: Scalars['Int'];
  readonly holidayHours: Scalars['Int'];
  readonly realBreakHours: Scalars['Int'];
  readonly holidayOvertimeHours: Scalars['Int'];
  readonly realSchedules: ReadonlyArray<Maybe<ContractRealSchedule>>;
  readonly homeTravelDistance: Maybe<Scalars['Int']>;
  readonly homeTravelDistanceDefault: Scalars['Int'];
  readonly homeTravelPrice: Maybe<Scalars['Int']>;
  readonly teamUnitPrice: Scalars['Int'];
  readonly homeTravelAmount: Scalars['Int'];
  readonly workTravelDistance: Maybe<Scalars['Int']>;
  readonly workTravelDistanceDefault: Scalars['Int'];
  readonly workTravelPrice: Maybe<Scalars['Int']>;
  readonly workTravelPriceDefault: Scalars['Int'];
  readonly workTravelAmount: Scalars['Int'];
  readonly expenses: ReadonlyArray<Maybe<ContractExpense>>;
  readonly special: Maybe<Scalars['String']>;
  readonly advance: Scalars['Int'];
  readonly fine: Scalars['Int'];
  readonly tariffType: Maybe<Ratesheet>;
  readonly compositionRole: Maybe<CompositionRole>;
  readonly tcCompositionRole: Maybe<TcCompositionRole>;
  readonly dimonaStatus: Maybe<Scalars['String']>;
  readonly sentToDimonaAt: Maybe<Scalars['DateTimeImmutable']>;
  readonly dimonaCancelAt: Maybe<Scalars['DateTimeImmutable']>;
  readonly contractToAttentiaAt: Maybe<Scalars['DateTimeImmutable']>;
  readonly sentContractToEmailAt: Maybe<Scalars['DateTimeImmutable']>;
  readonly cancellationEmailSentAt: Maybe<Scalars['DateTimeImmutable']>;
  readonly sentByEmail: Scalars['Boolean'];
  readonly number: Scalars['Int'];
  readonly printedAt: Maybe<Scalars['DateTimeImmutable']>;
  readonly company: Maybe<Company>;
  readonly signed: Scalars['Boolean'];
  readonly performanceSigned: Scalars['Boolean'];
  readonly attentiaCalculations: ReadonlyArray<Maybe<ContractAttentiaCalculation>>;
  readonly documentNumber: Scalars['String'];
  readonly overtimeTariffPerHour: Scalars['Int'];
  readonly holidayTariffPerHour: Scalars['Int'];
  readonly holidayOvertimeTariffPerHour: Scalars['Int'];
  readonly mealCompensationAmount: Scalars['Int'];
  readonly otherExpenseValue2: Scalars['Int'];
  readonly otherExpenseValue3: Scalars['Int'];
  readonly otherExpenseValue4: Scalars['Int'];
  readonly startLocationType: Maybe<Scalars['String']>;
  readonly subActionDistance: Scalars['Int'];
  readonly hasOwnTransport: Scalars['Boolean'];
  readonly totalCalculatedAttentia: Scalars['Int'];
  readonly totalCalculated: Scalars['Int'];
  readonly totalCostCompany: Scalars['Int'];
  readonly useLegacyPdfTemplate: Scalars['Boolean'];
  readonly pointhrSendResultUuid: Maybe<Scalars['String']>;
  readonly pointhrCancelResultUuid: Maybe<Scalars['String']>;
  readonly dimonaError: Maybe<Scalars['String']>;
  readonly pointhrExportStatus: Maybe<Scalars['String']>;
  readonly pointhrExportError: Maybe<Scalars['String']>;
  readonly dimonaFailStartedAt: Maybe<Scalars['DateTimeImmutable']>;
  readonly createdAt: Scalars['DateTimeImmutable'];
  readonly updatedAt: Scalars['DateTimeImmutable'];
  readonly uuid: Scalars['UUID'];
};

export type ContractAttentiaCalculation = {
  readonly __typename?: 'ContractAttentiaCalculation';
  readonly contract: Contract;
  readonly calculationFor: Scalars['DateTimeImmutable'];
  readonly grossSubordinateToRZS: Scalars['Int'];
  readonly grossNOTSubordinateToRZS: Scalars['Int'];
  readonly personalRSZ: Scalars['Int'];
  readonly taxable: Scalars['Int'];
  readonly companyTax: Scalars['Int'];
  readonly netSurcharge: Scalars['Int'];
  readonly netDeduction: Scalars['Int'];
  readonly BBSZ: Scalars['Int'];
  readonly totalNet: Scalars['Int'];
  readonly patronalRZS: Scalars['Int'];
  readonly createdAt: Scalars['DateTimeImmutable'];
  readonly updatedAt: Scalars['DateTimeImmutable'];
  readonly uuid: Scalars['UUID'];
};

export enum ContractDimonaStatus {
  Sent = 'SENT',
  Accepted = 'ACCEPTED',
  Error = 'ERROR',
  CancelSent = 'CANCEL_SENT',
  Cancelled = 'CANCELLED',
  AttentiaSent = 'ATTENTIA_SENT',
  CancelledInAttentia = 'CANCELLED_IN_ATTENTIA'
}

export enum ContractDocumentTemplateTag {
  EmployeeName = 'EMPLOYEE_NAME',
  EmployeeCompany = 'EMPLOYEE_COMPANY',
  EmployeeBirthDate = 'EMPLOYEE_BIRTH_DATE',
  EmployeeStreetOfficial = 'EMPLOYEE_STREET_OFFICIAL',
  EmployeeHouseNumberOfficial = 'EMPLOYEE_HOUSE_NUMBER_OFFICIAL',
  EmployeePostalCodeOfficial = 'EMPLOYEE_POSTAL_CODE_OFFICIAL',
  EmployeeCityOfficial = 'EMPLOYEE_CITY_OFFICIAL',
  EmployeeBirthPlace = 'EMPLOYEE_BIRTH_PLACE',
  EmployeeCompanyName = 'EMPLOYEE_COMPANY_NAME',
  EmployeeCompanyVat = 'EMPLOYEE_COMPANY_VAT',
  EmployerOfficeAddress = 'EMPLOYER_OFFICE_ADDRESS',
  EmployerRepresentative = 'EMPLOYER_REPRESENTATIVE',
  EmployerAgencyName = 'EMPLOYER_AGENCY_NAME',
  EmployerViaCompanyAddress = 'EMPLOYER_VIA_COMPANY_ADDRESS',
  MaximumMileage = 'MAXIMUM_MILEAGE',
  JointCommittee = 'JOINT_COMMITTEE',
  ActionDate = 'ACTION_DATE',
  ActionLocation = 'ACTION_LOCATION',
  ActionProject = 'ACTION_PROJECT',
  ContractHours = 'CONTRACT_HOURS',
  ContractGenerationDate = 'CONTRACT_GENERATION_DATE',
  ContractNumber = 'CONTRACT_NUMBER',
  SalaryRate = 'SALARY_RATE',
  JobTypeDescription = 'JOB_TYPE_DESCRIPTION'
}

export type ContractExpense = {
  readonly __typename?: 'ContractExpense';
  readonly name: Scalars['String'];
  readonly amount: Maybe<Scalars['Int']>;
  readonly contract: Maybe<Contract>;
  readonly type: Maybe<ContractExpenseTypes>;
  readonly priority: Scalars['Int'];
  readonly uuid: Scalars['UUID'];
  readonly createdAt: Scalars['DateTimeImmutable'];
  readonly updatedAt: Scalars['DateTimeImmutable'];
};

export type ContractExpenseInput = {
  readonly uuid?: Maybe<Scalars['UUID']>;
  readonly name?: Maybe<Scalars['String']>;
  readonly amount?: Maybe<Scalars['Int']>;
  readonly type: ContractExpenseTypes;
};

export enum ContractExpenseTypes {
  TypeDefault = 'TYPE_DEFAULT',
  TypeMealCompensation = 'TYPE_MEAL_COMPENSATION'
}

export type ContractInput = {
  readonly uuid: Scalars['UUID'];
  readonly expenses?: Maybe<ReadonlyArray<Maybe<ContractExpenseInput>>>;
  readonly signed?: Maybe<Scalars['Boolean']>;
};

export type ContractRealSchedule = {
  readonly __typename?: 'ContractRealSchedule';
  readonly contract: Maybe<Contract>;
  readonly plannedSchedule: Maybe<ScheduleAssignment>;
  readonly tcScheduleAssignment: Maybe<TeamCostScheduleAssignment>;
  readonly startTime: Scalars['Int'];
  readonly endTime: Scalars['Int'];
  readonly sequence: Scalars['Int'];
  readonly uuid: Scalars['UUID'];
  readonly createdAt: Scalars['DateTimeImmutable'];
  readonly updatedAt: Scalars['DateTimeImmutable'];
};

export enum ContractStatus {
  Open = 'OPEN',
  InProgress = 'IN_PROGRESS',
  Cancelled = 'CANCELLED',
  ToReview = 'TO_REVIEW',
  InQuestion = 'IN_QUESTION',
  ActionFinished = 'ACTION_FINISHED',
  CalculationFinished = 'CALCULATION_FINISHED',
  Approved = 'APPROVED',
  Closed = 'CLOSED',
  ClosedPaid = 'CLOSED_PAID',
  ClosedNotPaid = 'CLOSED_NOT_PAID'
}

export enum ContractTariffBase {
  RoleRate = 'ROLE_RATE',
  PersonalRate = 'PERSONAL_RATE'
}

export type ContractUploadAttentiaCalculationsInput = {
  readonly calculationsDocumentUuid: Scalars['UUID'];
};

export type ContractUploadAttentiaCalculationsResponse = {
  readonly __typename?: 'ContractUploadAttentiaCalculationsResponse';
  readonly importedCalculations: ReadonlyArray<ContractAttentiaCalculation>;
  readonly alreadyImportedContractNumbers: ReadonlyArray<Scalars['String']>;
  readonly notImportableContractNumbers: ReadonlyArray<Scalars['String']>;
};

export type ContractsPaginator = {
  readonly __typename?: 'ContractsPaginator';
  readonly items: ReadonlyArray<Contract>;
  readonly page: Scalars['Int'];
  readonly limit: Scalars['Int'];
  readonly total: Scalars['Int'];
  /**
   * *     Hash of query parameters.
   * *
   */
  readonly hash: Scalars['String'];
  readonly hasMore: Scalars['Boolean'];
};

export type ContractsQueryInput = {
  readonly sort?: Maybe<ReadonlyArray<ContractsSortItem>>;
  readonly uuids?: Maybe<ReadonlyArray<Scalars['UUID']>>;
  readonly externalUserUuids?: Maybe<ReadonlyArray<Scalars['UUID']>>;
  readonly externalUserIds?: Maybe<ReadonlyArray<Scalars['UUID']>>;
  readonly signed?: Maybe<Scalars['Boolean']>;
  readonly statuses?: Maybe<ReadonlyArray<ContractStatus>>;
  readonly dimonaStatuses?: Maybe<ReadonlyArray<ContractDimonaStatus>>;
  /**
   * *    Excludes signed contracts according to =signed=, =performanceSigned= and start date fields.
   * *
   */
  readonly excludeSigned?: Maybe<Scalars['Boolean']>;
  /**
   * *    Accepts positive number, maximum `1000`.
   * *    Default `1`.
   * *
   */
  readonly page?: Maybe<Scalars['Int']>;
  /**
   * *    Accepts any positive number or zero, maximum `1000`.
   * *    Zero can be used for calculate totals.
   * *    Default `20`.
   * *
   */
  readonly limit?: Maybe<Scalars['Int']>;
};

export type ContractsSortItem = {
  readonly by?: Maybe<ContractsSortType>;
  readonly direction?: Maybe<SortDirection>;
};

export enum ContractsSortType {
  ActionDate = 'ACTION_DATE'
}

export type CreateBookingPersonMovementInput = {
  readonly uuid?: Maybe<Scalars['UUID']>;
  readonly date: Scalars['DateTimeImmutable'];
  readonly state: Scalars['String'];
  readonly bookingPersonUuid: Scalars['UUID'];
  readonly lat?: Maybe<Scalars['Float']>;
  readonly lng?: Maybe<Scalars['Float']>;
};

export type CreateSubActionTeamInput = {
  readonly mainActionTeamUuid: Scalars['UUID'];
  /**
   * *     Only `_PICK_UP` and `_DROP_OFF` are allowed.
   * *
   */
  readonly type: ActionTeamType;
};

export type Currency = {
  readonly __typename?: 'Currency';
  readonly name: Scalars['String'];
  readonly code: Scalars['String'];
  readonly sign: Maybe<Scalars['String']>;
  readonly createdAt: Scalars['DateTimeImmutable'];
  readonly updatedAt: Scalars['DateTimeImmutable'];
  readonly uuid: Scalars['UUID'];
};





export type DebriefingAnswer = {
  readonly __typename?: 'DebriefingAnswer';
  readonly bookingPerson: Maybe<BookingPerson>;
  readonly formElement: FormElement;
  readonly user: Maybe<User>;
  readonly completed: Scalars['Boolean'];
  readonly value: Maybe<Scalars['String']>;
  readonly uuid: Scalars['UUID'];
  readonly createdAt: Scalars['DateTimeImmutable'];
  readonly updatedAt: Scalars['DateTimeImmutable'];
};

export type DebriefingAnswerContacts = DebriefingAnswerInterface & {
  readonly __typename?: 'DebriefingAnswerContacts';
  readonly value: Maybe<Scalars['String']>;
  readonly bookingPerson: Maybe<BookingPerson>;
  readonly formElement: FormElement;
  readonly user: Maybe<User>;
  readonly completed: Scalars['Boolean'];
  readonly uuid: Scalars['UUID'];
  readonly createdAt: Scalars['DateTimeImmutable'];
  readonly updatedAt: Scalars['DateTimeImmutable'];
};

export type DebriefingAnswerDate = DebriefingAnswerInterface & {
  readonly __typename?: 'DebriefingAnswerDate';
  readonly value: Maybe<Scalars['String']>;
  readonly bookingPerson: Maybe<BookingPerson>;
  readonly formElement: FormElement;
  readonly user: Maybe<User>;
  readonly completed: Scalars['Boolean'];
  readonly uuid: Scalars['UUID'];
  readonly createdAt: Scalars['DateTimeImmutable'];
  readonly updatedAt: Scalars['DateTimeImmutable'];
};

export type DebriefingAnswerDegree = DebriefingAnswerInterface & {
  readonly __typename?: 'DebriefingAnswerDegree';
  readonly value: Maybe<Scalars['String']>;
  readonly bookingPerson: Maybe<BookingPerson>;
  readonly formElement: FormElement;
  readonly user: Maybe<User>;
  readonly completed: Scalars['Boolean'];
  readonly uuid: Scalars['UUID'];
  readonly createdAt: Scalars['DateTimeImmutable'];
  readonly updatedAt: Scalars['DateTimeImmutable'];
};

export type DebriefingAnswerDropdown = DebriefingAnswerInterface & {
  readonly __typename?: 'DebriefingAnswerDropdown';
  readonly value: Maybe<Scalars['String']>;
  readonly bookingPerson: Maybe<BookingPerson>;
  readonly formElement: FormElement;
  readonly user: Maybe<User>;
  readonly completed: Scalars['Boolean'];
  readonly uuid: Scalars['UUID'];
  readonly createdAt: Scalars['DateTimeImmutable'];
  readonly updatedAt: Scalars['DateTimeImmutable'];
};

export type DebriefingAnswerFileUpload = DebriefingAnswerInterface & {
  readonly __typename?: 'DebriefingAnswerFileUpload';
  readonly files: ReadonlyArray<Maybe<DebriefingAnswerFileUploadItem>>;
  readonly value: Maybe<Scalars['String']>;
  readonly bookingPerson: Maybe<BookingPerson>;
  readonly formElement: FormElement;
  readonly user: Maybe<User>;
  readonly completed: Scalars['Boolean'];
  readonly uuid: Scalars['UUID'];
  readonly createdAt: Scalars['DateTimeImmutable'];
  readonly updatedAt: Scalars['DateTimeImmutable'];
};

export type DebriefingAnswerFileUploadItem = {
  readonly __typename?: 'DebriefingAnswerFileUploadItem';
  readonly debriefingAnswerFileUpload: DebriefingAnswerFileUpload;
  readonly name: Scalars['String'];
  readonly path: Scalars['String'];
  readonly uuid: Scalars['UUID'];
  readonly createdAt: Scalars['DateTimeImmutable'];
  readonly updatedAt: Scalars['DateTimeImmutable'];
};

export type DebriefingAnswerGoodBad = DebriefingAnswerInterface & {
  readonly __typename?: 'DebriefingAnswerGoodBad';
  readonly value: Maybe<Scalars['String']>;
  readonly bookingPerson: Maybe<BookingPerson>;
  readonly formElement: FormElement;
  readonly user: Maybe<User>;
  readonly completed: Scalars['Boolean'];
  readonly uuid: Scalars['UUID'];
  readonly createdAt: Scalars['DateTimeImmutable'];
  readonly updatedAt: Scalars['DateTimeImmutable'];
};

export type DebriefingAnswerInterface = {
  readonly uuid: Scalars['UUID'];
  readonly bookingPerson: Maybe<BookingPerson>;
  readonly user: Maybe<User>;
  readonly formElement: FormElement;
  readonly value: Maybe<Scalars['String']>;
  readonly completed: Scalars['Boolean'];
  readonly createdAt: Scalars['DateTimeImmutable'];
  readonly updatedAt: Scalars['DateTimeImmutable'];
};

export type DebriefingAnswerMultipleChoice = DebriefingAnswerInterface & {
  readonly __typename?: 'DebriefingAnswerMultipleChoice';
  readonly choices: ReadonlyArray<Maybe<FormElementChoice>>;
  readonly value: Maybe<Scalars['String']>;
  readonly bookingPerson: Maybe<BookingPerson>;
  readonly formElement: FormElement;
  readonly user: Maybe<User>;
  readonly completed: Scalars['Boolean'];
  readonly uuid: Scalars['UUID'];
  readonly createdAt: Scalars['DateTimeImmutable'];
  readonly updatedAt: Scalars['DateTimeImmutable'];
};

export type DebriefingAnswerNumber = DebriefingAnswerInterface & {
  readonly __typename?: 'DebriefingAnswerNumber';
  readonly value: Maybe<Scalars['String']>;
  readonly bookingPerson: Maybe<BookingPerson>;
  readonly formElement: FormElement;
  readonly user: Maybe<User>;
  readonly completed: Scalars['Boolean'];
  readonly uuid: Scalars['UUID'];
  readonly createdAt: Scalars['DateTimeImmutable'];
  readonly updatedAt: Scalars['DateTimeImmutable'];
};

export type DebriefingAnswerOpinionScale = DebriefingAnswerInterface & {
  readonly __typename?: 'DebriefingAnswerOpinionScale';
  readonly value: Maybe<Scalars['String']>;
  readonly bookingPerson: Maybe<BookingPerson>;
  readonly formElement: FormElement;
  readonly user: Maybe<User>;
  readonly completed: Scalars['Boolean'];
  readonly uuid: Scalars['UUID'];
  readonly createdAt: Scalars['DateTimeImmutable'];
  readonly updatedAt: Scalars['DateTimeImmutable'];
};

export type DebriefingAnswerRating = DebriefingAnswerInterface & {
  readonly __typename?: 'DebriefingAnswerRating';
  readonly value: Maybe<Scalars['String']>;
  readonly bookingPerson: Maybe<BookingPerson>;
  readonly formElement: FormElement;
  readonly user: Maybe<User>;
  readonly completed: Scalars['Boolean'];
  readonly uuid: Scalars['UUID'];
  readonly createdAt: Scalars['DateTimeImmutable'];
  readonly updatedAt: Scalars['DateTimeImmutable'];
};

export type DebriefingAnswerSamples = DebriefingAnswerInterface & {
  readonly __typename?: 'DebriefingAnswerSamples';
  readonly value: Maybe<Scalars['String']>;
  readonly bookingPerson: Maybe<BookingPerson>;
  readonly formElement: FormElement;
  readonly user: Maybe<User>;
  readonly completed: Scalars['Boolean'];
  readonly uuid: Scalars['UUID'];
  readonly createdAt: Scalars['DateTimeImmutable'];
  readonly updatedAt: Scalars['DateTimeImmutable'];
};

export type DebriefingAnswerText = DebriefingAnswerInterface & {
  readonly __typename?: 'DebriefingAnswerText';
  readonly value: Maybe<Scalars['String']>;
  readonly bookingPerson: Maybe<BookingPerson>;
  readonly formElement: FormElement;
  readonly user: Maybe<User>;
  readonly completed: Scalars['Boolean'];
  readonly uuid: Scalars['UUID'];
  readonly createdAt: Scalars['DateTimeImmutable'];
  readonly updatedAt: Scalars['DateTimeImmutable'];
};

export type DebriefingAnswerTextarea = DebriefingAnswerInterface & {
  readonly __typename?: 'DebriefingAnswerTextarea';
  readonly value: Maybe<Scalars['String']>;
  readonly bookingPerson: Maybe<BookingPerson>;
  readonly formElement: FormElement;
  readonly user: Maybe<User>;
  readonly completed: Scalars['Boolean'];
  readonly uuid: Scalars['UUID'];
  readonly createdAt: Scalars['DateTimeImmutable'];
  readonly updatedAt: Scalars['DateTimeImmutable'];
};

export type DebriefingAnswerTime = DebriefingAnswerInterface & {
  readonly __typename?: 'DebriefingAnswerTime';
  readonly value: Maybe<Scalars['String']>;
  readonly bookingPerson: Maybe<BookingPerson>;
  readonly formElement: FormElement;
  readonly user: Maybe<User>;
  readonly completed: Scalars['Boolean'];
  readonly uuid: Scalars['UUID'];
  readonly createdAt: Scalars['DateTimeImmutable'];
  readonly updatedAt: Scalars['DateTimeImmutable'];
};

export type DebriefingAnswerUnion = DebriefingAnswerText | DebriefingAnswerTextarea | DebriefingAnswerNumber | DebriefingAnswerFileUpload | DebriefingAnswerOpinionScale | DebriefingAnswerSamples | DebriefingAnswerContacts | DebriefingAnswerMultipleChoice | DebriefingAnswerDropdown | DebriefingAnswerGoodBad | DebriefingAnswerYesNo | DebriefingAnswerTime | DebriefingAnswerDate | DebriefingAnswerRating | DebriefingAnswerDegree;

export type DebriefingAnswerYesNo = DebriefingAnswerInterface & {
  readonly __typename?: 'DebriefingAnswerYesNo';
  readonly value: Maybe<Scalars['String']>;
  readonly bookingPerson: Maybe<BookingPerson>;
  readonly formElement: FormElement;
  readonly user: Maybe<User>;
  readonly completed: Scalars['Boolean'];
  readonly uuid: Scalars['UUID'];
  readonly createdAt: Scalars['DateTimeImmutable'];
  readonly updatedAt: Scalars['DateTimeImmutable'];
};

export enum Degree {
  Student = 'Student',
  Associate = 'Associate',
  Bachelor = 'Bachelor',
  Master = 'Master',
  Doctor = 'Doctor'
}

export type DeleteCompanyHolidayInput = {
  readonly uuid: Scalars['UUID'];
};

export type DeleteCompanyPayrollRuleInput = {
  readonly uuid: Scalars['UUID'];
};

export type DeleteLeaveHolidayAssignmentInput = {
  /** UUID of deleted entry. */
  readonly uuid?: Maybe<Scalars['UUID']>;
  /** (Optional) UUID of timeslot. */
  readonly timeslotUuid?: Maybe<Scalars['UUID']>;
};

export type DeleteProjectTaskAssignmentInput = {
  /** UUID of deleted entry. */
  readonly uuid?: Maybe<Scalars['UUID']>;
  /** (Optional) UUID of timeslot. */
  readonly timeslotUuid?: Maybe<Scalars['UUID']>;
};

export type DeleteTimeTrackInput = {
  readonly UUIDs?: Maybe<ReadonlyArray<Scalars['UUID']>>;
  readonly dates?: Maybe<ReadonlyArray<Scalars['DateImmutable']>>;
  readonly projectTaskUUIDs?: Maybe<ReadonlyArray<Scalars['UUID']>>;
  readonly type?: Maybe<TimeTrackType>;
};

export type DictionaryService = {
  readonly __typename?: 'DictionaryService';
  readonly name: Scalars['String'];
  readonly description: Maybe<Scalars['String']>;
  readonly unitPrice: Scalars['Int'];
  readonly billablePrice: Scalars['Int'];
  readonly status: Scalars['String'];
  readonly company: Maybe<Company>;
  readonly ratesheetServices: ReadonlyArray<Maybe<RatesheetService>>;
  readonly uuid: Scalars['UUID'];
  readonly createdAt: Scalars['DateTimeImmutable'];
  readonly updatedAt: Scalars['DateTimeImmutable'];
};

export type DictionaryTransport = {
  readonly __typename?: 'DictionaryTransport';
  readonly name: Scalars['String'];
  readonly code: Scalars['String'];
  readonly alias: Maybe<Scalars['String']>;
  readonly fixedCost: Maybe<Scalars['Int']>;
  readonly variableCost: Maybe<Scalars['Int']>;
  readonly checkBooking: Maybe<Scalars['Boolean']>;
  readonly checkDriverLicense: Maybe<Scalars['Boolean']>;
  readonly isNoPromo: Maybe<Scalars['Boolean']>;
  readonly isActive: Maybe<Scalars['Boolean']>;
  readonly company: Maybe<Company>;
  readonly own: Scalars['Boolean'];
  readonly status: Scalars['String'];
  readonly costUnitPrice: Scalars['Int'];
  readonly costBillablePrice: Scalars['Int'];
  readonly distanceUnitPrice: Scalars['Int'];
  readonly distanceBillablePrice: Scalars['Int'];
  readonly handlingUnitPrice: Scalars['Int'];
  readonly handlingBillablePrice: Scalars['Int'];
  readonly ratesheetTransports: ReadonlyArray<Maybe<RatesheetTransport>>;
  readonly uuid: Scalars['UUID'];
  readonly createdAt: Scalars['DateTimeImmutable'];
  readonly updatedAt: Scalars['DateTimeImmutable'];
};

export type DictionaryWarehouse = {
  readonly __typename?: 'DictionaryWarehouse';
  readonly name: Scalars['String'];
  readonly description: Maybe<Scalars['String']>;
  readonly unitPrice: Scalars['Int'];
  readonly billablePrice: Scalars['Int'];
  readonly uuid: Scalars['UUID'];
  readonly createdAt: Scalars['DateTimeImmutable'];
  readonly updatedAt: Scalars['DateTimeImmutable'];
};

export type Distance = {
  readonly __typename?: 'Distance';
  readonly fromLat: Scalars['Float'];
  readonly fromLng: Scalars['Float'];
  readonly toLat: Scalars['Float'];
  readonly toLng: Scalars['Float'];
  readonly distance: Scalars['Int'];
  readonly rawData: Maybe<Scalars['JSON']>;
  readonly uuid: Scalars['UUID'];
  readonly createdAt: Scalars['DateTimeImmutable'];
  readonly updatedAt: Scalars['DateTimeImmutable'];
};

export type Estimate = {
  readonly __typename?: 'Estimate';
  readonly estimateId: Scalars['String'];
  readonly client: Maybe<Client>;
  readonly issueDate: Maybe<Scalars['DateImmutable']>;
  readonly currency: Currency;
  readonly discount: Maybe<Scalars['Int']>;
  readonly notes: Maybe<Scalars['String']>;
  readonly estimateGroups: ReadonlyArray<Maybe<EstimateGroup>>;
  readonly estimateItems: ReadonlyArray<Maybe<EstimateItem>>;
  readonly company: Company;
  readonly status: Scalars['String'];
  readonly files: ReadonlyArray<Maybe<File>>;
  readonly name: Scalars['String'];
  readonly ratesheet: Maybe<Ratesheet>;
  readonly supplier: Maybe<Supplier>;
  readonly createdAt: Scalars['DateTimeImmutable'];
  readonly updatedAt: Scalars['DateTimeImmutable'];
  readonly uuid: Scalars['UUID'];
};

export type EstimateGroup = {
  readonly __typename?: 'EstimateGroup';
  readonly name: Scalars['String'];
  readonly estimateItems: ReadonlyArray<Maybe<EstimateItem>>;
  readonly estimate: Estimate;
  readonly createdAt: Scalars['DateTimeImmutable'];
  readonly updatedAt: Scalars['DateTimeImmutable'];
  readonly uuid: Scalars['UUID'];
};

export type EstimateItem = {
  readonly __typename?: 'EstimateItem';
  readonly estimateGroup: Maybe<EstimateGroup>;
  readonly name: Scalars['String'];
  readonly description: Maybe<Scalars['String']>;
  readonly quantity: Maybe<Scalars['Int']>;
  readonly realUnitPrice: Scalars['Int'];
  readonly billablePrice: Scalars['Int'];
  readonly billableUnitType: Scalars['String'];
  readonly discount: Maybe<Scalars['Int']>;
  readonly estimate: Maybe<Estimate>;
  readonly createdAt: Scalars['DateTimeImmutable'];
  readonly updatedAt: Scalars['DateTimeImmutable'];
  readonly uuid: Scalars['UUID'];
};

export type Event = {
  readonly __typename?: 'Event';
  readonly user: Maybe<User>;
  readonly ipAddress: Scalars['String'];
  readonly action: Scalars['String'];
  readonly targetUuid: Maybe<Scalars['UUID']>;
  readonly data: Maybe<Scalars['JSON']>;
  readonly company: Maybe<Company>;
  readonly snapshotUuid: Maybe<Scalars['UUID']>;
  readonly comment: Maybe<Scalars['String']>;
  readonly createdAt: Scalars['DateTimeImmutable'];
  readonly updatedAt: Scalars['DateTimeImmutable'];
  readonly uuid: Scalars['UUID'];
};

export type Expense = {
  readonly __typename?: 'Expense';
  readonly name: Scalars['String'];
  readonly expenseUnitPrice: Maybe<Scalars['Int']>;
  readonly billableRate: Maybe<Scalars['Int']>;
  readonly company: Maybe<Company>;
  readonly description: Scalars['String'];
  readonly status: Scalars['String'];
  readonly expenseGroups: ReadonlyArray<Maybe<ExpenseGroup>>;
  readonly expenseGroup: Maybe<ExpenseGroup>;
  readonly projectExpenses: ReadonlyArray<Maybe<ProjectExpense>>;
  readonly ratesheet: Maybe<Ratesheet>;
  readonly ratesheetExpenses: ReadonlyArray<Maybe<RatesheetExpense>>;
  readonly createdAt: Scalars['DateTimeImmutable'];
  readonly updatedAt: Scalars['DateTimeImmutable'];
  readonly uuid: Scalars['UUID'];
};

export type ExpenseGroup = {
  readonly __typename?: 'ExpenseGroup';
  readonly name: Scalars['String'];
  readonly type: Maybe<ExpenseType>;
  readonly company: Maybe<Company>;
  readonly expenseGroupUnitPrice: Maybe<Scalars['Int']>;
  readonly billableRate: Maybe<Scalars['Int']>;
  readonly description: Scalars['String'];
  readonly status: Scalars['String'];
  readonly expenses: ReadonlyArray<Maybe<Expense>>;
  readonly expense: Expense;
  readonly projectExpenseGroups: ReadonlyArray<Maybe<ProjectExpenseGroup>>;
  readonly createdAt: Scalars['DateTimeImmutable'];
  readonly updatedAt: Scalars['DateTimeImmutable'];
  readonly uuid: Scalars['UUID'];
};

export type ExpenseType = {
  readonly __typename?: 'ExpenseType';
  readonly name: Scalars['String'];
  readonly createdAt: Scalars['DateTimeImmutable'];
  readonly updatedAt: Scalars['DateTimeImmutable'];
  readonly uuid: Scalars['UUID'];
};

export type ExternalUser = {
  readonly __typename?: 'ExternalUser';
  readonly availabilityStatus: Maybe<AvailabilityStatus>;
  readonly fullName: Scalars['String'];
  readonly firstName: Scalars['String'];
  readonly lastName: Scalars['String'];
  readonly birthday: Maybe<Scalars['DateImmutable']>;
  readonly gender: Maybe<Gender>;
  readonly country: Maybe<GeoCountry>;
  readonly street: Maybe<Scalars['String']>;
  readonly postalCode: Maybe<Scalars['String']>;
  readonly city: Maybe<Scalars['String']>;
  readonly nr: Maybe<Scalars['String']>;
  readonly state: Maybe<Scalars['String']>;
  readonly socialSecurityNumber: Maybe<Scalars['String']>;
  readonly iban: Maybe<Scalars['String']>;
  readonly bic: Maybe<Scalars['String']>;
  readonly birthPlace: Maybe<Scalars['String']>;
  readonly childrenAmount: Maybe<Scalars['Int']>;
  readonly professionalStatus: Maybe<ProfessionalStatusForPointHr>;
  readonly studentWorkdays: Maybe<Scalars['Int']>;
  readonly studyLevel: Maybe<Scalars['String']>;
  readonly degree: Maybe<Degree>;
  readonly hasCar: Maybe<Scalars['Boolean']>;
  readonly drivingLicenseNumber: Maybe<Scalars['String']>;
  readonly drivingLicenseExpirationDate: Maybe<Scalars['DateTimeImmutable']>;
  readonly height: Maybe<Scalars['Float']>;
  readonly weight: Maybe<Scalars['Float']>;
  readonly pantsSize: Maybe<Scalars['Int']>;
  readonly shoeSize: Maybe<Scalars['Int']>;
  readonly motivation: Maybe<Scalars['String']>;
  readonly contactReferenceName: Maybe<Scalars['String']>;
  readonly files: ReadonlyArray<Maybe<File>>;
  readonly gallery: ReadonlyArray<Maybe<File>>;
  readonly socialNetworks: ReadonlyArray<Maybe<SocialNetwork>>;
  readonly hairColor: Maybe<Scalars['String']>;
  readonly skinColor: Maybe<Scalars['String']>;
  readonly avatar: Maybe<Scalars['String']>;
  readonly role: Maybe<Scalars['String']>;
  readonly phones: ReadonlyArray<Maybe<ExternalUserPhone>>;
  readonly company: Company;
  readonly status: Scalars['String'];
  readonly maritalStatus: Maybe<Scalars['String']>;
  readonly drivingLicenses: Maybe<Scalars['JSON']>;
  readonly knowledge: ReadonlyArray<Maybe<Knowledge>>;
  readonly bookingPersons: ReadonlyArray<Maybe<BookingPerson>>;
  readonly tShirtSize: Maybe<Scalars['String']>;
  readonly reason: Maybe<Scalars['String']>;
  readonly visitDate: Maybe<Scalars['DateTimeImmutable']>;
  readonly archivedAt: Maybe<Scalars['DateTimeImmutable']>;
  readonly contactReferenceType: Maybe<Scalars['String']>;
  readonly confirmationToken: Maybe<Scalars['String']>;
  readonly email: Scalars['String'];
  readonly createdBy: Maybe<Scalars['String']>;
  readonly updatedBy: Maybe<Scalars['String']>;
  readonly invitedDate: Maybe<Scalars['DateTimeImmutable']>;
  readonly invitedDate2: Maybe<Scalars['DateTimeImmutable']>;
  readonly nextOfKin: Maybe<Scalars['String']>;
  readonly nextOfKinPhone: Maybe<Scalars['String']>;
  readonly employersDescription: Maybe<Scalars['String']>;
  readonly friendsDescription: Maybe<Scalars['String']>;
  readonly accountNumber: Maybe<Scalars['String']>;
  readonly passportNumber: Maybe<Scalars['String']>;
  readonly degreeDate: Maybe<Scalars['DateTimeImmutable']>;
  readonly study: Maybe<Scalars['String']>;
  readonly sports: Maybe<Scalars['JSON']>;
  readonly jobExperience: Maybe<Scalars['JSON']>;
  readonly waiste: Maybe<Scalars['Int']>;
  readonly legLength: Maybe<Scalars['Int']>;
  readonly carRemark: Maybe<Scalars['String']>;
  readonly remarks: Maybe<Scalars['JSON']>;
  readonly evaluation: Maybe<Scalars['String']>;
  readonly ownStaff: Scalars['Boolean'];
  readonly jobStudentStart: Maybe<Scalars['DateTimeImmutable']>;
  readonly husbandFirstName: Maybe<Scalars['String']>;
  readonly husbandLastName: Maybe<Scalars['String']>;
  readonly husbandProfessionCategory: Maybe<Scalars['String']>;
  readonly registrationDate: Maybe<Scalars['DateTimeImmutable']>;
  readonly languageRemarks: Maybe<Scalars['JSON']>;
  readonly badgeNumber: Maybe<Scalars['Int']>;
  readonly contractType: Maybe<Scalars['String']>;
  readonly preferredLanguage: Maybe<Scalars['String']>;
  readonly childHandicapedCount: Maybe<Scalars['Int']>;
  readonly partnerAsBurden: Scalars['Boolean'];
  readonly partnerHandicaped: Scalars['Boolean'];
  readonly otherAsBurdenCount: Maybe<Scalars['Int']>;
  readonly otherHandicapedAsBurdenCount: Maybe<Scalars['Int']>;
  readonly handicapedEmployee: Scalars['Boolean'];
  readonly childSupport: Scalars['Boolean'];
  readonly taxLevel: Maybe<Scalars['String']>;
  readonly stillActive: Scalars['Boolean'];
  readonly avWeek: Maybe<Scalars['String']>;
  readonly avWeekend: Maybe<Scalars['String']>;
  readonly profile: Maybe<Scalars['String']>;
  readonly profiles: Maybe<Scalars['JSON']>;
  readonly wait: Scalars['Boolean'];
  readonly shirtSize: Maybe<Scalars['String']>;
  readonly ethnic: Maybe<Scalars['String']>;
  readonly peopleStatus: Maybe<Scalars['String']>;
  readonly peopleRemarks: Maybe<Scalars['String']>;
  readonly peopleMotivations: Maybe<Scalars['String']>;
  readonly BMI: Maybe<Scalars['Float']>;
  readonly privacyClause: Scalars['Boolean'];
  readonly privacyClauseDate: Maybe<Scalars['DateTimeImmutable']>;
  readonly webLoginDate: Maybe<Scalars['DateTimeImmutable']>;
  readonly VATNumber: Maybe<Scalars['String']>;
  readonly companyName: Maybe<Scalars['String']>;
  readonly companyVAT: Maybe<Scalars['String']>;
  readonly debriefingViaPromoPortal: Scalars['Boolean'];
  readonly lastFilledInAvailabilityDate: Maybe<Scalars['DateTimeImmutable']>;
  readonly lastEmailedInAvailabilityDate: Maybe<Scalars['DateTimeImmutable']>;
  readonly driverLicenseIssueDate: Maybe<Scalars['DateTimeImmutable']>;
  readonly fuelCode: Maybe<Scalars['String']>;
  readonly carPolicy: Scalars['Boolean'];
  readonly tariffType: Maybe<Scalars['String']>;
  readonly tariffType22: Maybe<Scalars['String']>;
  readonly autoPeopleNbr: Maybe<Scalars['Int']>;
  readonly maritalStatusModifiedDate: Maybe<Scalars['DateTimeImmutable']>;
  readonly recieveWebUpdates: Scalars['Boolean'];
  readonly skillRemarks: Maybe<Scalars['JSON']>;
  readonly jobStudentWorkingHours: Maybe<Scalars['Int']>;
  readonly driverLicenseCheckDate: Maybe<Scalars['DateTimeImmutable']>;
  readonly mostRecentUpdate: Maybe<Scalars['DateTimeImmutable']>;
  readonly tags: ReadonlyArray<Maybe<Tag>>;
  readonly location: Maybe<ExternalUserLocation>;
  readonly otherLanguages: Maybe<Scalars['String']>;
  readonly otherSkills: Maybe<Scalars['String']>;
  readonly hobbies: Maybe<Scalars['String']>;
  readonly receiveUpdates: Scalars['Boolean'];
  readonly nationality: Maybe<Nationality>;
  readonly availabilities: ReadonlyArray<Maybe<Availability>>;
  readonly emails: ReadonlyArray<Maybe<ExternalUserEmail>>;
  readonly taxTariff: Scalars['Int'];
  readonly cv: Maybe<Scalars['String']>;
  readonly costPrice: Maybe<Scalars['Int']>;
  readonly resetPasswordToken: Maybe<Scalars['String']>;
  readonly sanctionPolicyApproved: Scalars['Boolean'];
  readonly latenessForgivenDate: Maybe<Scalars['DateTimeImmutable']>;
  readonly contracts: ReadonlyArray<Maybe<Contract>>;
  readonly extId: Maybe<Scalars['Int']>;
  readonly createdAt: Scalars['DateTimeImmutable'];
  readonly updatedAt: Scalars['DateTimeImmutable'];
  readonly uuid: Scalars['UUID'];
};

export type ExternalUserEmail = {
  readonly __typename?: 'ExternalUserEmail';
  readonly externalUser: Maybe<ExternalUser>;
  readonly label: Maybe<Scalars['String']>;
  readonly email: Scalars['String'];
  readonly createdAt: Scalars['DateTimeImmutable'];
  readonly updatedAt: Scalars['DateTimeImmutable'];
  readonly uuid: Scalars['UUID'];
};

export type ExternalUserLocation = {
  readonly __typename?: 'ExternalUserLocation';
  readonly cityName: Maybe<Scalars['String']>;
  readonly externalUser: ExternalUser;
  readonly companyDistance: Maybe<Distance>;
  readonly name: Maybe<Scalars['String']>;
  readonly address: Maybe<Scalars['String']>;
  readonly lat: Maybe<Scalars['Float']>;
  readonly lng: Maybe<Scalars['Float']>;
  readonly rawDataType: Scalars['String'];
  readonly rawData: Scalars['JSON'];
  readonly uuid: Scalars['UUID'];
  readonly createdAt: Scalars['DateTimeImmutable'];
  readonly updatedAt: Scalars['DateTimeImmutable'];
};

export type ExternalUserPhone = {
  readonly __typename?: 'ExternalUserPhone';
  readonly externalUser: Maybe<ExternalUser>;
  readonly label: Maybe<Scalars['String']>;
  readonly number: Scalars['String'];
  readonly createdAt: Scalars['DateTimeImmutable'];
  readonly updatedAt: Scalars['DateTimeImmutable'];
  readonly uuid: Scalars['UUID'];
};

export type ExternalUserUpdateInput = {
  readonly uuid: Scalars['UUID'];
  readonly latenessForgivenDate?: Maybe<Scalars['DateTimeImmutable']>;
};

export enum ExternalUsersDrivingLicense {
  A1 = 'A1',
  B = 'B',
  C = 'C',
  Be = 'BE',
  Ce = 'CE',
  De = 'DE',
  None = 'NONE',
  Temporary = 'TEMPORARY',
  Voorlopig = 'VOORLOPIG'
}

export type ExternalUsersPaginator = {
  readonly __typename?: 'ExternalUsersPaginator';
  readonly items: ReadonlyArray<ExternalUser>;
  readonly page: Scalars['Int'];
  readonly limit: Scalars['Int'];
  readonly total: Scalars['Int'];
  /**
   * *     Hash of query parameters.
   * *
   */
  readonly hash: Scalars['String'];
  readonly hasMore: Scalars['Boolean'];
};

export type ExternalUsersQueryInput = {
  readonly uuids?: Maybe<ReadonlyArray<Maybe<Scalars['String']>>>;
  /**
   * *    Accepts positive number, maximum `1000`.
   * *    Default `1`.
   * *
   */
  readonly page?: Maybe<Scalars['Int']>;
  /**
   * *    Accepts any positive number or zero, maximum `1000`.
   * *    Zero can be used for calculate totals.
   * *    Default `20`.
   * *
   */
  readonly limit?: Maybe<Scalars['Int']>;
};

export type Fee = {
  readonly __typename?: 'Fee';
  readonly name: Scalars['String'];
  readonly description: Scalars['String'];
  readonly company: Maybe<Company>;
  readonly status: Scalars['String'];
  readonly feeGroups: ReadonlyArray<Maybe<FeeGroup>>;
  readonly createdAt: Scalars['DateTimeImmutable'];
  readonly updatedAt: Scalars['DateTimeImmutable'];
  readonly uuid: Scalars['UUID'];
};

export type FeeGroup = {
  readonly __typename?: 'FeeGroup';
  readonly name: Scalars['String'];
  readonly company: Maybe<Company>;
  readonly status: Scalars['String'];
  readonly fees: ReadonlyArray<Maybe<Fee>>;
  readonly createdAt: Scalars['DateTimeImmutable'];
  readonly updatedAt: Scalars['DateTimeImmutable'];
  readonly uuid: Scalars['UUID'];
};

export type FeesBudgetItem = {
  readonly __typename?: 'FeesBudgetItem';
  readonly actionTeam: ActionTeam;
  readonly channelSelector: Maybe<ChannelSelector>;
  readonly project: Project;
  readonly name: Scalars['String'];
  readonly qty: Scalars['Int'];
  readonly discount: Scalars['Int'];
  readonly unitPrice: Scalars['Int'];
  readonly billablePrice: Scalars['Int'];
  readonly description: Maybe<Scalars['String']>;
  readonly createdAt: Scalars['DateTimeImmutable'];
  readonly updatedAt: Scalars['DateTimeImmutable'];
  readonly uuid: Scalars['UUID'];
};

export type File = {
  readonly __typename?: 'File';
  readonly name: Maybe<Scalars['String']>;
  readonly file: Scalars['String'];
  readonly estimate: Maybe<Estimate>;
  readonly invoice: Maybe<Invoice>;
  readonly externalUser: Maybe<ExternalUser>;
  readonly teamCosts: ReadonlyArray<Maybe<TeamCost>>;
  readonly forms: ReadonlyArray<Maybe<Form>>;
  readonly externalUserGallery: Maybe<ExternalUser>;
  readonly size: Maybe<Scalars['Int']>;
  readonly createdAt: Scalars['DateTimeImmutable'];
  readonly updatedAt: Scalars['DateTimeImmutable'];
  readonly uuid: Scalars['UUID'];
  readonly snapshot: Scalars['Boolean'];
};

export type FlatProjectTaskAssignment = {
  readonly __typename?: 'FlatProjectTaskAssignment';
  readonly type: TimeslotType;
  readonly leaveHolidayAssignment: Maybe<LeaveHolidayAssignment>;
  readonly assignmentUuid: Maybe<Scalars['UUID']>;
  readonly user: Maybe<User>;
  readonly timeslotUuid: Scalars['UUID'];
  readonly date: Maybe<Scalars['DateImmutable']>;
  readonly startTime: Maybe<Scalars['DateTimeImmutable']>;
  readonly duration: Maybe<Scalars['Float']>;
  readonly note: Maybe<Scalars['String']>;
  readonly createdAt: Maybe<Scalars['DateTimeImmutable']>;
  readonly updatedAt: Maybe<Scalars['DateTimeImmutable']>;
  readonly events: ReadonlyArray<Maybe<ProjectTaskAssignmentEvent>>;
  readonly projectTask: Maybe<ProjectTask>;
  readonly isConfirmed: Maybe<Scalars['Boolean']>;
};

export type Form = {
  readonly __typename?: 'Form';
  readonly company: Maybe<Company>;
  readonly name: Maybe<Scalars['String']>;
  readonly template: Scalars['Boolean'];
  readonly status: Maybe<FormStatus>;
  readonly type: Maybe<FormTypes>;
  readonly canSubmit: Maybe<Scalars['Boolean']>;
  readonly formElements: ReadonlyArray<Maybe<FormElement>>;
  readonly formFiles: ReadonlyArray<Maybe<File>>;
  readonly debriefingAction: Action;
  readonly debriefingProject: Project;
  readonly companyFormProject: Project;
  readonly clientFormProject: Project;
  readonly clientFormAction: Action;
  readonly companyFormAction: Action;
  readonly debriefingTeamCost: TeamCost;
  readonly clientFormTeamCost: TeamCost;
  readonly companyFormTeamCost: TeamCost;
  readonly uuid: Scalars['UUID'];
  readonly createdAt: Scalars['DateTimeImmutable'];
  readonly updatedAt: Scalars['DateTimeImmutable'];
};

export type FormAnswerListItem = {
  readonly __typename?: 'FormAnswerListItem';
  readonly actionName: Scalars['String'];
  readonly actionUuid: Scalars['UUID'];
  readonly userUuid: Maybe<Scalars['UUID']>;
  readonly externalUserUuid: Maybe<Scalars['UUID']>;
  readonly firstName: Scalars['String'];
  readonly lastName: Scalars['String'];
  readonly date: Scalars['DateTimeImmutable'];
  readonly type: FormTypes;
  readonly formUuid: Scalars['UUID'];
};

export type FormAnswersListQueryInput = {
  readonly sort?: Maybe<ReadonlyArray<FormAnswersListSortItem>>;
  readonly actionUuid?: Maybe<Scalars['UUID']>;
  readonly projectUuid?: Maybe<Scalars['UUID']>;
};

export type FormAnswersListSortItem = {
  readonly by?: Maybe<FormAnswersListSortType>;
  readonly direction?: Maybe<SortDirection>;
};

export enum FormAnswersListSortType {
  Date = 'date',
  ActionName = 'actionName',
  FirstName = 'firstName',
  LastName = 'lastName'
}

export type FormAnswersPaginator = {
  readonly __typename?: 'FormAnswersPaginator';
  readonly items: ReadonlyArray<DebriefingAnswerUnion>;
  readonly page: Scalars['Int'];
  readonly limit: Scalars['Int'];
  readonly total: Scalars['Int'];
  /**
   * *     Hash of query parameters.
   * *
   */
  readonly hash: Scalars['String'];
  readonly hasMore: Scalars['Boolean'];
};

export type FormAnswersQueryInput = {
  readonly formUuid?: Maybe<Scalars['UUID']>;
  readonly externalUserUuid?: Maybe<Scalars['UUID']>;
  readonly userUuid?: Maybe<Scalars['UUID']>;
  /**
   * *    Accepts positive number, maximum `1000`.
   * *    Default `1`.
   * *
   */
  readonly page?: Maybe<Scalars['Int']>;
  /**
   * *    Accepts any positive number or zero, maximum `1000`.
   * *    Zero can be used for calculate totals.
   * *    Default `20`.
   * *
   */
  readonly limit?: Maybe<Scalars['Int']>;
};

export type FormElement = {
  readonly __typename?: 'FormElement';
  readonly name: Maybe<Scalars['String']>;
  readonly form: Form;
  readonly value: Maybe<Scalars['Int']>;
  readonly formValues: ReadonlyArray<Maybe<FormValue>>;
  readonly type: Maybe<FormElementTypes>;
  readonly optional: Scalars['Boolean'];
  readonly parent: Maybe<FormElement>;
  readonly children: ReadonlyArray<Maybe<FormElement>>;
  readonly debriefingAnswers: ReadonlyArray<Maybe<DebriefingAnswer>>;
  readonly opinionScale: Maybe<FormElementOpinionScale>;
  readonly choices: ReadonlyArray<Maybe<FormElementChoice>>;
  readonly uuid: Scalars['UUID'];
  readonly createdAt: Scalars['DateTimeImmutable'];
  readonly updatedAt: Scalars['DateTimeImmutable'];
};

export type FormElementChoice = {
  readonly __typename?: 'FormElementChoice';
  readonly name: Scalars['String'];
  readonly position: Scalars['Int'];
  readonly formElement: FormElement;
  readonly uuid: Scalars['UUID'];
  readonly createdAt: Scalars['DateTimeImmutable'];
  readonly updatedAt: Scalars['DateTimeImmutable'];
};

export type FormElementOpinionScale = {
  readonly __typename?: 'FormElementOpinionScale';
  readonly minValue: Scalars['Int'];
  readonly minLabel: Scalars['String'];
  readonly maxValue: Scalars['Int'];
  readonly maxLabel: Scalars['String'];
  readonly formElement: FormElement;
  readonly uuid: Scalars['UUID'];
  readonly createdAt: Scalars['DateTimeImmutable'];
  readonly updatedAt: Scalars['DateTimeImmutable'];
};

export enum FormElementTypes {
  Text = 'TEXT',
  Textarea = 'TEXTAREA',
  OpinionScale = 'OPINION_SCALE',
  FileUpload = 'FILE_UPLOAD',
  Numbers = 'NUMBERS',
  Samples = 'SAMPLES',
  Contacts = 'CONTACTS',
  MultipleChoice = 'MULTIPLE_CHOICE',
  Dropdown = 'DROPDOWN',
  Date = 'DATE',
  Time = 'TIME',
  Rating = 'RATING',
  GoodBad = 'GOOD_BAD',
  YesNo = 'YES_NO',
  Degree = 'DEGREE'
}

export enum FormStatus {
  Active = 'ACTIVE',
  Archived = 'ARCHIVED'
}

export enum FormTypes {
  AmbassadorQac = 'AMBASSADOR_QAC',
  CompanyQac = 'COMPANY_QAC',
  ClientQac = 'CLIENT_QAC'
}

export type FormValue = {
  readonly __typename?: 'FormValue';
  readonly formElement: Maybe<FormElement>;
  readonly value: Maybe<Scalars['String']>;
  readonly file: Maybe<File>;
  readonly uuid: Scalars['UUID'];
  readonly createdAt: Scalars['DateTimeImmutable'];
  readonly updatedAt: Scalars['DateTimeImmutable'];
};

export type FormsPaginator = {
  readonly __typename?: 'FormsPaginator';
  readonly items: ReadonlyArray<Form>;
  readonly page: Scalars['Int'];
  readonly limit: Scalars['Int'];
  readonly total: Scalars['Int'];
  /**
   * *     Hash of query parameters.
   * *
   */
  readonly hash: Scalars['String'];
  readonly hasMore: Scalars['Boolean'];
};

export type FormsQueryInput = {
  readonly sort?: Maybe<ReadonlyArray<FormsSortItem>>;
  readonly uuids?: Maybe<ReadonlyArray<Scalars['UUID']>>;
  readonly status?: Maybe<ReadonlyArray<FormStatus>>;
  readonly type?: Maybe<ReadonlyArray<FormTypes>>;
  readonly template?: Maybe<Scalars['Boolean']>;
  /**
   * *    Accepts positive number, maximum `1000`.
   * *    Default `1`.
   * *
   */
  readonly page?: Maybe<Scalars['Int']>;
  /**
   * *    Accepts any positive number or zero, maximum `1000`.
   * *    Zero can be used for calculate totals.
   * *    Default `20`.
   * *
   */
  readonly limit?: Maybe<Scalars['Int']>;
  readonly search?: Maybe<Scalars['String']>;
};

export type FormsSortItem = {
  readonly by?: Maybe<FormsSortType>;
  readonly direction?: Maybe<SortDirection>;
};

export enum FormsSortType {
  Uuid = 'UUID',
  Name = 'NAME',
  CreatedAt = 'CREATED_AT',
  UpdatedAt = 'UPDATED_AT'
}

export enum Gender {
  Male = 'MALE',
  Female = 'FEMALE'
}

export type GeneralProject = {
  readonly __typename?: 'GeneralProject';
  readonly name: Scalars['String'];
  readonly creator: Maybe<User>;
  readonly projectId: Maybe<Scalars['String']>;
  readonly startDate: Maybe<Scalars['DateImmutable']>;
  readonly endDate: Maybe<Scalars['DateImmutable']>;
  readonly description: Maybe<Scalars['String']>;
  readonly client: Client;
  readonly company: Company;
  readonly starred: Maybe<Scalars['Boolean']>;
  readonly fixedFee: Maybe<Scalars['Int']>;
  readonly totalFees: Maybe<Scalars['Int']>;
  readonly totalHours: Maybe<Scalars['Int']>;
  readonly hourlyRate: Maybe<Scalars['Int']>;
  readonly tasks: ReadonlyArray<Maybe<ProjectTask>>;
  readonly teamMembers: ReadonlyArray<Maybe<ProjectTeamMember>>;
  readonly projectGroup: Maybe<ProjectGroup>;
  readonly timeAndMaterials: Maybe<ProjectTimeAndMaterials>;
  readonly taskGroups: ReadonlyArray<Maybe<ProjectTaskGroup>>;
  readonly status: Scalars['String'];
  readonly nettoMarginTarget: Maybe<Scalars['Float']>;
  readonly grossMarginTarget: Maybe<Scalars['Float']>;
  readonly nonBillableBudget: Maybe<Scalars['String']>;
  readonly logoFilename: Maybe<Scalars['String']>;
  readonly ratesheet: Maybe<Ratesheet>;
  readonly grossMargin: Maybe<Scalars['Int']>;
  readonly budgetType: Maybe<Scalars['String']>;
  readonly currentTotalBudget: Maybe<Scalars['Int']>;
  readonly paidAmount: Maybe<Scalars['Int']>;
  readonly invoices: ReadonlyArray<Maybe<Invoice>>;
  readonly draft: Scalars['Boolean'];
  readonly createdAt: Scalars['DateTimeImmutable'];
  readonly updatedAt: Scalars['DateTimeImmutable'];
  readonly uuid: Scalars['UUID'];
};

export type GeoCity = {
  readonly __typename?: 'GeoCity';
  readonly uuid: Scalars['UUID'];
  /** Uniquely identifies this locality for syncronization from data on GeoNames.org. */
  readonly geonameIdentifier: Maybe<Scalars['Int']>;
  readonly country: GeoCountry;
  readonly nameUtf8: Scalars['String'];
  readonly nameAscii: Maybe<Scalars['String']>;
  readonly latitude: Scalars['Float'];
  readonly longitude: Scalars['Float'];
  readonly timezone: Maybe<Timezone>;
  readonly creationDate: Scalars['DateTime'];
  readonly modificationDate: Maybe<Scalars['DateTime']>;
  /**
   * Fipscode (subject to change to iso code), see exceptions below, see file
   * admin1Codes.txt for display names ofthis code; Saved here to set proper states
   */
  readonly admin1Code: Maybe<Scalars['String']>;
  readonly state: Maybe<GeoState>;
  readonly slug: Scalars['String'];
  readonly relation: Maybe<ReadonlyArray<Maybe<GeoState>>>;
};

export type GeoCountry = {
  readonly __typename?: 'GeoCountry';
  readonly uuid: Scalars['UUID'];
  /** ISO code (2 character). */
  readonly code: Scalars['String'];
  readonly name: Scalars['String'];
  /** Top level domain. */
  readonly domain: Scalars['String'];
  /** Postal code format. */
  readonly postalCodeFormat: Maybe<Scalars['String']>;
  /** Postal code regular expression. */
  readonly postalCodeRegex: Maybe<Scalars['String']>;
  /**
   * Phone number prefix, where there is more than one possible phone prefix the
   * different prefixes will be separated by commas.
   */
  readonly phonePrefix: Maybe<Scalars['String']>;
};

export type GeoState = {
  readonly __typename?: 'GeoState';
  readonly uuid: Scalars['UUID'];
  /** Uniquely identifies this locality for syncronization from data on GeoNames.org. */
  readonly geonameIdentifier: Maybe<Scalars['Int']>;
  readonly country: GeoCountry;
  readonly nameUtf8: Scalars['String'];
  readonly nameAscii: Maybe<Scalars['String']>;
  readonly latitude: Scalars['Float'];
  readonly longitude: Scalars['Float'];
  readonly timezone: GeoTimezone;
  readonly creationDate: Scalars['DateTime'];
  readonly modificationDate: Maybe<Scalars['DateTime']>;
  /**
   * Fipscode (subject to change to iso code), see exceptions below, see file
   * admin1Codes.txt for display names ofthis code; Saved here to set proper states
   */
  readonly admin1Code: Maybe<Scalars['String']>;
  readonly slug: Scalars['String'];
};

export type GeoTimezone = {
  readonly __typename?: 'GeoTimezone';
  readonly uuid: Scalars['UUID'];
  readonly country: GeoCountry;
  readonly code: Maybe<Scalars['String']>;
};

export type GroupStaffingCostBudgetItem = {
  readonly __typename?: 'GroupStaffingCostBudgetItem';
  readonly taskGroup: ProjectTaskGroup;
  readonly project: Project;
  readonly name: Scalars['String'];
  readonly qty: Scalars['Int'];
  readonly discount: Scalars['Int'];
  readonly unitPrice: Scalars['Int'];
  readonly billablePrice: Scalars['Int'];
  readonly description: Maybe<Scalars['String']>;
  readonly createdAt: Scalars['DateTimeImmutable'];
  readonly updatedAt: Scalars['DateTimeImmutable'];
  readonly uuid: Scalars['UUID'];
};

export type Invoice = {
  readonly __typename?: 'Invoice';
  readonly invoiceId: Maybe<Scalars['String']>;
  readonly client: Maybe<Client>;
  readonly issueDate: Maybe<Scalars['DateImmutable']>;
  readonly currency: Maybe<Currency>;
  readonly discount: Maybe<Scalars['Int']>;
  readonly hideDiscountPercent: Scalars['Boolean'];
  readonly notes: Maybe<Scalars['String']>;
  readonly notesForClient: Maybe<Scalars['String']>;
  readonly invoiceGroups: ReadonlyArray<Maybe<InvoiceGroup>>;
  readonly invoiceItems: ReadonlyArray<Maybe<InvoiceItem>>;
  readonly company: Company;
  readonly status: Scalars['String'];
  readonly extendedStatus: Scalars['String'];
  readonly declineReason: Maybe<Scalars['String']>;
  readonly subject: Scalars['String'];
  readonly files: ReadonlyArray<Maybe<File>>;
  readonly supplier: Maybe<Supplier>;
  readonly tax: Maybe<Scalars['Int']>;
  readonly project: Maybe<Project>;
  readonly generalProject: Maybe<GeneralProject>;
  readonly dueDate: Maybe<Scalars['DateImmutable']>;
  readonly dueDateType: Maybe<Scalars['String']>;
  readonly ratesheet: Maybe<Ratesheet>;
  readonly total: Maybe<Scalars['Int']>;
  readonly type: Scalars['String'];
  readonly paidAt: Maybe<Scalars['DateTimeImmutable']>;
  readonly codePO: Maybe<Scalars['String']>;
  readonly noteReviewer: Maybe<Scalars['String']>;
  readonly reviewRequester: Maybe<User>;
  readonly reviewer: Maybe<User>;
  readonly invoicePayments: ReadonlyArray<Maybe<InvoicePayment>>;
  readonly creator: Maybe<User>;
  readonly amountPaid: Maybe<Scalars['Int']>;
  readonly discountAmount: Maybe<Scalars['Int']>;
  readonly isMain: Maybe<Scalars['Boolean']>;
  readonly token: Maybe<Scalars['String']>;
  readonly draft: Scalars['Boolean'];
  readonly paymentReference: Maybe<Scalars['String']>;
  readonly template: Scalars['Boolean'];
  readonly manuallySaved: Scalars['Boolean'];
  readonly deniedBy: Maybe<User>;
  readonly deniedAt: Maybe<Scalars['DateTimeImmutable']>;
  readonly totalCost: Scalars['Int'];
  readonly invoicedAmount: Scalars['Int'];
  readonly checkedForBt: Scalars['Boolean'];
  readonly canSendForReview: Scalars['Boolean'];
  readonly declinedBy: Maybe<Contact>;
  readonly declinedAt: Maybe<Scalars['DateTimeImmutable']>;
  readonly declineNote: Scalars['String'];
  readonly budgetTimingAmount: Scalars['Int'];
  readonly statusNote: Scalars['String'];
  readonly statusChangedAt: Maybe<Scalars['DateTimeImmutable']>;
  readonly statusChangedByContact: Maybe<Contact>;
  readonly statusChangedByUser: Maybe<User>;
  readonly invoiceRequestCreatedDate: Maybe<Scalars['DateImmutable']>;
  readonly attachedEstimate: Maybe<Invoice>;
  readonly invoices: ReadonlyArray<Maybe<Invoice>>;
  readonly snapshotSource: Maybe<Invoice>;
  readonly lastEditedAt: Maybe<Scalars['DateTimeImmutable']>;
  readonly currentEditor: Maybe<User>;
  readonly leadNames: Scalars['String'];
  readonly createdAt: Scalars['DateTimeImmutable'];
  readonly updatedAt: Scalars['DateTimeImmutable'];
  readonly uuid: Scalars['UUID'];
  readonly snapshot: Scalars['Boolean'];
};

export type InvoiceEvent = {
  readonly __typename?: 'InvoiceEvent';
  readonly userUuid: Scalars['String'];
  readonly userName: Scalars['String'];
  readonly date: Maybe<Scalars['DateTimeImmutable']>;
};

export type InvoiceGroup = {
  readonly __typename?: 'InvoiceGroup';
  readonly name: Scalars['String'];
  readonly invoiceItems: ReadonlyArray<Maybe<InvoiceItem>>;
  readonly invoice: Invoice;
  readonly taskGroup: Maybe<TaskGroup>;
  readonly expenseGroup: Maybe<ExpenseGroup>;
  readonly feeGroup: Maybe<FeeGroup>;
  readonly type: Maybe<Scalars['String']>;
  readonly sequence: Maybe<Scalars['Int']>;
  readonly isPinned: Scalars['Boolean'];
  readonly projectExpenseGroup: Maybe<ProjectExpenseGroup>;
  readonly createdAt: Scalars['DateTimeImmutable'];
  readonly updatedAt: Scalars['DateTimeImmutable'];
  readonly uuid: Scalars['UUID'];
  readonly snapshot: Scalars['Boolean'];
};

export type InvoiceItem = {
  readonly __typename?: 'InvoiceItem';
  readonly amount: Maybe<Scalars['Int']>;
  readonly itemType: Scalars['String'];
  readonly type: Maybe<Scalars['String']>;
  readonly status: Maybe<Scalars['String']>;
  readonly projectTask: Maybe<ProjectTask>;
  readonly projectExpense: Maybe<ProjectExpense>;
  readonly invoiceGroup: Maybe<InvoiceGroup>;
  readonly name: Scalars['String'];
  readonly description: Scalars['String'];
  readonly quantity: Maybe<Scalars['Float']>;
  readonly qty1: Scalars['Float'];
  readonly qty2: Scalars['Float'];
  readonly unitPrice: Maybe<Scalars['Float']>;
  readonly billablePrice: Maybe<Scalars['Int']>;
  readonly discount: Maybe<Scalars['Float']>;
  readonly invoice: Invoice;
  readonly tax: Maybe<Scalars['Float']>;
  readonly taxRate: Maybe<TaxRate>;
  readonly spoAmount: Scalars['Int'];
  readonly spoQty1: Scalars['Float'];
  readonly spoQty2: Scalars['Float'];
  readonly task: Maybe<Task>;
  readonly expense: Maybe<Expense>;
  readonly fee: Maybe<Fee>;
  readonly billablePriceMargin: Maybe<Scalars['Float']>;
  readonly discountMargin: Maybe<Scalars['Float']>;
  readonly project: Maybe<Project>;
  readonly sequence: Maybe<Scalars['Int']>;
  readonly isPinned: Scalars['Boolean'];
  readonly SPOs: ReadonlyArray<Maybe<Spo>>;
  readonly globalFee: Scalars['Boolean'];
  readonly feeSources: Maybe<ReadonlyArray<Scalars['String']>>;
  readonly color: Scalars['String'];
  readonly spoItems: ReadonlyArray<Maybe<SpoItem>>;
  readonly inCalc: Scalars['Boolean'];
  readonly isVisibleForCustomer: Scalars['Boolean'];
  readonly teamType: Maybe<TeamCostTeamType>;
  readonly transport: Maybe<DictionaryTransport>;
  readonly itemTransport: Maybe<InvoiceItemTransport>;
  readonly createdAt: Scalars['DateTimeImmutable'];
  readonly updatedAt: Scalars['DateTimeImmutable'];
  readonly uuid: Scalars['UUID'];
  readonly snapshot: Scalars['Boolean'];
};

export type InvoiceItemTransport = {
  readonly __typename?: 'InvoiceItemTransport';
  readonly invoiceItem: Maybe<InvoiceItem>;
  readonly name: Scalars['String'];
  readonly qty: Maybe<Scalars['Int']>;
  readonly distance: Maybe<Scalars['Float']>;
  readonly distanceUnitPrice: Maybe<Scalars['Int']>;
  readonly distanceBillablePrice: Maybe<Scalars['Int']>;
  readonly totalUnitPrice: Maybe<Scalars['Int']>;
  readonly totalBillablePrice: Maybe<Scalars['Int']>;
  readonly totalDistanceUnitPrice: Maybe<Scalars['Int']>;
  readonly costUnitPrice: Maybe<Scalars['Int']>;
  readonly costBillablePrice: Maybe<Scalars['Int']>;
  readonly totalDistanceBillablePrice: Maybe<Scalars['Int']>;
  readonly code: Maybe<Scalars['String']>;
  readonly totalCostUnitPrice: Maybe<Scalars['Int']>;
  readonly totalCostBillablePrice: Maybe<Scalars['Int']>;
  readonly dictionaryTransport: DictionaryTransport;
  readonly handlingUnitPrice: Maybe<Scalars['Int']>;
  readonly handlingBillablePrice: Maybe<Scalars['Int']>;
  readonly createdAt: Scalars['DateTimeImmutable'];
  readonly updatedAt: Scalars['DateTimeImmutable'];
  readonly uuid: Scalars['UUID'];
  readonly snapshot: Scalars['Boolean'];
};

export type InvoicePayment = {
  readonly __typename?: 'InvoicePayment';
  readonly description: Maybe<Scalars['String']>;
  readonly amount: Scalars['Int'];
  readonly invoice: Invoice;
  readonly date: Maybe<Scalars['DateImmutable']>;
  readonly createdAt: Scalars['DateTimeImmutable'];
  readonly updatedAt: Scalars['DateTimeImmutable'];
  readonly uuid: Scalars['UUID'];
  readonly snapshot: Scalars['Boolean'];
};

export enum InvoicePermission {
  View = 'VIEW',
  Edit = 'EDIT',
  Duplicate = 'DUPLICATE',
  Delete = 'DELETE',
  Export = 'EXPORT',
  SendForApproval = 'SEND_FOR_APPROVAL',
  SendToClient = 'SEND_TO_CLIENT',
  Approve = 'APPROVE',
  Confirm = 'CONFIRM',
  Decline = 'DECLINE',
  RevertStatus = 'REVERT_STATUS',
  ChangeStatus = 'CHANGE_STATUS'
}


export type Knowledge = {
  readonly __typename?: 'Knowledge';
  readonly type: Scalars['String'];
  readonly level: Maybe<Scalars['String']>;
  readonly name: Scalars['String'];
  readonly code: Maybe<Scalars['String']>;
  readonly externalUser: ExternalUser;
  readonly uuid: Scalars['UUID'];
  readonly createdAt: Scalars['DateTimeImmutable'];
  readonly updatedAt: Scalars['DateTimeImmutable'];
};

export enum KnowledgeLevel {
  None = 'NONE',
  Basic = 'BASIC',
  Good = 'GOOD',
  Excellent = 'EXCELLENT',
  Professional = 'PROFESSIONAL',
  Native = 'NATIVE'
}

export enum LanguageCode {
  Nl = 'NL',
  Fr = 'FR',
  En = 'EN',
  De = 'DE'
}

export type LeaveHolidayAssignment = {
  readonly __typename?: 'LeaveHolidayAssignment';
  readonly user: Maybe<User>;
  readonly type: Maybe<LeaveHolidayType>;
  readonly timeslots: ReadonlyArray<Maybe<ProjectTaskAssignmentTimeslot>>;
  readonly createdAt: Scalars['DateTimeImmutable'];
  readonly updatedAt: Scalars['DateTimeImmutable'];
  readonly uuid: Scalars['UUID'];
};

export type LeaveHolidayType = {
  readonly __typename?: 'LeaveHolidayType';
  readonly title: Scalars['String'];
  readonly description: Maybe<Scalars['String']>;
  readonly status: Scalars['String'];
  readonly yearlyLimit: Scalars['Int'];
  readonly occupationType: Maybe<OccupationType>;
  readonly company: Maybe<Company>;
  readonly isBillable: Scalars['Boolean'];
  readonly createdAt: Scalars['DateTimeImmutable'];
  readonly updatedAt: Scalars['DateTimeImmutable'];
  readonly uuid: Scalars['UUID'];
};

export type ManualBookInput = {
  readonly uuid: Scalars['UUID'];
  readonly compositionRoleUuid: Scalars['UUID'];
};

export type Material = {
  readonly __typename?: 'Material';
  readonly iceBox: Scalars['Boolean'];
  readonly name: Maybe<Scalars['String']>;
  readonly unitPrice: Maybe<Scalars['Int']>;
  readonly billablePrice: Maybe<Scalars['Int']>;
  readonly type: Maybe<Scalars['String']>;
  readonly displayPriority: Maybe<Scalars['Int']>;
  readonly uuid: Scalars['UUID'];
  readonly createdAt: Scalars['DateTimeImmutable'];
  readonly updatedAt: Scalars['DateTimeImmutable'];
};

export type MaterialCostBudgetItem = {
  readonly __typename?: 'MaterialCostBudgetItem';
  readonly materialGroupItem: ProjectMaterialGroupItem;
  readonly project: Project;
  readonly name: Scalars['String'];
  readonly qty: Scalars['Int'];
  readonly discount: Scalars['Int'];
  readonly unitPrice: Scalars['Int'];
  readonly billablePrice: Scalars['Int'];
  readonly description: Maybe<Scalars['String']>;
  readonly createdAt: Scalars['DateTimeImmutable'];
  readonly updatedAt: Scalars['DateTimeImmutable'];
  readonly uuid: Scalars['UUID'];
};

export type MaterialGroupItem = {
  readonly __typename?: 'MaterialGroupItem';
  readonly projectMaterialGroupItem: ProjectMaterialGroupItem;
  readonly actionTeam: Maybe<ActionTeam>;
  readonly qty: Maybe<Scalars['Int']>;
  readonly estimated: Maybe<Scalars['Float']>;
  readonly transported: Maybe<Scalars['Float']>;
  readonly inTray: Maybe<Scalars['Int']>;
  readonly inLayer: Maybe<Scalars['Int']>;
  readonly inPalet: Maybe<Scalars['Int']>;
  readonly actionMaterials: ReadonlyArray<Maybe<ActionMaterial>>;
  readonly inChecklist: Scalars['Boolean'];
  readonly iceBoxes: Maybe<Scalars['Int']>;
  readonly layersOnPallet: Maybe<Scalars['Int']>;
  readonly iceCubes: Maybe<Scalars['Int']>;
  readonly createdAt: Scalars['DateTimeImmutable'];
  readonly updatedAt: Scalars['DateTimeImmutable'];
  readonly uuid: Scalars['UUID'];
};

export type Mutation = {
  readonly __typename?: 'Mutation';
  readonly publish_action: Action;
  readonly unpublish_action: Action;
  readonly update_action_by_client: Action;
  readonly action_planning_item_distribute: ActionPlanningItem;
  readonly create_sub_action_team: ActionTeam;
  readonly manual_book_person: BookingPerson;
  readonly save_booking_person_performance: BookingPersonPerformance;
  readonly update_booking_person_movement: BookingPersonMovement;
  readonly create_booking_person_movement: BookingPersonMovement;
  readonly add_company_holiday: CompanyHoliday;
  readonly delete_company_holiday: Scalars['UUID'];
  readonly delete_company_payroll_rule: Scalars['UUID'];
  readonly set_company_payroll_code: ReadonlyArray<CompanyPayrollCodeItem>;
  readonly set_company_payroll_rule: CompanyPayrollRule;
  readonly contract_upload_attentia_calculations: ContractUploadAttentiaCalculationsResponse;
  readonly update_contract: Contract;
  readonly sign_contract: Contract;
  readonly sign_performance: Contract;
  readonly update_external_user: ExternalUser;
  readonly submit_form: Scalars['Boolean'];
  readonly add_leave_holiday_assignment: ProjectTaskAssignmentTimeslot;
  readonly delete_leave_holiday_assignment: ReadonlyArray<Scalars['UUID']>;
  readonly update_leave_holiday_assignment: LeaveHolidayAssignment;
  readonly add_project_task_assignment: ProjectTaskAssignment;
  readonly delete_project_task_assignment: ReadonlyArray<Scalars['UUID']>;
  readonly update_project_task_assignment: ProjectTaskAssignment;
  readonly update_project_task: ProjectTask;
  readonly add_quantity_type: QuantityType;
  readonly add_time_track: TimeTrack;
  readonly delete_time_track: ReadonlyArray<Scalars['UUID']>;
  readonly toggle_time_track: TimeTrack;
  readonly update_time_track: TimeTrack;
};


export type MutationPublishActionArgs = {
  input: PublishActionInput;
};


export type MutationUnpublishActionArgs = {
  input: UnpublishActionInput;
};


export type MutationUpdateActionByClientArgs = {
  input: UpdateActionByClientInput;
};


export type MutationActionPlanningItemDistributeArgs = {
  input: ActionPlanningItemDistributeInput;
};


export type MutationCreateSubActionTeamArgs = {
  input: CreateSubActionTeamInput;
};


export type MutationManualBookPersonArgs = {
  input: ManualBookInput;
};


export type MutationSaveBookingPersonPerformanceArgs = {
  input: BookingPersonPerformanceInput;
};


export type MutationUpdateBookingPersonMovementArgs = {
  input: BookingPersonMovementInput;
};


export type MutationCreateBookingPersonMovementArgs = {
  input: CreateBookingPersonMovementInput;
};


export type MutationAddCompanyHolidayArgs = {
  input: AddCompanyHolidayInput;
};


export type MutationDeleteCompanyHolidayArgs = {
  input: DeleteCompanyHolidayInput;
};


export type MutationDeleteCompanyPayrollRuleArgs = {
  input: DeleteCompanyPayrollRuleInput;
};


export type MutationSetCompanyPayrollCodeArgs = {
  input: SetCompanyPayrollCodeInput;
};


export type MutationSetCompanyPayrollRuleArgs = {
  input: SetCompanyPayrollRuleInput;
};


export type MutationContractUploadAttentiaCalculationsArgs = {
  input: ContractUploadAttentiaCalculationsInput;
};


export type MutationUpdateContractArgs = {
  input: ContractInput;
};


export type MutationSignContractArgs = {
  input: SignContractInput;
};


export type MutationSignPerformanceArgs = {
  input: SignPerformanceInput;
};


export type MutationUpdateExternalUserArgs = {
  input: ExternalUserUpdateInput;
};


export type MutationSubmitFormArgs = {
  input: SubmitFormInput;
};


export type MutationAddLeaveHolidayAssignmentArgs = {
  input: AddLeaveHolidayAssignmentInput;
};


export type MutationDeleteLeaveHolidayAssignmentArgs = {
  input: DeleteLeaveHolidayAssignmentInput;
};


export type MutationUpdateLeaveHolidayAssignmentArgs = {
  input: UpdateLeaveHolidayAssignmentInput;
};


export type MutationAddProjectTaskAssignmentArgs = {
  input: AddProjectTaskAssignmentInput;
};


export type MutationDeleteProjectTaskAssignmentArgs = {
  input: DeleteProjectTaskAssignmentInput;
};


export type MutationUpdateProjectTaskAssignmentArgs = {
  input: UpdateProjectTaskAssignmentInput;
};


export type MutationUpdateProjectTaskArgs = {
  input: UpdateProjectTaskInput;
};


export type MutationAddQuantityTypeArgs = {
  input: AddQuantityTypeInput;
};


export type MutationAddTimeTrackArgs = {
  input: AddTimeTrackInput;
};


export type MutationDeleteTimeTrackArgs = {
  input: DeleteTimeTrackInput;
};


export type MutationToggleTimeTrackArgs = {
  input: ToggleTimeTrackInput;
};


export type MutationUpdateTimeTrackArgs = {
  input: UpdateTimeTrackInput;
};

export type Nationality = {
  readonly __typename?: 'Nationality';
  readonly name: Scalars['String'];
  readonly code: Maybe<Scalars['String']>;
  readonly pointhrCode: Maybe<Scalars['String']>;
  readonly uuid: Scalars['UUID'];
  readonly createdAt: Scalars['DateTimeImmutable'];
  readonly updatedAt: Scalars['DateTimeImmutable'];
};

export type OccupationType = {
  readonly __typename?: 'OccupationType';
  readonly name: Scalars['String'];
  readonly description: Maybe<Scalars['String']>;
  readonly status: Scalars['String'];
  readonly leaveHolidayTypes: ReadonlyArray<Maybe<LeaveHolidayType>>;
  readonly company: Maybe<Company>;
  readonly createdAt: Scalars['DateTimeImmutable'];
  readonly updatedAt: Scalars['DateTimeImmutable'];
  readonly uuid: Scalars['UUID'];
};

export enum Permission {
  ObjectsCompanyView = 'OBJECTS_COMPANY_VIEW',
  ObjectsCompanyEdit = 'OBJECTS_COMPANY_EDIT',
  ObjectsProjectCreate = 'OBJECTS_PROJECT_CREATE',
  ObjectsProjectAllView = 'OBJECTS_PROJECT_ALL_VIEW',
  ObjectsProjectAllEdit = 'OBJECTS_PROJECT_ALL_EDIT',
  ObjectsProjectAllDuplicate = 'OBJECTS_PROJECT_ALL_DUPLICATE',
  ObjectsProjectAllEditBt = 'OBJECTS_PROJECT_ALL_EDIT_BT',
  ObjectsProjectAllForceExecuted = 'OBJECTS_PROJECT_ALL_FORCE_EXECUTED',
  ObjectsProjectLeadView = 'OBJECTS_PROJECT_LEAD_VIEW',
  ObjectsProjectLeadEdit = 'OBJECTS_PROJECT_LEAD_EDIT',
  ObjectsProjectLeadDuplicate = 'OBJECTS_PROJECT_LEAD_DUPLICATE',
  ObjectsProjectLeadEditBt = 'OBJECTS_PROJECT_LEAD_EDIT_BT',
  ObjectsProjectLeadForceExecuted = 'OBJECTS_PROJECT_LEAD_FORCE_EXECUTED',
  ObjectsProjectSupportView = 'OBJECTS_PROJECT_SUPPORT_VIEW',
  ObjectsProjectSupportEdit = 'OBJECTS_PROJECT_SUPPORT_EDIT',
  ObjectsProjectSupportDuplicate = 'OBJECTS_PROJECT_SUPPORT_DUPLICATE',
  ObjectsProjectSupportEditBt = 'OBJECTS_PROJECT_SUPPORT_EDIT_BT',
  ObjectsProjectSupportForceExecuted = 'OBJECTS_PROJECT_SUPPORT_FORCE_EXECUTED',
  ObjectsProjectGroupCreate = 'OBJECTS_PROJECT_GROUP_CREATE',
  ObjectsProjectGroupEdit = 'OBJECTS_PROJECT_GROUP_EDIT',
  ObjectsProjectGroupDelete = 'OBJECTS_PROJECT_GROUP_DELETE',
  ObjectsSpoCreate = 'OBJECTS_SPO_CREATE',
  ObjectsSpoAllView = 'OBJECTS_SPO_ALL_VIEW',
  ObjectsSpoAllEdit = 'OBJECTS_SPO_ALL_EDIT',
  ObjectsSpoAllEditAfterReview = 'OBJECTS_SPO_ALL_EDIT_AFTER_REVIEW',
  ObjectsSpoAllFlag = 'OBJECTS_SPO_ALL_FLAG',
  ObjectsSpoAllChangeStatus = 'OBJECTS_SPO_ALL_CHANGE_STATUS',
  ObjectsSpoAllDuplicate = 'OBJECTS_SPO_ALL_DUPLICATE',
  ObjectsSpoAllApprove = 'OBJECTS_SPO_ALL_APPROVE',
  ObjectsSpoLeadView = 'OBJECTS_SPO_LEAD_VIEW',
  ObjectsSpoLeadEdit = 'OBJECTS_SPO_LEAD_EDIT',
  ObjectsSpoLeadEditAfterReview = 'OBJECTS_SPO_LEAD_EDIT_AFTER_REVIEW',
  ObjectsSpoLeadFlag = 'OBJECTS_SPO_LEAD_FLAG',
  ObjectsSpoLeadChangeStatus = 'OBJECTS_SPO_LEAD_CHANGE_STATUS',
  ObjectsSpoLeadDuplicate = 'OBJECTS_SPO_LEAD_DUPLICATE',
  ObjectsSpoLeadApprove = 'OBJECTS_SPO_LEAD_APPROVE',
  ObjectsSpoSupportView = 'OBJECTS_SPO_SUPPORT_VIEW',
  ObjectsSpoSupportEdit = 'OBJECTS_SPO_SUPPORT_EDIT',
  ObjectsSpoSupportEditAfterReview = 'OBJECTS_SPO_SUPPORT_EDIT_AFTER_REVIEW',
  ObjectsSpoSupportFlag = 'OBJECTS_SPO_SUPPORT_FLAG',
  ObjectsSpoSupportChangeStatus = 'OBJECTS_SPO_SUPPORT_CHANGE_STATUS',
  ObjectsSpoSupportDuplicate = 'OBJECTS_SPO_SUPPORT_DUPLICATE',
  ObjectsSpoSupportApprove = 'OBJECTS_SPO_SUPPORT_APPROVE',
  ObjectsEstimateSetAsBudgetTemplate = 'OBJECTS_ESTIMATE_SET_AS_BUDGET_TEMPLATE',
  ObjectsEstimateAllView = 'OBJECTS_ESTIMATE_ALL_VIEW',
  ObjectsEstimateAllCreate = 'OBJECTS_ESTIMATE_ALL_CREATE',
  ObjectsEstimateAllEdit = 'OBJECTS_ESTIMATE_ALL_EDIT',
  ObjectsEstimateAllEditAfterReview = 'OBJECTS_ESTIMATE_ALL_EDIT_AFTER_REVIEW',
  ObjectsEstimateAllDuplicate = 'OBJECTS_ESTIMATE_ALL_DUPLICATE',
  ObjectsEstimateAllDelete = 'OBJECTS_ESTIMATE_ALL_DELETE',
  ObjectsEstimateAllExport = 'OBJECTS_ESTIMATE_ALL_EXPORT',
  ObjectsEstimateAllSendForApproval = 'OBJECTS_ESTIMATE_ALL_SEND_FOR_APPROVAL',
  ObjectsEstimateAllSendToClient = 'OBJECTS_ESTIMATE_ALL_SEND_TO_CLIENT',
  ObjectsEstimateAllApprove = 'OBJECTS_ESTIMATE_ALL_APPROVE',
  ObjectsEstimateAllConfirm = 'OBJECTS_ESTIMATE_ALL_CONFIRM',
  ObjectsEstimateAllDecline = 'OBJECTS_ESTIMATE_ALL_DECLINE',
  ObjectsEstimateAllRevertStatus = 'OBJECTS_ESTIMATE_ALL_REVERT_STATUS',
  ObjectsEstimateAllChangeStatus = 'OBJECTS_ESTIMATE_ALL_CHANGE_STATUS',
  ObjectsEstimateLeadView = 'OBJECTS_ESTIMATE_LEAD_VIEW',
  ObjectsEstimateLeadCreate = 'OBJECTS_ESTIMATE_LEAD_CREATE',
  ObjectsEstimateLeadEdit = 'OBJECTS_ESTIMATE_LEAD_EDIT',
  ObjectsEstimateLeadEditAfterReview = 'OBJECTS_ESTIMATE_LEAD_EDIT_AFTER_REVIEW',
  ObjectsEstimateLeadDuplicate = 'OBJECTS_ESTIMATE_LEAD_DUPLICATE',
  ObjectsEstimateLeadDelete = 'OBJECTS_ESTIMATE_LEAD_DELETE',
  ObjectsEstimateLeadExport = 'OBJECTS_ESTIMATE_LEAD_EXPORT',
  ObjectsEstimateLeadSendForApproval = 'OBJECTS_ESTIMATE_LEAD_SEND_FOR_APPROVAL',
  ObjectsEstimateLeadSendToClient = 'OBJECTS_ESTIMATE_LEAD_SEND_TO_CLIENT',
  ObjectsEstimateLeadApprove = 'OBJECTS_ESTIMATE_LEAD_APPROVE',
  ObjectsEstimateLeadConfirm = 'OBJECTS_ESTIMATE_LEAD_CONFIRM',
  ObjectsEstimateLeadDecline = 'OBJECTS_ESTIMATE_LEAD_DECLINE',
  ObjectsEstimateLeadRevertStatus = 'OBJECTS_ESTIMATE_LEAD_REVERT_STATUS',
  ObjectsEstimateLeadChangeStatus = 'OBJECTS_ESTIMATE_LEAD_CHANGE_STATUS',
  ObjectsEstimateSupportView = 'OBJECTS_ESTIMATE_SUPPORT_VIEW',
  ObjectsEstimateSupportCreate = 'OBJECTS_ESTIMATE_SUPPORT_CREATE',
  ObjectsEstimateSupportEdit = 'OBJECTS_ESTIMATE_SUPPORT_EDIT',
  ObjectsEstimateSupportEditAfterReview = 'OBJECTS_ESTIMATE_SUPPORT_EDIT_AFTER_REVIEW',
  ObjectsEstimateSupportDuplicate = 'OBJECTS_ESTIMATE_SUPPORT_DUPLICATE',
  ObjectsEstimateSupportDelete = 'OBJECTS_ESTIMATE_SUPPORT_DELETE',
  ObjectsEstimateSupportExport = 'OBJECTS_ESTIMATE_SUPPORT_EXPORT',
  ObjectsEstimateSupportSendForApproval = 'OBJECTS_ESTIMATE_SUPPORT_SEND_FOR_APPROVAL',
  ObjectsEstimateSupportSendToClient = 'OBJECTS_ESTIMATE_SUPPORT_SEND_TO_CLIENT',
  ObjectsEstimateSupportApprove = 'OBJECTS_ESTIMATE_SUPPORT_APPROVE',
  ObjectsEstimateSupportConfirm = 'OBJECTS_ESTIMATE_SUPPORT_CONFIRM',
  ObjectsEstimateSupportDecline = 'OBJECTS_ESTIMATE_SUPPORT_DECLINE',
  ObjectsEstimateSupportRevertStatus = 'OBJECTS_ESTIMATE_SUPPORT_REVERT_STATUS',
  ObjectsEstimateSupportChangeStatus = 'OBJECTS_ESTIMATE_SUPPORT_CHANGE_STATUS',
  ObjectsInvoiceAllView = 'OBJECTS_INVOICE_ALL_VIEW',
  ObjectsInvoiceAllCreate = 'OBJECTS_INVOICE_ALL_CREATE',
  ObjectsInvoiceAllEdit = 'OBJECTS_INVOICE_ALL_EDIT',
  ObjectsInvoiceAllDuplicate = 'OBJECTS_INVOICE_ALL_DUPLICATE',
  ObjectsInvoiceAllDelete = 'OBJECTS_INVOICE_ALL_DELETE',
  ObjectsInvoiceAllExport = 'OBJECTS_INVOICE_ALL_EXPORT',
  ObjectsInvoiceAllSendToClient = 'OBJECTS_INVOICE_ALL_SEND_TO_CLIENT',
  ObjectsInvoiceAllApprove = 'OBJECTS_INVOICE_ALL_APPROVE',
  ObjectsInvoiceAllDecline = 'OBJECTS_INVOICE_ALL_DECLINE',
  ObjectsInvoiceAllHtmlPreview = 'OBJECTS_INVOICE_ALL_HTML_PREVIEW',
  ObjectsInvoiceLeadView = 'OBJECTS_INVOICE_LEAD_VIEW',
  ObjectsInvoiceLeadCreate = 'OBJECTS_INVOICE_LEAD_CREATE',
  ObjectsInvoiceLeadEdit = 'OBJECTS_INVOICE_LEAD_EDIT',
  ObjectsInvoiceLeadDuplicate = 'OBJECTS_INVOICE_LEAD_DUPLICATE',
  ObjectsInvoiceLeadDelete = 'OBJECTS_INVOICE_LEAD_DELETE',
  ObjectsInvoiceLeadExport = 'OBJECTS_INVOICE_LEAD_EXPORT',
  ObjectsInvoiceLeadSendToClient = 'OBJECTS_INVOICE_LEAD_SEND_TO_CLIENT',
  ObjectsInvoiceLeadApprove = 'OBJECTS_INVOICE_LEAD_APPROVE',
  ObjectsInvoiceLeadDecline = 'OBJECTS_INVOICE_LEAD_DECLINE',
  ObjectsInvoiceSupportView = 'OBJECTS_INVOICE_SUPPORT_VIEW',
  ObjectsInvoiceSupportCreate = 'OBJECTS_INVOICE_SUPPORT_CREATE',
  ObjectsInvoiceSupportEdit = 'OBJECTS_INVOICE_SUPPORT_EDIT',
  ObjectsInvoiceSupportDuplicate = 'OBJECTS_INVOICE_SUPPORT_DUPLICATE',
  ObjectsInvoiceSupportDelete = 'OBJECTS_INVOICE_SUPPORT_DELETE',
  ObjectsInvoiceSupportExport = 'OBJECTS_INVOICE_SUPPORT_EXPORT',
  ObjectsInvoiceSupportSendToClient = 'OBJECTS_INVOICE_SUPPORT_SEND_TO_CLIENT',
  ObjectsInvoiceSupportApprove = 'OBJECTS_INVOICE_SUPPORT_APPROVE',
  ObjectsInvoiceSupportDecline = 'OBJECTS_INVOICE_SUPPORT_DECLINE',
  ObjectsClientView = 'OBJECTS_CLIENT_VIEW',
  ObjectsClientCreate = 'OBJECTS_CLIENT_CREATE',
  ObjectsClientEdit = 'OBJECTS_CLIENT_EDIT',
  ObjectsClientDuplicate = 'OBJECTS_CLIENT_DUPLICATE',
  ObjectsClientDelete = 'OBJECTS_CLIENT_DELETE',
  ObjectsClientImport = 'OBJECTS_CLIENT_IMPORT',
  ObjectsClientCreateWithoutVatNumber = 'OBJECTS_CLIENT_CREATE_WITHOUT_VAT_NUMBER',
  ObjectsSupplierView = 'OBJECTS_SUPPLIER_VIEW',
  ObjectsSupplierCreate = 'OBJECTS_SUPPLIER_CREATE',
  ObjectsSupplierEdit = 'OBJECTS_SUPPLIER_EDIT',
  ObjectsSupplierDuplicate = 'OBJECTS_SUPPLIER_DUPLICATE',
  ObjectsSupplierDelete = 'OBJECTS_SUPPLIER_DELETE',
  ObjectsSupplierImport = 'OBJECTS_SUPPLIER_IMPORT',
  ObjectsSupplierCreateWithoutVatNumber = 'OBJECTS_SUPPLIER_CREATE_WITHOUT_VAT_NUMBER',
  ObjectsContactView = 'OBJECTS_CONTACT_VIEW',
  ObjectsContactCreate = 'OBJECTS_CONTACT_CREATE',
  ObjectsContactEdit = 'OBJECTS_CONTACT_EDIT',
  ObjectsContactDuplicate = 'OBJECTS_CONTACT_DUPLICATE',
  ObjectsContactDelete = 'OBJECTS_CONTACT_DELETE',
  ObjectsContractTemplateView = 'OBJECTS_CONTRACT_TEMPLATE_VIEW',
  ObjectsContractTemplateCreate = 'OBJECTS_CONTRACT_TEMPLATE_CREATE',
  ObjectsContractTemplateEdit = 'OBJECTS_CONTRACT_TEMPLATE_EDIT',
  ObjectsContractTemplateArchive = 'OBJECTS_CONTRACT_TEMPLATE_ARCHIVE',
  ObjectsContractTemplateDelete = 'OBJECTS_CONTRACT_TEMPLATE_DELETE',
  ObjectsUserView = 'OBJECTS_USER_VIEW',
  ObjectsUserCreate = 'OBJECTS_USER_CREATE',
  ObjectsUserEdit = 'OBJECTS_USER_EDIT',
  ObjectsUserDelete = 'OBJECTS_USER_DELETE',
  ObjectsTaskView = 'OBJECTS_TASK_VIEW',
  ObjectsTaskCreate = 'OBJECTS_TASK_CREATE',
  ObjectsTaskEdit = 'OBJECTS_TASK_EDIT',
  ObjectsTaskDelete = 'OBJECTS_TASK_DELETE',
  ObjectsExpenseView = 'OBJECTS_EXPENSE_VIEW',
  ObjectsExpenseCreate = 'OBJECTS_EXPENSE_CREATE',
  ObjectsExpenseEdit = 'OBJECTS_EXPENSE_EDIT',
  ObjectsExpenseDelete = 'OBJECTS_EXPENSE_DELETE',
  ObjectsRateSheetsView = 'OBJECTS_RATE_SHEETS_VIEW',
  ObjectsRateSheetsCreate = 'OBJECTS_RATE_SHEETS_CREATE',
  ObjectsRateSheetsDuplicate = 'OBJECTS_RATE_SHEETS_DUPLICATE',
  ObjectsRateSheetsEdit = 'OBJECTS_RATE_SHEETS_EDIT',
  ObjectsRateSheetsDelete = 'OBJECTS_RATE_SHEETS_DELETE',
  ObjectsBudgetTemplateView = 'OBJECTS_BUDGET_TEMPLATE_VIEW',
  ObjectsBudgetTemplateCreate = 'OBJECTS_BUDGET_TEMPLATE_CREATE',
  ObjectsBudgetTemplateDuplicate = 'OBJECTS_BUDGET_TEMPLATE_DUPLICATE',
  ObjectsBudgetTemplateEdit = 'OBJECTS_BUDGET_TEMPLATE_EDIT',
  ObjectsBudgetTemplateDelete = 'OBJECTS_BUDGET_TEMPLATE_DELETE',
  ObjectsTaxRateView = 'OBJECTS_TAX_RATE_VIEW',
  ObjectsTaxRateCreate = 'OBJECTS_TAX_RATE_CREATE',
  ObjectsTaxRateEdit = 'OBJECTS_TAX_RATE_EDIT',
  ObjectsTaxRateDelete = 'OBJECTS_TAX_RATE_DELETE',
  ObjectsTeamCostRoleView = 'OBJECTS_TEAM_COST_ROLE_VIEW',
  ObjectsTeamCostRoleCreate = 'OBJECTS_TEAM_COST_ROLE_CREATE',
  ObjectsTeamCostRoleEdit = 'OBJECTS_TEAM_COST_ROLE_EDIT',
  ObjectsTeamCostRoleDelete = 'OBJECTS_TEAM_COST_ROLE_DELETE',
  ObjectsTeamCostServiceView = 'OBJECTS_TEAM_COST_SERVICE_VIEW',
  ObjectsTeamCostServiceCreate = 'OBJECTS_TEAM_COST_SERVICE_CREATE',
  ObjectsTeamCostServiceEdit = 'OBJECTS_TEAM_COST_SERVICE_EDIT',
  ObjectsTeamCostServiceDelete = 'OBJECTS_TEAM_COST_SERVICE_DELETE',
  ObjectsTeamCostTransportView = 'OBJECTS_TEAM_COST_TRANSPORT_VIEW',
  ObjectsTeamCostTransportCreate = 'OBJECTS_TEAM_COST_TRANSPORT_CREATE',
  ObjectsTeamCostTransportEdit = 'OBJECTS_TEAM_COST_TRANSPORT_EDIT',
  ObjectsTeamCostTransportDelete = 'OBJECTS_TEAM_COST_TRANSPORT_DELETE',
  ObjectsTeamCostViaCompanyView = 'OBJECTS_TEAM_COST_VIA_COMPANY_VIEW',
  ObjectsTeamCostViaCompanyCreate = 'OBJECTS_TEAM_COST_VIA_COMPANY_CREATE',
  ObjectsTeamCostViaCompanyEdit = 'OBJECTS_TEAM_COST_VIA_COMPANY_EDIT',
  ObjectsTeamCostViaCompanyDelete = 'OBJECTS_TEAM_COST_VIA_COMPANY_DELETE',
  ObjectsTeamCostLevelView = 'OBJECTS_TEAM_COST_LEVEL_VIEW',
  ObjectsTeamCostLevelCreate = 'OBJECTS_TEAM_COST_LEVEL_CREATE',
  ObjectsTeamCostLevelEdit = 'OBJECTS_TEAM_COST_LEVEL_EDIT',
  ObjectsTeamCostLevelDelete = 'OBJECTS_TEAM_COST_LEVEL_DELETE',
  ObjectsTeamCostJointCommitteeView = 'OBJECTS_TEAM_COST_JOINT_COMMITTEE_VIEW',
  ObjectsTeamCostJointCommitteeCreate = 'OBJECTS_TEAM_COST_JOINT_COMMITTEE_CREATE',
  ObjectsTeamCostJointCommitteeEdit = 'OBJECTS_TEAM_COST_JOINT_COMMITTEE_EDIT',
  ObjectsTeamCostJointCommitteeDelete = 'OBJECTS_TEAM_COST_JOINT_COMMITTEE_DELETE',
  ObjectsAgendaOccupationTypeView = 'OBJECTS_AGENDA_OCCUPATION_TYPE_VIEW',
  ObjectsAgendaOccupationTypeCreate = 'OBJECTS_AGENDA_OCCUPATION_TYPE_CREATE',
  ObjectsAgendaOccupationTypeEdit = 'OBJECTS_AGENDA_OCCUPATION_TYPE_EDIT',
  ObjectsAgendaOccupationTypeDelete = 'OBJECTS_AGENDA_OCCUPATION_TYPE_DELETE',
  ObjectsAgendaLeaveTypeView = 'OBJECTS_AGENDA_LEAVE_TYPE_VIEW',
  ObjectsAgendaLeaveTypeCreate = 'OBJECTS_AGENDA_LEAVE_TYPE_CREATE',
  ObjectsAgendaLeaveTypeEdit = 'OBJECTS_AGENDA_LEAVE_TYPE_EDIT',
  ObjectsAgendaLeaveTypeDelete = 'OBJECTS_AGENDA_LEAVE_TYPE_DELETE',
  ObjectsTeamCostTeamTypeView = 'OBJECTS_TEAM_COST_TEAM_TYPE_VIEW',
  ObjectsTeamCostTeamTypeCreate = 'OBJECTS_TEAM_COST_TEAM_TYPE_CREATE',
  ObjectsTeamCostTeamTypeEdit = 'OBJECTS_TEAM_COST_TEAM_TYPE_EDIT',
  ObjectsTeamCostTeamTypeDelete = 'OBJECTS_TEAM_COST_TEAM_TYPE_DELETE',
  ObjectsExternalUserView = 'OBJECTS_EXTERNAL_USER_VIEW',
  ObjectsExternalUserViewFullDetails = 'OBJECTS_EXTERNAL_USER_VIEW_FULL_DETAILS',
  ObjectsExternalUserCreate = 'OBJECTS_EXTERNAL_USER_CREATE',
  ObjectsExternalUserEdit = 'OBJECTS_EXTERNAL_USER_EDIT',
  ObjectsExternalUserDelete = 'OBJECTS_EXTERNAL_USER_DELETE',
  InterfaceControlCenter = 'INTERFACE_CONTROL_CENTER',
  InterfaceCompanyManage = 'INTERFACE_COMPANY_MANAGE',
  InterfaceCompanyManageProjects = 'INTERFACE_COMPANY_MANAGE_PROJECTS',
  InterfaceCompanyManagePlanner = 'INTERFACE_COMPANY_MANAGE_PLANNER',
  InterfaceCompanyManageAgenda = 'INTERFACE_COMPANY_MANAGE_AGENDA',
  InterfaceCompanyManageFinancial = 'INTERFACE_COMPANY_MANAGE_FINANCIAL',
  InterfaceCompanyManageFinancialBudgetTimingExport = 'INTERFACE_COMPANY_MANAGE_FINANCIAL_BUDGET_TIMING_EXPORT',
  InterfaceCompanyManageFinancialBudgetTimingExportRaw = 'INTERFACE_COMPANY_MANAGE_FINANCIAL_BUDGET_TIMING_EXPORT_RAW',
  InterfaceCompanyManageFinancialBudgetTimingExportTimeTracking = 'INTERFACE_COMPANY_MANAGE_FINANCIAL_BUDGET_TIMING_EXPORT_TIME_TRACKING',
  InterfaceCompanyManageManage = 'INTERFACE_COMPANY_MANAGE_MANAGE',
  InterfaceTimeTracking = 'INTERFACE_TIME_TRACKING',
  InterfaceHr = 'INTERFACE_HR',
  InterfaceHrLoginAs = 'INTERFACE_HR_LOGIN_AS',
  InterfaceHrEditBookedAction = 'INTERFACE_HR_EDIT_BOOKED_ACTION',
  InterfaceHrEditClosedPaidContract = 'INTERFACE_HR_EDIT_CLOSED_PAID_CONTRACT'
}

export type PersonSelectListItem = {
  readonly __typename?: 'PersonSelectListItem';
  readonly externalUser: ExternalUser;
  readonly compositionRole: Maybe<TcCompositionRole>;
  readonly viaCompanyDistance: Maybe<Scalars['Float']>;
  readonly eventDistance: Maybe<Scalars['Float']>;
};

export type PersonSelectListPaginator = {
  readonly __typename?: 'PersonSelectListPaginator';
  readonly items: ReadonlyArray<PersonSelectListItem>;
  readonly page: Scalars['Int'];
  readonly limit: Scalars['Int'];
  readonly total: Scalars['Int'];
  /**
   * *     Hash of query parameters.
   * *
   */
  readonly hash: Scalars['String'];
  readonly hasMore: Scalars['Boolean'];
};

export type PersonSelectListQueryInput = {
  readonly sort?: Maybe<ReadonlyArray<PersonSelectListSortItem>>;
  readonly uuids?: Maybe<ReadonlyArray<Scalars['UUID']>>;
  readonly actionUuid: Scalars['UUID'];
  readonly bookable?: Maybe<Scalars['Boolean']>;
  readonly volunteered?: Maybe<Scalars['Boolean']>;
  readonly treatCompletedActionAsBookable?: Maybe<Scalars['Boolean']>;
  readonly availabilities?: Maybe<ReadonlyArray<BookingPersonsAvailability>>;
  readonly languageCodes?: Maybe<ReadonlyArray<LanguageCode>>;
  readonly minimalKnowledge?: Maybe<KnowledgeLevel>;
  readonly preferredLanguage?: Maybe<ReadonlyArray<LanguageCode>>;
  readonly drivingLicenses?: Maybe<ReadonlyArray<ExternalUsersDrivingLicense>>;
  readonly tagsUuids?: Maybe<ReadonlyArray<Scalars['UUID']>>;
  /**
   * *     Accepts natural number.
   * *
   */
  readonly companyDistanceFrom?: Maybe<Scalars['Int']>;
  /**
   * *     Accepts natural number.
   * *
   */
  readonly companyDistanceTo?: Maybe<Scalars['Int']>;
  /**
   * *     Accepts natural number.
   * *
   */
  readonly eventDistanceFrom?: Maybe<Scalars['Int']>;
  /**
   * *     Accepts natural number.
   * *
   */
  readonly eventDistanceTo?: Maybe<Scalars['Int']>;
  readonly ownTransport?: Maybe<Scalars['Boolean']>;
  readonly studentWorkdaysFrom?: Maybe<Scalars['Int']>;
  readonly studentWorkdaysTo?: Maybe<Scalars['Int']>;
  readonly professionalStatuses?: Maybe<ReadonlyArray<ProfessionalStatusForPointHr>>;
  readonly availabilityStatuses?: Maybe<ReadonlyArray<AvailabilityStatus>>;
  readonly degree?: Maybe<ReadonlyArray<Degree>>;
  readonly weightFrom?: Maybe<Scalars['Float']>;
  readonly weightTo?: Maybe<Scalars['Float']>;
  readonly heightFrom?: Maybe<Scalars['Float']>;
  readonly heightTo?: Maybe<Scalars['Float']>;
  readonly BMIFrom?: Maybe<Scalars['Float']>;
  readonly BMITo?: Maybe<Scalars['Float']>;
  /**
   * *    Accepts positive number, maximum `1000`.
   * *    Default `1`.
   * *
   */
  readonly page?: Maybe<Scalars['Int']>;
  /**
   * *    Accepts any positive number or zero, maximum `1000`.
   * *    Zero can be used for calculate totals.
   * *    Default `20`.
   * *
   */
  readonly limit?: Maybe<Scalars['Int']>;
  readonly search?: Maybe<Scalars['String']>;
};

export type PersonSelectListSortItem = {
  readonly by?: Maybe<PersonSelectListSortType>;
  readonly direction?: Maybe<SortDirection>;
};

export enum PersonSelectListSortType {
  CompanyDistance = 'COMPANY_DISTANCE',
  FirstName = 'FIRST_NAME',
  LastName = 'LAST_NAME'
}

export type Plan = {
  readonly __typename?: 'Plan';
  readonly date: Maybe<Scalars['DateImmutable']>;
  readonly title: Maybe<Scalars['String']>;
  readonly uuid: Scalars['UUID'];
  readonly createdAt: Scalars['DateTimeImmutable'];
  readonly updatedAt: Scalars['DateTimeImmutable'];
};

export type ProductType = {
  readonly __typename?: 'ProductType';
  readonly name: Maybe<Scalars['String']>;
  readonly briefingInfoSettings: ReadonlyArray<Maybe<BriefingInfoSettings>>;
  readonly uuid: Scalars['UUID'];
  readonly createdAt: Scalars['DateTimeImmutable'];
  readonly updatedAt: Scalars['DateTimeImmutable'];
};

export enum ProfessionalStatusForPointHr {
  Freelancer = 'Freelancer',
  Student = 'Student',
  Interim = 'Interim',
  Dummy = 'Dummy',
  Flexijob = 'Flexijob',
  Standard = 'Standard'
}

export type Project = {
  readonly __typename?: 'Project';
  readonly resolvedLogo: Maybe<Scalars['String']>;
  readonly getUninvoicedAmount: Maybe<Scalars['Int']>;
  readonly name: Scalars['String'];
  readonly creator: Maybe<User>;
  readonly startDate: Maybe<Scalars['DateImmutable']>;
  readonly endDate: Maybe<Scalars['DateImmutable']>;
  readonly description: Maybe<Scalars['String']>;
  readonly client: Client;
  readonly contacts: ReadonlyArray<Maybe<Contact>>;
  readonly company: Company;
  readonly fixedFee: Maybe<Scalars['Int']>;
  readonly totalFees: Maybe<Scalars['Int']>;
  readonly totalHours: Maybe<Scalars['Float']>;
  readonly approvedTotalHours: Maybe<Scalars['Float']>;
  readonly hourlyRate: Maybe<Scalars['Int']>;
  readonly timeAndMaterials: Maybe<ProjectTimeAndMaterials>;
  readonly tasks: ReadonlyArray<Maybe<ProjectTask>>;
  readonly teamMembers: ReadonlyArray<Maybe<ProjectTeamMember>>;
  readonly projectGroup: Maybe<ProjectGroup>;
  readonly roleUnits: ReadonlyArray<Maybe<RoleUnit>>;
  readonly status: Scalars['String'];
  readonly label: Scalars['String'];
  readonly briefingInfoSettings: Maybe<BriefingInfoSettings>;
  readonly nettoMarginTarget: Maybe<Scalars['Float']>;
  readonly grossMarginTarget: Maybe<Scalars['Float']>;
  readonly taskGroups: ReadonlyArray<Maybe<ProjectTaskGroup>>;
  readonly actionTeams: ReadonlyArray<Maybe<ActionTeam>>;
  readonly nonBillableBudget: Maybe<Scalars['String']>;
  readonly logoFilename: Maybe<Scalars['String']>;
  readonly ratesheet: Maybe<Ratesheet>;
  readonly channelMatches: ReadonlyArray<Maybe<ChannelMatch>>;
  readonly projectMaterialGroups: ReadonlyArray<Maybe<ProjectMaterialGroup>>;
  readonly channelGroupSelectors: ReadonlyArray<Maybe<ChannelGroupSelector>>;
  readonly invoices: ReadonlyArray<Maybe<Invoice>>;
  readonly materialsTotalUnitPrice: Maybe<Scalars['Int']>;
  readonly materialsTotalBillablePrice: Maybe<Scalars['Int']>;
  readonly channelSelectors: ReadonlyArray<Maybe<ChannelSelector>>;
  readonly currentTotalBudget: Maybe<Scalars['Int']>;
  readonly currentTotalCost: Maybe<Scalars['Int']>;
  readonly currentTotalContacts: Maybe<Scalars['Int']>;
  readonly currentTotalActions: Maybe<Scalars['Int']>;
  readonly costContacts: Maybe<Scalars['Int']>;
  readonly grossMargin: Maybe<Scalars['Int']>;
  readonly budgetType: Maybe<Scalars['String']>;
  readonly paidAmount: Maybe<Scalars['Int']>;
  readonly expenses: ReadonlyArray<Maybe<ProjectExpense>>;
  readonly expenseGroups: ReadonlyArray<Maybe<ProjectExpenseGroup>>;
  readonly lastUsedProjectNumber: Maybe<Scalars['Int']>;
  readonly CPOs: ReadonlyArray<Maybe<Cpo>>;
  readonly SPOs: ReadonlyArray<Maybe<Spo>>;
  readonly briefing: Briefing;
  readonly supplier: Maybe<Supplier>;
  readonly timeTracks: ReadonlyArray<Maybe<TimeTrack>>;
  readonly remainingBudget: Maybe<Scalars['Int']>;
  readonly nettoMargin: Maybe<Scalars['Int']>;
  readonly estimatedGrossMargin: Maybe<Scalars['Int']>;
  readonly estimatedNettoMargin: Maybe<Scalars['Int']>;
  readonly remainingHours: Maybe<Scalars['Float']>;
  readonly approvedRemainingHours: Maybe<Scalars['Float']>;
  readonly billableTimeCost: Maybe<Scalars['Int']>;
  readonly realTimeCost: Maybe<Scalars['Int']>;
  readonly totalTimeTracked: Maybe<Scalars['Float']>;
  readonly realCostEstimatedExpenses: Maybe<Scalars['Int']>;
  readonly billableCostEstimatedExpenses: Maybe<Scalars['Int']>;
  readonly draft: Scalars['Boolean'];
  readonly debriefing: Maybe<Form>;
  readonly tags: ReadonlyArray<Maybe<Tag>>;
  readonly budgetItems: ReadonlyArray<Maybe<AbstractBudgetItem>>;
  readonly type: Scalars['String'];
  readonly warehouses: ReadonlyArray<Maybe<Warehouse>>;
  readonly warehouseRatesheet: Maybe<Ratesheet>;
  readonly companyForm: Maybe<Form>;
  readonly clientForm: Maybe<Form>;
  readonly externalUuid: Maybe<Scalars['UUID']>;
  readonly hasCustomDebriefing: Scalars['Boolean'];
  readonly hasCustomClientForm: Scalars['Boolean'];
  readonly hasCustomCompanyForm: Scalars['Boolean'];
  readonly number: Scalars['Int'];
  readonly billableExpensesCost: Scalars['Int'];
  readonly invoicedAmount: Scalars['Int'];
  readonly bookkeepingProjectCreated: Scalars['Boolean'];
  readonly contracts: ReadonlyArray<Maybe<Contract>>;
  readonly projectId: Scalars['String'];
  readonly trackTasksBy: Maybe<ProjectTrackTasksBy>;
  readonly initials: Maybe<Scalars['String']>;
  readonly financeId: Maybe<Scalars['String']>;
  readonly brand: Maybe<Brand>;
  readonly confirmedEstimatesAmount: Scalars['Int'];
  readonly sentInvoicesAmount: Scalars['Int'];
  readonly paidInvoicesAmount: Scalars['Int'];
  readonly actualSellPrice: Scalars['Float'];
  readonly actualCostPrice: Scalars['Float'];
  readonly starredByUsers: ReadonlyArray<Maybe<User>>;
  readonly showEstimateInvoicedAmount: Scalars['Boolean'];
  readonly tasksTotalAmount: Scalars['Int'];
  readonly createdAt: Scalars['DateTimeImmutable'];
  readonly updatedAt: Scalars['DateTimeImmutable'];
  readonly uuid: Scalars['UUID'];
};

export type ProjectExpense = {
  readonly __typename?: 'ProjectExpense';
  readonly expenseGroup: Maybe<ProjectExpenseGroup>;
  readonly name: Scalars['String'];
  readonly description: Scalars['String'];
  readonly expenseUnitPrice: Maybe<Scalars['Int']>;
  readonly billableRate: Maybe<Scalars['Int']>;
  readonly originalExpense: Maybe<Expense>;
  readonly project: Maybe<Project>;
  readonly isBillable: Scalars['Boolean'];
  readonly qty: Maybe<Scalars['Float']>;
  readonly discount: Maybe<Scalars['Float']>;
  readonly amount: Maybe<Scalars['Int']>;
  readonly invoiceItems: ReadonlyArray<Maybe<InvoiceItem>>;
  readonly createdAt: Scalars['DateTimeImmutable'];
  readonly updatedAt: Scalars['DateTimeImmutable'];
  readonly uuid: Scalars['UUID'];
};

export type ProjectExpenseGroup = {
  readonly __typename?: 'ProjectExpenseGroup';
  readonly originalExpenseGroup: ExpenseGroup;
  readonly expenses: ReadonlyArray<Maybe<ProjectExpense>>;
  readonly description: Maybe<Scalars['String']>;
  readonly name: Scalars['String'];
  readonly project: Maybe<Project>;
  readonly isBillable: Maybe<Scalars['Boolean']>;
  readonly createdAt: Scalars['DateTimeImmutable'];
  readonly updatedAt: Scalars['DateTimeImmutable'];
  readonly uuid: Scalars['UUID'];
};

export type ProjectGroup = {
  readonly __typename?: 'ProjectGroup';
  readonly name: Scalars['String'];
  readonly company: Maybe<Company>;
  readonly parent: Maybe<ProjectGroup>;
  readonly projects: ReadonlyArray<Maybe<Project>>;
  readonly generalProjects: ReadonlyArray<Maybe<GeneralProject>>;
  readonly tags: ReadonlyArray<Maybe<Tag>>;
  readonly status: Scalars['String'];
  readonly createdAt: Scalars['DateTimeImmutable'];
  readonly updatedAt: Scalars['DateTimeImmutable'];
  readonly uuid: Scalars['UUID'];
};

export type ProjectMaterialGroup = {
  readonly __typename?: 'ProjectMaterialGroup';
  readonly type: Maybe<Scalars['String']>;
  readonly name: Scalars['String'];
  readonly project: Project;
  readonly projectMaterialGroupItems: ReadonlyArray<Maybe<ProjectMaterialGroupItem>>;
  readonly createdAt: Scalars['DateTimeImmutable'];
  readonly updatedAt: Scalars['DateTimeImmutable'];
  readonly uuid: Scalars['UUID'];
};

export type ProjectMaterialGroupItem = {
  readonly __typename?: 'ProjectMaterialGroupItem';
  readonly name: Maybe<Scalars['String']>;
  readonly qtyRequired: Maybe<Scalars['Int']>;
  readonly qtyLimit: Maybe<Scalars['Int']>;
  readonly unitPrice: Maybe<Scalars['Int']>;
  readonly billablePrice: Maybe<Scalars['Int']>;
  readonly retourPrice: Maybe<Scalars['Int']>;
  readonly materialGroupItems: ReadonlyArray<Maybe<MaterialGroupItem>>;
  readonly projectMaterialGroup: ProjectMaterialGroup;
  readonly dictionaryMaterial: Maybe<Material>;
  readonly dictionarySampleUnit: Maybe<SampleUnit>;
  readonly reserveUnit: Maybe<Scalars['Int']>;
  readonly reservePercent: Maybe<Scalars['Int']>;
  readonly qtyTotal: Maybe<Scalars['Int']>;
  readonly totalEstimated: Maybe<Scalars['Int']>;
  readonly totalTransported: Maybe<Scalars['Int']>;
  readonly totalBillablePrice: Maybe<Scalars['Int']>;
  readonly totalUnitPrice: Maybe<Scalars['Int']>;
  readonly inTray: Maybe<Scalars['Int']>;
  readonly inLayer: Maybe<Scalars['Int']>;
  readonly inPalet: Maybe<Scalars['Int']>;
  readonly isActive: Maybe<Scalars['Boolean']>;
  readonly action: Maybe<Action>;
  readonly budgetItem: Maybe<MaterialCostBudgetItem>;
  readonly isHiddenForBudgetOverview: Scalars['Boolean'];
  readonly createdAt: Scalars['DateTimeImmutable'];
  readonly updatedAt: Scalars['DateTimeImmutable'];
  readonly uuid: Scalars['UUID'];
};

export type ProjectPaginator = {
  readonly __typename?: 'ProjectPaginator';
  readonly items: ReadonlyArray<Project>;
  readonly page: Scalars['Int'];
  readonly limit: Scalars['Int'];
  readonly total: Scalars['Int'];
  /**
   * *     Hash of query parameters.
   * *
   */
  readonly hash: Scalars['String'];
  readonly hasMore: Scalars['Boolean'];
};

export enum ProjectPermission {
  View = 'VIEW',
  Edit = 'EDIT',
  Duplicate = 'DUPLICATE',
  ViewEstimates = 'VIEW_ESTIMATES',
  CreateEstimates = 'CREATE_ESTIMATES',
  ExportEstimates = 'EXPORT_ESTIMATES',
  ViewInvoices = 'VIEW_INVOICES',
  CreateInvoices = 'CREATE_INVOICES',
  ExportInvoices = 'EXPORT_INVOICES',
  EditBt = 'EDIT_BT',
  ForceExecuted = 'FORCE_EXECUTED'
}

export type ProjectQueryInput = {
  readonly sort?: Maybe<ReadonlyArray<ProjectSortItem>>;
  readonly hasTask?: Maybe<Scalars['Boolean']>;
  readonly own?: Maybe<Scalars['Boolean']>;
  readonly statuses?: Maybe<ReadonlyArray<Scalars['String']>>;
  readonly excludeArchiveEstimates?: Maybe<Scalars['Boolean']>;
  readonly excludeForceExecuted?: Maybe<Scalars['Boolean']>;
  /**
   * *    Accepts positive number, maximum `1000`.
   * *    Default `1`.
   * *
   */
  readonly page?: Maybe<Scalars['Int']>;
  /**
   * *    Accepts any positive number or zero, maximum `1000`.
   * *    Zero can be used for calculate totals.
   * *    Default `20`.
   * *
   */
  readonly limit?: Maybe<Scalars['Int']>;
  readonly search?: Maybe<Scalars['String']>;
  readonly UUIDs?: Maybe<ReadonlyArray<Scalars['UUID']>>;
  readonly excludeUUIDs?: Maybe<ReadonlyArray<Scalars['UUID']>>;
};

export type ProjectRole = {
  readonly __typename?: 'ProjectRole';
  readonly roleName: Maybe<Scalars['String']>;
  readonly unitPrice: Maybe<Scalars['Int']>;
  readonly billablePrice: Maybe<Scalars['Int']>;
  readonly ratesheet: Maybe<Ratesheet>;
  readonly teamMembers: ReadonlyArray<Maybe<ProjectTeamMember>>;
  readonly uuid: Scalars['UUID'];
  readonly createdAt: Scalars['DateTimeImmutable'];
  readonly updatedAt: Scalars['DateTimeImmutable'];
};

export type ProjectSortItem = {
  readonly by?: Maybe<ProjectSortType>;
  readonly direction?: Maybe<SortDirection>;
};

export enum ProjectSortType {
  CreatedAt = 'CREATED_AT'
}

export type ProjectTask = {
  readonly __typename?: 'ProjectTask';
  readonly trackedHours: Maybe<Scalars['Float']>;
  readonly plannedHours: Maybe<Scalars['Float']>;
  readonly projectLeads: Maybe<ReadonlyArray<User>>;
  readonly estimateLabel: Scalars['String'];
  readonly hasEstimateLink: Scalars['Boolean'];
  readonly originalTask: Maybe<Task>;
  readonly invoiceItems: ReadonlyArray<Maybe<InvoiceItem>>;
  readonly tcTask: TcTask;
  readonly budgetHours: Maybe<Scalars['Float']>;
  readonly approvedBudgetHours: Maybe<Scalars['Float']>;
  readonly budgetFee: Maybe<Scalars['Int']>;
  readonly billingRatePerHour: Maybe<Scalars['Int']>;
  readonly project: Project;
  readonly generalProject: Maybe<GeneralProject>;
  readonly billable: Maybe<Scalars['Boolean']>;
  readonly taskGroup: Maybe<ProjectTaskGroup>;
  readonly projectTaskAssignments: ReadonlyArray<Maybe<ProjectTaskAssignment>>;
  readonly name: Scalars['String'];
  readonly description: Scalars['String'];
  readonly timeTracks: ReadonlyArray<Maybe<TimeTrack>>;
  readonly budgetItem: StaffingCostBudgetItem;
  readonly projectLevelTask: Scalars['Boolean'];
  readonly createdAt: Scalars['DateTimeImmutable'];
  readonly updatedAt: Scalars['DateTimeImmutable'];
  readonly uuid: Scalars['UUID'];
};

export type ProjectTaskAssignment = {
  readonly __typename?: 'ProjectTaskAssignment';
  readonly user: Maybe<User>;
  readonly projectTask: Maybe<ProjectTask>;
  readonly note: Maybe<Scalars['String']>;
  readonly events: ReadonlyArray<Maybe<ProjectTaskAssignmentEvent>>;
  readonly timeslots: ReadonlyArray<Maybe<ProjectTaskAssignmentTimeslot>>;
  readonly createdAt: Scalars['DateTimeImmutable'];
  readonly updatedAt: Scalars['DateTimeImmutable'];
  readonly uuid: Scalars['UUID'];
};

export type ProjectTaskAssignmentEvent = {
  readonly __typename?: 'ProjectTaskAssignmentEvent';
  readonly user: Maybe<User>;
  readonly comment: Scalars['String'];
  readonly createdAt: Scalars['DateTimeImmutable'];
  readonly updatedAt: Scalars['DateTimeImmutable'];
  readonly uuid: Scalars['UUID'];
};

export type ProjectTaskAssignmentPaginator = {
  readonly __typename?: 'ProjectTaskAssignmentPaginator';
  readonly items: ReadonlyArray<FlatProjectTaskAssignment>;
  readonly page: Scalars['Int'];
  readonly limit: Scalars['Int'];
  readonly total: Scalars['Int'];
  /**
   * *     Hash of query parameters.
   * *
   */
  readonly hash: Scalars['String'];
  readonly hasMore: Scalars['Boolean'];
};

export type ProjectTaskAssignmentQueryInput = {
  readonly userUUIDs?: Maybe<ReadonlyArray<Scalars['UUID']>>;
  readonly taskRoleUUDs?: Maybe<ReadonlyArray<Scalars['UUID']>>;
  readonly dateLTE?: Maybe<Scalars['DateImmutable']>;
  readonly dateGTE?: Maybe<Scalars['DateImmutable']>;
  readonly originalTaskUUIDs?: Maybe<ReadonlyArray<Scalars['UUID']>>;
  /**
   * *    Accepts positive number, maximum `1000`.
   * *    Default `1`.
   * *
   */
  readonly page?: Maybe<Scalars['Int']>;
  /**
   * *    Accepts any positive number or zero, maximum `1000`.
   * *    Zero can be used for calculate totals.
   * *    Default `20`.
   * *
   */
  readonly limit?: Maybe<Scalars['Int']>;
  readonly search?: Maybe<Scalars['String']>;
  readonly UUIDs?: Maybe<ReadonlyArray<Scalars['UUID']>>;
  readonly excludeUUIDs?: Maybe<ReadonlyArray<Scalars['UUID']>>;
};

export type ProjectTaskAssignmentTimeslot = {
  readonly __typename?: 'ProjectTaskAssignmentTimeslot';
  readonly assignment: Maybe<ProjectTaskAssignment>;
  readonly type: Scalars['String'];
  readonly leaveHolidayAssignment: Maybe<LeaveHolidayAssignment>;
  readonly createdBy: Maybe<User>;
  readonly date: Maybe<Scalars['DateImmutable']>;
  readonly startTime: Maybe<Scalars['DateTimeImmutable']>;
  readonly duration: Maybe<Scalars['Float']>;
  readonly isConfirmed: Maybe<Scalars['Boolean']>;
  readonly createdAt: Scalars['DateTimeImmutable'];
  readonly updatedAt: Scalars['DateTimeImmutable'];
  readonly uuid: Scalars['UUID'];
};

export type ProjectTaskGroup = {
  readonly __typename?: 'ProjectTaskGroup';
  readonly originalTaskGroup: TaskGroup;
  readonly project: Project;
  readonly generalProject: Maybe<GeneralProject>;
  readonly budgetHours: Maybe<Scalars['Float']>;
  readonly approvedBudgetHours: Maybe<Scalars['Int']>;
  readonly budgetFee: Maybe<Scalars['Int']>;
  readonly billingRatePerHour: Maybe<Scalars['Int']>;
  readonly billable: Maybe<Scalars['Boolean']>;
  readonly tasks: ReadonlyArray<Maybe<ProjectTask>>;
  readonly description: Scalars['String'];
  readonly name: Scalars['String'];
  readonly budgetItem: Maybe<GroupStaffingCostBudgetItem>;
  readonly createdAt: Scalars['DateTimeImmutable'];
  readonly updatedAt: Scalars['DateTimeImmutable'];
  readonly uuid: Scalars['UUID'];
};

export type ProjectTaskPaginator = {
  readonly __typename?: 'ProjectTaskPaginator';
  readonly items: ReadonlyArray<ProjectTask>;
  readonly page: Scalars['Int'];
  readonly limit: Scalars['Int'];
  readonly total: Scalars['Int'];
  /**
   * *     Hash of query parameters.
   * *
   */
  readonly hash: Scalars['String'];
  readonly hasMore: Scalars['Boolean'];
};

export type ProjectTaskQueryInput = {
  readonly sort?: Maybe<ReadonlyArray<ProjectTaskSortItem>>;
  readonly excludeNonProjectLevelTasksWhenTrackingByProject?: Maybe<Scalars['Boolean']>;
  readonly projectUUIDs?: Maybe<ReadonlyArray<Scalars['UUID']>>;
  readonly taskRoleUUIDs?: Maybe<ReadonlyArray<Scalars['UUID']>>;
  readonly userUUIDs?: Maybe<ReadonlyArray<Scalars['UUID']>>;
  readonly originalTaskUUIDs?: Maybe<ReadonlyArray<Scalars['UUID']>>;
  readonly ownTaskRole?: Maybe<Scalars['Boolean']>;
  readonly excludeArchiveEstimates?: Maybe<Scalars['Boolean']>;
  /**
   * *    Accepts any positive number or zero, maximum `1000`.
   * *    Zero can be used for calculate totals.
   * *    Default `20`.
   * *
   */
  readonly limit?: Maybe<Scalars['Int']>;
  /**
   * *    Accepts positive number, maximum `1000`.
   * *    Default `1`.
   * *
   */
  readonly page?: Maybe<Scalars['Int']>;
  readonly search?: Maybe<Scalars['String']>;
  readonly UUIDs?: Maybe<ReadonlyArray<Scalars['UUID']>>;
  readonly excludeUUIDs?: Maybe<ReadonlyArray<Scalars['UUID']>>;
};

export type ProjectTaskSortItem = {
  readonly by?: Maybe<ProjectTaskSortType>;
  readonly direction?: Maybe<SortDirection>;
};

export enum ProjectTaskSortType {
  CreatedAt = 'CREATED_AT'
}

export type ProjectTeamMember = {
  readonly __typename?: 'ProjectTeamMember';
  readonly user: Maybe<User>;
  readonly budgetHours: Maybe<Scalars['Int']>;
  readonly billableRatePerHour: Maybe<Scalars['Int']>;
  readonly project: Maybe<Project>;
  readonly generalProject: Maybe<GeneralProject>;
  readonly actions: ReadonlyArray<Maybe<Action>>;
  readonly isProjectLeader: Scalars['Boolean'];
  readonly timeTracks: ReadonlyArray<Maybe<TimeTrack>>;
  readonly projectRole: Maybe<ProjectRole>;
  readonly useUserRate: Scalars['Boolean'];
  readonly uuid: Scalars['UUID'];
  readonly createdAt: Scalars['DateTimeImmutable'];
  readonly updatedAt: Scalars['DateTimeImmutable'];
};

export type ProjectTimeAndMaterials = {
  readonly __typename?: 'ProjectTimeAndMaterials';
  readonly sendEmailExceedPercent: Maybe<Scalars['Float']>;
  readonly includesBillableAndNonBillableProjectExpenses: Maybe<Scalars['Boolean']>;
  readonly budget: Maybe<Scalars['String']>;
  readonly billingMethod: Maybe<Scalars['String']>;
  readonly project: Project;
  readonly generalProject: GeneralProject;
  readonly sendEmailExceed: Maybe<Scalars['Boolean']>;
  readonly uuid: Scalars['UUID'];
  readonly createdAt: Scalars['DateTimeImmutable'];
  readonly updatedAt: Scalars['DateTimeImmutable'];
};

export enum ProjectTrackTasksBy {
  Project = 'PROJECT',
  Group = 'GROUP'
}

export enum Province {
  Antwerp = 'ANTWERP',
  EastFlanders = 'EAST_FLANDERS',
  FlemishBrabant = 'FLEMISH_BRABANT',
  Limburg = 'LIMBURG',
  WestFlanders = 'WEST_FLANDERS',
  WalloonBrabant = 'WALLOON_BRABANT',
  Hainaut = 'HAINAUT',
  Liege = 'LIEGE',
  Luxembourg = 'LUXEMBOURG',
  Namur = 'NAMUR',
  Brussels = 'BRUSSELS'
}

export type PublishActionImageInput = {
  readonly source: ActionPublicationItemSource;
  readonly name: Scalars['String'];
  readonly path: Scalars['String'];
  readonly caption?: Maybe<Scalars['String']>;
};

export type PublishActionInput = {
  readonly uuid: Scalars['UUID'];
  readonly intro?: Maybe<Scalars['String']>;
  readonly items?: Maybe<ReadonlyArray<PublishActionItemInput>>;
  readonly images?: Maybe<ReadonlyArray<PublishActionImageInput>>;
  readonly replaceActuals?: Maybe<Scalars['Boolean']>;
};

export type PublishActionItemInput = {
  readonly source: ActionPublicationItemSource;
  readonly formElementUuid?: Maybe<Scalars['UUID']>;
  readonly label: Scalars['String'];
  readonly value?: Maybe<Scalars['String']>;
  readonly originalValue?: Maybe<Scalars['String']>;
};

export type QuantityType = {
  readonly __typename?: 'QuantityType';
  readonly name: Scalars['String'];
  readonly uuid: Scalars['UUID'];
  readonly createdAt: Scalars['DateTimeImmutable'];
  readonly updatedAt: Scalars['DateTimeImmutable'];
};

export type QuantityTypePaginator = {
  readonly __typename?: 'QuantityTypePaginator';
  readonly items: ReadonlyArray<QuantityType>;
  readonly page: Scalars['Int'];
  readonly limit: Scalars['Int'];
  readonly total: Scalars['Int'];
  /**
   * *     Hash of query parameters.
   * *
   */
  readonly hash: Scalars['String'];
  readonly hasMore: Scalars['Boolean'];
};

export type QuantityTypeQueryInput = {
  readonly sort?: Maybe<ReadonlyArray<QuantityTypeSortItem>>;
  readonly name?: Maybe<Scalars['String']>;
  /**
   * *    Accepts positive number, maximum `1000`.
   * *    Default `1`.
   * *
   */
  readonly page?: Maybe<Scalars['Int']>;
  /**
   * *    Accepts any positive number or zero, maximum `1000`.
   * *    Zero can be used for calculate totals.
   * *    Default `20`.
   * *
   */
  readonly limit?: Maybe<Scalars['Int']>;
  readonly search?: Maybe<Scalars['String']>;
  readonly UUIDs?: Maybe<ReadonlyArray<Scalars['UUID']>>;
  readonly excludeUUIDs?: Maybe<ReadonlyArray<Scalars['UUID']>>;
};

export type QuantityTypeSortItem = {
  readonly by?: Maybe<QuantityTypeSortType>;
  readonly direction?: Maybe<SortDirection>;
};

export enum QuantityTypeSortType {
  CreatedAt = 'CREATED_AT',
  Name = 'NAME'
}

export type Query = {
  readonly __typename?: 'Query';
  readonly actions: ActionsPaginator;
  readonly actions_filter: SimpleEntityPaginator;
  readonly action_teams: ActionTeamPaginator;
  readonly actuals: ReadonlyArray<ActualsLine>;
  readonly actual_totals: ActualTotals;
  readonly app_settings: Maybe<AppSettings>;
  readonly booking_persons: BookingPersonsPaginator;
  readonly booking_persons_stat: BookingPersonsStat;
  readonly booking_person_performance: BookingPersonPerformance;
  readonly booking_person_late_movements: BookingPersonLateMovements;
  readonly clients: ClientPaginator;
  readonly company_holidays: ReadonlyArray<CompanyHoliday>;
  readonly company_payroll_codes: ReadonlyArray<CompanyPayrollCodeItem>;
  readonly company_payroll_rules: ReadonlyArray<CompanyPayrollRule>;
  readonly contact_client_roles: ContactClientRolesPaginator;
  readonly contracts: ContractsPaginator;
  readonly current_company: Company;
  readonly external_users: ExternalUsersPaginator;
  readonly form_answers: FormAnswersPaginator;
  readonly form_answers_list: ReadonlyArray<FormAnswerListItem>;
  readonly forms: FormsPaginator;
  readonly person_select_list: PersonSelectListPaginator;
  readonly projects: ProjectPaginator;
  readonly project_task_assignments: ProjectTaskAssignmentPaginator;
  readonly project_tasks: ProjectTaskPaginator;
  readonly quantity_types: QuantityTypePaginator;
  readonly time_tracks: TimeTrackPaginator;
  readonly time_track_stat_by_date: TimeTrackStatByDatePaginator;
  readonly types: Maybe<Types>;
};


export type QueryActionsArgs = {
  q?: Maybe<ActionsQueryInput>;
};


export type QueryActionsFilterArgs = {
  q: ActionsFilterQueryInput;
};


export type QueryActionTeamsArgs = {
  q?: Maybe<ActionTeamQueryInput>;
};


export type QueryActualsArgs = {
  q: ActualsQueryInput;
};


export type QueryActualTotalsArgs = {
  q: ActualsQueryInput;
};


export type QueryBookingPersonsArgs = {
  q?: Maybe<BookingPersonsQueryInput>;
};


export type QueryBookingPersonsStatArgs = {
  q?: Maybe<BookingPersonsQueryInput>;
};


export type QueryBookingPersonPerformanceArgs = {
  q: BookingPersonPerformanceQueryInput;
};


export type QueryBookingPersonLateMovementsArgs = {
  q: BookingPersonLateMovementsQueryInput;
};


export type QueryClientsArgs = {
  q?: Maybe<ClientQueryInput>;
};


export type QueryContactClientRolesArgs = {
  q?: Maybe<ContactClientRolesQueryInput>;
};


export type QueryContractsArgs = {
  q?: Maybe<ContractsQueryInput>;
};


export type QueryExternalUsersArgs = {
  q?: Maybe<ExternalUsersQueryInput>;
};


export type QueryFormAnswersArgs = {
  q?: Maybe<FormAnswersQueryInput>;
};


export type QueryFormAnswersListArgs = {
  q: FormAnswersListQueryInput;
};


export type QueryFormsArgs = {
  q?: Maybe<FormsQueryInput>;
};


export type QueryPersonSelectListArgs = {
  q: PersonSelectListQueryInput;
};


export type QueryProjectsArgs = {
  q?: Maybe<ProjectQueryInput>;
};


export type QueryProjectTaskAssignmentsArgs = {
  q?: Maybe<ProjectTaskAssignmentQueryInput>;
};


export type QueryProjectTasksArgs = {
  q?: Maybe<ProjectTaskQueryInput>;
};


export type QueryQuantityTypesArgs = {
  q?: Maybe<QuantityTypeQueryInput>;
};


export type QueryTimeTracksArgs = {
  q?: Maybe<TimeTrackQueryInput>;
};


export type QueryTimeTrackStatByDateArgs = {
  q?: Maybe<TimeTrackQueryInput>;
};

export type Ratesheet = {
  readonly __typename?: 'Ratesheet';
  readonly name: Scalars['String'];
  readonly createdBy: Maybe<User>;
  readonly type: Maybe<RatesheetCategory>;
  readonly estimates: ReadonlyArray<Maybe<Estimate>>;
  readonly invoices: ReadonlyArray<Maybe<Invoice>>;
  readonly defaultCostPerHourUnitPrice: Scalars['Int'];
  readonly defaultCostPerHourBillablePrice: Scalars['Int'];
  readonly hourUnitPrice: Scalars['Int'];
  readonly hourBillablePrice: Scalars['Int'];
  readonly distanceToTheCompanyUnitPrice: Scalars['Int'];
  readonly distanceToTheCompanyBillablePrice: Scalars['Int'];
  readonly distanceToTheEventUnitPrice: Scalars['Int'];
  readonly distanceToTheEventBillablePrice: Scalars['Int'];
  readonly distanceToTheCompany: Scalars['Int'];
  readonly distanceToTheEvent: Scalars['Int'];
  readonly company: Maybe<Company>;
  readonly roleName: Maybe<Scalars['String']>;
  readonly projectType: Maybe<Scalars['String']>;
  readonly tasks: ReadonlyArray<Maybe<Task>>;
  readonly expenses: ReadonlyArray<Maybe<Expense>>;
  readonly budgetSplits: ReadonlyArray<Maybe<BudgetSplit>>;
  readonly services: ReadonlyArray<Maybe<Service>>;
  readonly transports: ReadonlyArray<Maybe<Transport>>;
  readonly externalRoles: ReadonlyArray<Maybe<CompositionRole>>;
  readonly projectRoles: ReadonlyArray<Maybe<ProjectRole>>;
  readonly status: Maybe<RatesheetStatus>;
  readonly projects: ReadonlyArray<Maybe<Project>>;
  readonly warehouses: ReadonlyArray<Maybe<Warehouse>>;
  readonly ratesheetValues: ReadonlyArray<Maybe<RatesheetValue>>;
  readonly defaultRatesheet: Scalars['Boolean'];
  readonly client: Maybe<Client>;
  readonly fromDate: Scalars['DateTimeImmutable'];
  readonly toDate: Scalars['DateTimeImmutable'];
  readonly createdAt: Scalars['DateTimeImmutable'];
  readonly updatedAt: Scalars['DateTimeImmutable'];
  readonly uuid: Scalars['UUID'];
};

export type RatesheetBudgetSplit = {
  readonly __typename?: 'RatesheetBudgetSplit';
  readonly name: Scalars['String'];
  readonly percentage: Scalars['Float'];
  readonly ratesheetValue: RatesheetValue;
  readonly uuid: Scalars['UUID'];
  readonly createdAt: Scalars['DateTimeImmutable'];
  readonly updatedAt: Scalars['DateTimeImmutable'];
};

export type RatesheetCategory = {
  readonly __typename?: 'RatesheetCategory';
  readonly name: Scalars['String'];
  readonly createdAt: Scalars['DateTimeImmutable'];
  readonly updatedAt: Scalars['DateTimeImmutable'];
  readonly uuid: Scalars['UUID'];
};

export type RatesheetExpense = {
  readonly __typename?: 'RatesheetExpense';
  readonly expense: Expense;
  readonly unitPrice: Scalars['Int'];
  readonly billablePrice: Scalars['Int'];
  readonly ratesheetValue: RatesheetValue;
  readonly uuid: Scalars['UUID'];
  readonly createdAt: Scalars['DateTimeImmutable'];
  readonly updatedAt: Scalars['DateTimeImmutable'];
};

export type RatesheetExternal = {
  readonly __typename?: 'RatesheetExternal';
  readonly defaultCostPricePerHour: Maybe<Scalars['Int']>;
  readonly defaultSellPricePerHour: Maybe<Scalars['Int']>;
  readonly costPricePerHour: Maybe<Scalars['Int']>;
  readonly sellPricePerHour: Maybe<Scalars['Int']>;
  readonly overtimeCostPricePerHour: Maybe<Scalars['Int']>;
  readonly overtimeSellPricePerHour: Maybe<Scalars['Int']>;
  readonly transportCostPricePerDistanceUnit: Maybe<Scalars['Int']>;
  readonly transportSellPricePerDistanceUnit: Maybe<Scalars['Int']>;
  readonly transportDistance: Maybe<Scalars['Float']>;
  readonly planningCostPrice: Maybe<Scalars['Int']>;
  readonly planningSellPrice: Maybe<Scalars['Int']>;
  readonly mealAllowanceCostPrice: Maybe<Scalars['Int']>;
  readonly mealAllowanceSellPrice: Maybe<Scalars['Int']>;
  readonly dryCleaningCostPrice: Maybe<Scalars['Int']>;
  readonly dryCleaningSellPrice: Maybe<Scalars['Int']>;
  readonly normalRatePercentage: Scalars['Int'];
  readonly overtimeRatePercentage: Scalars['Int'];
  readonly quantity: Maybe<Scalars['Int']>;
  readonly amount: Maybe<Scalars['Int']>;
  readonly roleName: Scalars['String'];
  readonly holidayHourCostPrice: Maybe<Scalars['Int']>;
  readonly holidayHourSellPrice: Maybe<Scalars['Int']>;
  readonly holidayOvertimeCostPrice: Maybe<Scalars['Int']>;
  readonly holidayOvertimeSellPrice: Maybe<Scalars['Int']>;
  readonly costPrice: Maybe<Scalars['Int']>;
  readonly sellPrice: Maybe<Scalars['Int']>;
  readonly defaultCostPerHourUnitPrice: Maybe<Scalars['Int']>;
  readonly defaultCostPerHourBillablePrice: Maybe<Scalars['Int']>;
  readonly hourPricePercentage: Maybe<Scalars['Int']>;
  readonly hourPriceUnitPrice: Maybe<Scalars['Int']>;
  readonly hourPriceBillablePrice: Maybe<Scalars['Int']>;
  readonly overtimePricePercentage: Maybe<Scalars['Int']>;
  readonly overtimePriceUnitPrice: Maybe<Scalars['Int']>;
  readonly overtimePriceBillablePrice: Maybe<Scalars['Int']>;
  readonly holidayHourPricePercentage: Maybe<Scalars['Int']>;
  readonly holidayHourPriceUnitPrice: Maybe<Scalars['Int']>;
  readonly holidayHourPriceBillablePrice: Maybe<Scalars['Int']>;
  readonly holidayOvertimePricePercentage: Maybe<Scalars['Int']>;
  readonly holidayOvertimePriceUnitPrice: Maybe<Scalars['Int']>;
  readonly holidayOvertimePriceBillablePrice: Maybe<Scalars['Int']>;
  readonly distancePricePerKmUnitPrice: Maybe<Scalars['Int']>;
  readonly distancePricePerKmBillablePrice: Maybe<Scalars['Int']>;
  readonly ownCarViaUnitPrice: Maybe<Scalars['Int']>;
  readonly ownCarViaBillablePrice: Maybe<Scalars['Int']>;
  readonly ownCarDirectUnitPrice: Maybe<Scalars['Int']>;
  readonly ownCarDirectBillablePrice: Maybe<Scalars['Int']>;
  readonly distance: Maybe<Scalars['Float']>;
  readonly ratesheetValue: RatesheetValue;
  readonly actionTeamRole: Maybe<ActionTeamRole>;
  readonly uuid: Scalars['UUID'];
  readonly createdAt: Scalars['DateTimeImmutable'];
  readonly updatedAt: Scalars['DateTimeImmutable'];
};

export type RatesheetInternal = {
  readonly __typename?: 'RatesheetInternal';
  readonly role: Role;
  readonly unitPrice: Maybe<Scalars['Int']>;
  readonly billablePrice: Maybe<Scalars['Int']>;
  readonly ratesheetValue: RatesheetValue;
  readonly uuid: Scalars['UUID'];
  readonly createdAt: Scalars['DateTimeImmutable'];
  readonly updatedAt: Scalars['DateTimeImmutable'];
};

export type RatesheetService = {
  readonly __typename?: 'RatesheetService';
  readonly name: Scalars['String'];
  readonly description: Maybe<Scalars['String']>;
  readonly unitPrice: Maybe<Scalars['Int']>;
  readonly billablePrice: Maybe<Scalars['Int']>;
  readonly ratesheetValue: RatesheetValue;
  readonly dictionaryService: DictionaryService;
  readonly uuid: Scalars['UUID'];
  readonly createdAt: Scalars['DateTimeImmutable'];
  readonly updatedAt: Scalars['DateTimeImmutable'];
};

export enum RatesheetStatus {
  Active = 'ACTIVE',
  Archived = 'ARCHIVED'
}

export type RatesheetTcRole = {
  readonly __typename?: 'RatesheetTCRole';
  readonly defaultCostPricePerHour: Maybe<Scalars['Int']>;
  readonly defaultSellPricePerHour: Maybe<Scalars['Int']>;
  readonly costPricePerHour: Maybe<Scalars['Int']>;
  readonly sellPricePerHour: Maybe<Scalars['Int']>;
  readonly overtimeCostPricePerHour: Maybe<Scalars['Int']>;
  readonly overtimeSellPricePerHour: Maybe<Scalars['Int']>;
  readonly transportCostPricePerDistanceUnit: Maybe<Scalars['Int']>;
  readonly transportSellPricePerDistanceUnit: Maybe<Scalars['Int']>;
  readonly transportDistance: Maybe<Scalars['Float']>;
  readonly planningCostPrice: Maybe<Scalars['Int']>;
  readonly planningSellPrice: Maybe<Scalars['Int']>;
  readonly mealAllowanceCostPrice: Maybe<Scalars['Int']>;
  readonly mealAllowanceSellPrice: Maybe<Scalars['Int']>;
  readonly dryCleaningCostPrice: Maybe<Scalars['Int']>;
  readonly dryCleaningSellPrice: Maybe<Scalars['Int']>;
  readonly normalRatePercentage: Scalars['Int'];
  readonly overtimeRatePercentage: Scalars['Int'];
  readonly amount: Maybe<Scalars['Int']>;
  readonly roleName: Scalars['String'];
  readonly holidayHourCostPrice: Maybe<Scalars['Int']>;
  readonly holidayHourSellPrice: Maybe<Scalars['Int']>;
  readonly holidayOvertimeCostPrice: Maybe<Scalars['Int']>;
  readonly holidayOvertimeSellPrice: Maybe<Scalars['Int']>;
  readonly costPrice: Maybe<Scalars['Int']>;
  readonly sellPrice: Maybe<Scalars['Int']>;
  readonly defaultCostPerHourUnitPrice: Maybe<Scalars['Int']>;
  readonly defaultCostPerHourBillablePrice: Maybe<Scalars['Int']>;
  readonly hourPricePercentage: Maybe<Scalars['Int']>;
  readonly hourPriceUnitPrice: Maybe<Scalars['Int']>;
  readonly hourPriceBillablePrice: Maybe<Scalars['Int']>;
  readonly overtimePricePercentage: Maybe<Scalars['Int']>;
  readonly overtimePriceUnitPrice: Maybe<Scalars['Int']>;
  readonly overtimePriceBillablePrice: Maybe<Scalars['Int']>;
  readonly holidayHourPricePercentage: Maybe<Scalars['Int']>;
  readonly holidayHourPriceUnitPrice: Maybe<Scalars['Int']>;
  readonly holidayHourPriceBillablePrice: Maybe<Scalars['Int']>;
  readonly holidayOvertimePricePercentage: Maybe<Scalars['Int']>;
  readonly holidayOvertimePriceUnitPrice: Maybe<Scalars['Int']>;
  readonly holidayOvertimePriceBillablePrice: Maybe<Scalars['Int']>;
  readonly distancePricePerKmUnitPrice: Maybe<Scalars['Int']>;
  readonly distancePricePerKmBillablePrice: Maybe<Scalars['Int']>;
  readonly ownCarViaUnitPrice: Maybe<Scalars['Int']>;
  readonly ownCarViaBillablePrice: Maybe<Scalars['Int']>;
  readonly ownCarDirectUnitPrice: Maybe<Scalars['Int']>;
  readonly ownCarDirectBillablePrice: Maybe<Scalars['Int']>;
  readonly distance: Maybe<Scalars['Float']>;
  readonly ratesheetValue: RatesheetValue;
  readonly teamCostRole: Maybe<TeamCostRole>;
  readonly uuid: Scalars['UUID'];
  readonly createdAt: Scalars['DateTimeImmutable'];
  readonly updatedAt: Scalars['DateTimeImmutable'];
};

export type RatesheetTask = {
  readonly __typename?: 'RatesheetTask';
  readonly task: Task;
  readonly unitPrice: Scalars['Int'];
  readonly billablePrice: Scalars['Int'];
  readonly ratesheetValue: RatesheetValue;
  readonly uuid: Scalars['UUID'];
  readonly createdAt: Scalars['DateTimeImmutable'];
  readonly updatedAt: Scalars['DateTimeImmutable'];
};

export type RatesheetTransport = {
  readonly __typename?: 'RatesheetTransport';
  readonly unitPrice: Maybe<Scalars['Int']>;
  readonly billablePrice: Maybe<Scalars['Int']>;
  readonly distanceUnitPrice: Maybe<Scalars['Int']>;
  readonly distanceBillablePrice: Maybe<Scalars['Int']>;
  readonly kms: Maybe<Scalars['Int']>;
  readonly handlingUnitPrice: Maybe<Scalars['Int']>;
  readonly handlingBillablePrice: Maybe<Scalars['Int']>;
  readonly ratesheetValue: Maybe<RatesheetValue>;
  readonly dictionaryTransport: DictionaryTransport;
  readonly code: Maybe<Scalars['String']>;
  readonly uuid: Scalars['UUID'];
  readonly createdAt: Scalars['DateTimeImmutable'];
  readonly updatedAt: Scalars['DateTimeImmutable'];
};

export type RatesheetValue = {
  readonly __typename?: 'RatesheetValue';
  readonly type: Scalars['String'];
  readonly data: Maybe<Scalars['JSON']>;
  readonly ratesheet: Ratesheet;
  readonly ratesheetInternal: RatesheetInternal;
  readonly ratesheetTask: RatesheetTask;
  readonly ratesheetExternal: RatesheetExternal;
  readonly ratesheetTCRole: RatesheetTcRole;
  readonly ratesheetWarehouse: RatesheetWarehouse;
  readonly ratesheetTransport: RatesheetTransport;
  readonly ratesheetBudgetSplit: RatesheetBudgetSplit;
  readonly ratesheetService: RatesheetService;
  readonly ratesheetExpense: RatesheetExpense;
  readonly uuid: Scalars['UUID'];
  readonly createdAt: Scalars['DateTimeImmutable'];
  readonly updatedAt: Scalars['DateTimeImmutable'];
};

export type RatesheetWarehouse = {
  readonly __typename?: 'RatesheetWarehouse';
  readonly qty: Maybe<Scalars['Int']>;
  readonly unitPrice: Maybe<Scalars['Int']>;
  readonly billablePrice: Maybe<Scalars['Int']>;
  readonly ratesheetValue: RatesheetValue;
  readonly dictionaryWarehouse: DictionaryWarehouse;
  readonly description: Maybe<Scalars['String']>;
  readonly uuid: Scalars['UUID'];
  readonly createdAt: Scalars['DateTimeImmutable'];
  readonly updatedAt: Scalars['DateTimeImmutable'];
};

export type Role = {
  readonly __typename?: 'Role';
  readonly name: Scalars['String'];
  readonly code: Maybe<Scalars['String']>;
  readonly information: Maybe<Scalars['String']>;
  readonly permissions: Maybe<Scalars['JSON']>;
  readonly users: ReadonlyArray<Maybe<User>>;
  readonly units: ReadonlyArray<Maybe<RoleUnit>>;
  readonly type: Scalars['String'];
  readonly company: Maybe<Company>;
  readonly priority: Scalars['Int'];
  readonly createdAt: Scalars['DateTimeImmutable'];
  readonly updatedAt: Scalars['DateTimeImmutable'];
  readonly uuid: Scalars['UUID'];
};

export type RoleUnit = {
  readonly __typename?: 'RoleUnit';
  readonly role: Role;
  readonly company: Maybe<Company>;
  readonly user: User;
  readonly project: Maybe<Project>;
  readonly uuid: Scalars['UUID'];
  readonly createdAt: Scalars['DateTimeImmutable'];
  readonly updatedAt: Scalars['DateTimeImmutable'];
};

export type Spo = {
  readonly __typename?: 'SPO';
  readonly project: Maybe<Project>;
  readonly reqNumber: Maybe<Scalars['String']>;
  readonly spoNumber: Maybe<Scalars['String']>;
  readonly subject: Maybe<Scalars['String']>;
  readonly client: Maybe<Client>;
  readonly projectGroup: Maybe<ProjectGroup>;
  readonly issueDate: Maybe<Scalars['DateImmutable']>;
  readonly invoiceItem: Maybe<InvoiceItem>;
  readonly currency: Maybe<Currency>;
  readonly tax: Maybe<Scalars['Float']>;
  readonly requester: Maybe<User>;
  readonly items: ReadonlyArray<Maybe<SpoItem>>;
  readonly company: Company;
  readonly estimatedDeliveryDate: Maybe<Scalars['DateImmutable']>;
  readonly status: Scalars['String'];
  readonly statusNote: Scalars['String'];
  readonly statusNoteFlagged: Scalars['Boolean'];
  readonly statusNoteEditor: Maybe<User>;
  readonly supplier: Maybe<Supplier>;
  readonly notes: Maybe<Scalars['String']>;
  readonly files: ReadonlyArray<Maybe<File>>;
  readonly creator: Maybe<User>;
  readonly reviewer: Maybe<User>;
  readonly filterExpensesByProject: Scalars['Boolean'];
  readonly linkedEstimate: Maybe<Invoice>;
  readonly preferredSupplier: Scalars['Boolean'];
  readonly inMarginDate: Maybe<Scalars['DateImmutable']>;
  readonly totalAmount: Maybe<Scalars['Int']>;
  readonly createdAt: Scalars['DateTimeImmutable'];
  readonly updatedAt: Scalars['DateTimeImmutable'];
  readonly uuid: Scalars['UUID'];
};

export type SpoGroup = {
  readonly __typename?: 'SPOGroup';
  readonly name: Scalars['String'];
  readonly items: ReadonlyArray<Maybe<SpoItem>>;
  readonly expenseGroup: Maybe<ExpenseGroup>;
  readonly createdAt: Scalars['DateTimeImmutable'];
  readonly updatedAt: Scalars['DateTimeImmutable'];
  readonly uuid: Scalars['UUID'];
};

export type SpoItem = {
  readonly __typename?: 'SPOItem';
  readonly name: Scalars['String'];
  readonly description: Maybe<Scalars['String']>;
  readonly quantity: Maybe<Scalars['Float']>;
  readonly qty1: Scalars['Float'];
  readonly qty2: Scalars['Float'];
  readonly unitPrice: Scalars['Int'];
  readonly discount: Maybe<Scalars['Float']>;
  readonly applyTax: Scalars['Boolean'];
  readonly spoGroup: Maybe<SpoGroup>;
  readonly SPO: Spo;
  readonly expense: Maybe<Expense>;
  readonly teamType: Maybe<TeamCostTeamType>;
  readonly service: Maybe<DictionaryService>;
  readonly billableAmount: Scalars['Int'];
  readonly invoiceItem: Maybe<InvoiceItem>;
  readonly type: Scalars['String'];
  readonly margin: Scalars['Float'];
  readonly createdAt: Scalars['DateTimeImmutable'];
  readonly updatedAt: Scalars['DateTimeImmutable'];
  readonly uuid: Scalars['UUID'];
};

export type SampleUnit = {
  readonly __typename?: 'SampleUnit';
  readonly name: Maybe<Scalars['String']>;
  readonly inTray: Maybe<Scalars['Int']>;
  readonly inLayer: Maybe<Scalars['Int']>;
  readonly inPalet: Maybe<Scalars['Int']>;
  readonly isActive: Maybe<Scalars['Boolean']>;
  readonly uuid: Scalars['UUID'];
  readonly createdAt: Scalars['DateTimeImmutable'];
  readonly updatedAt: Scalars['DateTimeImmutable'];
};

export type ScheduleAssignment = {
  readonly __typename?: 'ScheduleAssignment';
  readonly name: Scalars['String'];
  readonly startDay: Maybe<Scalars['Int']>;
  readonly startTime: Scalars['Int'];
  readonly endDay: Maybe<Scalars['Int']>;
  readonly endTime: Scalars['Int'];
  readonly type: Maybe<Scalars['String']>;
  readonly actionTeam: Maybe<ActionTeam>;
  readonly color: Maybe<Scalars['String']>;
  readonly scheduleStartLocations: ReadonlyArray<Maybe<ScheduleStartLocation>>;
  readonly duration: Scalars['Int'];
  readonly startViaCompany: Scalars['Boolean'];
  readonly directToEvent: Scalars['Boolean'];
  readonly createdAt: Scalars['DateTimeImmutable'];
  readonly updatedAt: Scalars['DateTimeImmutable'];
  readonly uuid: Scalars['UUID'];
};

export type ScheduleStartLocation = {
  readonly __typename?: 'ScheduleStartLocation';
  readonly name: Scalars['String'];
  readonly address: Maybe<Scalars['String']>;
  readonly actionTeam: Maybe<ActionTeam>;
  readonly scheduleAssignments: ReadonlyArray<Maybe<ScheduleAssignment>>;
  readonly compositionRoles: ReadonlyArray<Maybe<CompositionRole>>;
  readonly isDefault: Maybe<Scalars['Boolean']>;
  readonly type: Scalars['String'];
  readonly createdAt: Scalars['DateTimeImmutable'];
  readonly updatedAt: Scalars['DateTimeImmutable'];
  readonly uuid: Scalars['UUID'];
};

export type Service = {
  readonly __typename?: 'Service';
  readonly actionTeam: Maybe<ActionTeam>;
  readonly name: Scalars['String'];
  readonly description: Maybe<Scalars['String']>;
  readonly qty: Maybe<Scalars['Int']>;
  readonly unitPrice: Maybe<Scalars['Int']>;
  readonly billablePrice: Maybe<Scalars['Int']>;
  readonly amount: Maybe<Scalars['Int']>;
  readonly billablePriceMargin: Maybe<Scalars['Float']>;
  readonly actionServices: ReadonlyArray<Maybe<ActionService>>;
  readonly ratesheet: Maybe<Ratesheet>;
  readonly dictionaryService: Maybe<DictionaryService>;
  readonly type: Maybe<Scalars['String']>;
  readonly createdAt: Scalars['DateTimeImmutable'];
  readonly updatedAt: Scalars['DateTimeImmutable'];
  readonly uuid: Scalars['UUID'];
};

export type SetCompanyPayrollCodeInput = {
  readonly key: Scalars['String'];
  /** New code value. Omit or pass null to reset the code back to its default. */
  readonly value?: Maybe<Scalars['String']>;
};

export type SetCompanyPayrollRuleInput = {
  readonly jointCommitteeUuid: Scalars['UUID'];
  /** Identifier of this joint committee at the social secretariat. */
  readonly externalJcCode?: Maybe<Scalars['String']>;
  readonly functionCategoryCode?: Maybe<Scalars['String']>;
  readonly functionDescription?: Maybe<Scalars['String']>;
  /** Contract type code at the social secretariat. Null derives it from the professional status. */
  readonly contractType?: Maybe<Scalars['String']>;
  /** Overtime pay percentage relative to the base tariff, e.g. 150 or 200. */
  readonly overtimeRatePercentage?: Maybe<Scalars['Int']>;
  /** Wage code for overtime worked on a Saturday. Null keeps the code derived from the overtime percentage. */
  readonly saturdayOvertimeCode?: Maybe<Scalars['String']>;
  /** Overtime pay percentage for Saturday work. Null keeps the regular overtime percentage. */
  readonly saturdayOvertimeRatePercentage?: Maybe<Scalars['Int']>;
  /** Wage code for overtime worked on a Sunday. Null keeps the code derived from the overtime percentage. */
  readonly sundayOvertimeCode?: Maybe<Scalars['String']>;
  /** Overtime pay percentage for Sunday work. Null keeps the regular overtime percentage. */
  readonly sundayOvertimeRatePercentage?: Maybe<Scalars['Int']>;
  /** Holiday pay percentage relative to the base tariff. */
  readonly holidayRatePercentage?: Maybe<Scalars['Int']>;
  readonly daysPerWeek?: Maybe<Scalars['Int']>;
  readonly hoursPerWeek?: Maybe<Scalars['Int']>;
};

export type SignContractInput = {
  readonly uuid: Scalars['UUID'];
  readonly signJSON: Scalars['JSON'];
  readonly signSVG: Scalars['String'];
};

export type SignPerformanceInput = {
  readonly uuid: Scalars['UUID'];
  readonly signJSON: Scalars['JSON'];
  readonly signSVG: Scalars['String'];
};

export type SimpleEntity = {
  readonly __typename?: 'SimpleEntity';
  readonly uuid: Scalars['UUID'];
  readonly name: Scalars['String'];
};

export type SimpleEntityPaginator = {
  readonly __typename?: 'SimpleEntityPaginator';
  readonly items: ReadonlyArray<SimpleEntity>;
  readonly page: Scalars['Int'];
  readonly limit: Scalars['Int'];
  readonly total: Scalars['Int'];
  /**
   * *     Hash of query parameters.
   * *
   */
  readonly hash: Scalars['String'];
  readonly hasMore: Scalars['Boolean'];
};

export type SocialNetwork = {
  readonly __typename?: 'SocialNetwork';
  readonly socialNetwork: Scalars['String'];
  readonly link: Scalars['String'];
  readonly externalUser: Maybe<ExternalUser>;
  readonly uuid: Scalars['UUID'];
  readonly createdAt: Scalars['DateTimeImmutable'];
  readonly updatedAt: Scalars['DateTimeImmutable'];
};

export enum SortDirection {
  Asc = 'asc',
  Desc = 'desc'
}

export enum SpoPermission {
  View = 'VIEW',
  Edit = 'EDIT',
  ChangeStatus = 'CHANGE_STATUS',
  Duplicate = 'DUPLICATE',
  Flag = 'FLAG'
}

export type StaffingCostBudgetItem = {
  readonly __typename?: 'StaffingCostBudgetItem';
  readonly task: ProjectTask;
  readonly project: Project;
  readonly name: Scalars['String'];
  readonly qty: Scalars['Int'];
  readonly discount: Scalars['Int'];
  readonly unitPrice: Scalars['Int'];
  readonly billablePrice: Scalars['Int'];
  readonly description: Maybe<Scalars['String']>;
  readonly createdAt: Scalars['DateTimeImmutable'];
  readonly updatedAt: Scalars['DateTimeImmutable'];
  readonly uuid: Scalars['UUID'];
};

export enum StartLocationType {
  ViaCompany = 'VIA_COMPANY',
  AtCompany = 'AT_COMPANY',
  DirectToEvent = 'DIRECT_TO_EVENT'
}

export type SubmitFormAnswerInput = {
  readonly formElementUuid: Scalars['UUID'];
  readonly value: Scalars['String'];
};

export type SubmitFormInput = {
  readonly formUuid: Scalars['UUID'];
  readonly answers?: Maybe<ReadonlyArray<SubmitFormAnswerInput>>;
};

export type Supplier = {
  readonly __typename?: 'Supplier';
  readonly name: Scalars['String'];
  readonly language: Maybe<Scalars['String']>;
  readonly company: Company;
  readonly phones: ReadonlyArray<Maybe<SupplierPhone>>;
  readonly emails: ReadonlyArray<Maybe<SupplierEmail>>;
  readonly category: Maybe<CompanyCategory>;
  readonly status: Scalars['String'];
  readonly timezone: Maybe<Timezone>;
  readonly country: Maybe<GeoCountry>;
  readonly city: Maybe<GeoCity>;
  readonly invoices: ReadonlyArray<Maybe<Invoice>>;
  readonly estimates: ReadonlyArray<Maybe<Estimate>>;
  readonly contactSupplierRoles: ReadonlyArray<Maybe<ContactSupplierRole>>;
  readonly zip: Maybe<Scalars['String']>;
  readonly logo: Maybe<Scalars['String']>;
  readonly address: Maybe<Scalars['String']>;
  readonly address2: Maybe<Scalars['String']>;
  readonly projects: ReadonlyArray<Maybe<Project>>;
  readonly returnComissions: Maybe<Scalars['Int']>;
  readonly SPOs: ReadonlyArray<Maybe<Spo>>;
  readonly btwVat: Maybe<Scalars['String']>;
  readonly bic: Maybe<Scalars['String']>;
  readonly bankAccount: Maybe<Scalars['String']>;
  readonly currency: Maybe<Currency>;
  readonly isLinkedToBookkeeping: Scalars['Boolean'];
  readonly partyId: Maybe<Scalars['UUID']>;
  readonly projectsCount: Scalars['Int'];
  readonly cost: Scalars['Int'];
  readonly preferredSupplier: Scalars['Boolean'];
  readonly createdAt: Scalars['DateTimeImmutable'];
  readonly updatedAt: Scalars['DateTimeImmutable'];
  readonly uuid: Scalars['UUID'];
};

export type SupplierEmail = {
  readonly __typename?: 'SupplierEmail';
  readonly supplier: Maybe<Supplier>;
  readonly label: Maybe<Scalars['String']>;
  readonly email: Scalars['String'];
  readonly createdAt: Scalars['DateTimeImmutable'];
  readonly updatedAt: Scalars['DateTimeImmutable'];
  readonly uuid: Scalars['UUID'];
};

export type SupplierPhone = {
  readonly __typename?: 'SupplierPhone';
  readonly supplier: Maybe<Supplier>;
  readonly label: Maybe<Scalars['String']>;
  readonly number: Scalars['String'];
  readonly createdAt: Scalars['DateTimeImmutable'];
  readonly updatedAt: Scalars['DateTimeImmutable'];
  readonly uuid: Scalars['UUID'];
};

export type TcCompositionRole = {
  readonly __typename?: 'TCCompositionRole';
  readonly defaultCostPricePerHour: Maybe<Scalars['Int']>;
  readonly defaultSellPricePerHour: Maybe<Scalars['Int']>;
  readonly costPricePerHour: Maybe<Scalars['Int']>;
  readonly sellPricePerHour: Maybe<Scalars['Int']>;
  readonly overtimeCostPricePerHour: Maybe<Scalars['Int']>;
  readonly overtimeSellPricePerHour: Maybe<Scalars['Int']>;
  readonly transportCostPricePerDistanceUnit: Maybe<Scalars['Int']>;
  readonly transportSellPricePerDistanceUnit: Maybe<Scalars['Int']>;
  readonly transportDistance: Maybe<Scalars['Float']>;
  readonly planningCostPrice: Maybe<Scalars['Int']>;
  readonly planningSellPrice: Maybe<Scalars['Int']>;
  readonly mealAllowanceCostPrice: Maybe<Scalars['Int']>;
  readonly mealAllowanceSellPrice: Maybe<Scalars['Int']>;
  readonly dryCleaningCostPrice: Maybe<Scalars['Int']>;
  readonly dryCleaningSellPrice: Maybe<Scalars['Int']>;
  readonly normalRatePercentage: Scalars['Int'];
  readonly overtimeRatePercentage: Scalars['Int'];
  readonly teamCost: Maybe<TeamCost>;
  readonly scheduleStartLocation: Maybe<TcScheduleStartLocation>;
  readonly quantity: Maybe<Scalars['Int']>;
  readonly roleName: Scalars['String'];
  readonly holidayHourCostPrice: Maybe<Scalars['Int']>;
  readonly holidayHourSellPrice: Maybe<Scalars['Int']>;
  readonly holidayOvertimeCostPrice: Maybe<Scalars['Int']>;
  readonly holidayOvertimeSellPrice: Maybe<Scalars['Int']>;
  readonly costPrice: Maybe<Scalars['Int']>;
  readonly sellPrice: Maybe<Scalars['Int']>;
  readonly defaultCostPerHourUnitPrice: Maybe<Scalars['Int']>;
  readonly defaultCostPerHourBillablePrice: Maybe<Scalars['Int']>;
  readonly hourPricePercentage: Maybe<Scalars['Int']>;
  readonly hourPriceUnitPrice: Maybe<Scalars['Int']>;
  readonly hourPriceBillablePrice: Maybe<Scalars['Int']>;
  readonly overtimePricePercentage: Maybe<Scalars['Int']>;
  readonly overtimePriceUnitPrice: Maybe<Scalars['Int']>;
  readonly overtimePriceBillablePrice: Maybe<Scalars['Int']>;
  readonly holidayHourPricePercentage: Maybe<Scalars['Int']>;
  readonly holidayHourPriceUnitPrice: Maybe<Scalars['Int']>;
  readonly holidayHourPriceBillablePrice: Maybe<Scalars['Int']>;
  readonly holidayOvertimePricePercentage: Maybe<Scalars['Int']>;
  readonly holidayOvertimePriceUnitPrice: Maybe<Scalars['Int']>;
  readonly holidayOvertimePriceBillablePrice: Maybe<Scalars['Int']>;
  readonly distancePricePerKmUnitPrice: Maybe<Scalars['Int']>;
  readonly distancePricePerKmBillablePrice: Maybe<Scalars['Int']>;
  readonly ownCarViaUnitPrice: Maybe<Scalars['Int']>;
  readonly ownCarViaBillablePrice: Maybe<Scalars['Int']>;
  readonly ownCarDirectUnitPrice: Maybe<Scalars['Int']>;
  readonly ownCarDirectBillablePrice: Maybe<Scalars['Int']>;
  readonly distance: Maybe<Scalars['Float']>;
  readonly fullness: Scalars['Int'];
  readonly teamCostRole: Maybe<TeamCostRole>;
  readonly parent: Maybe<TcCompositionRole>;
  readonly children: ReadonlyArray<Maybe<TcCompositionRole>>;
  readonly dataSource: Maybe<Scalars['String']>;
  readonly billableHours: Maybe<Scalars['DateTimeImmutable']>;
  readonly bookingPersons: ReadonlyArray<Maybe<BookingPerson>>;
  readonly contracts: ReadonlyArray<Maybe<Contract>>;
  readonly createdAt: Scalars['DateTimeImmutable'];
  readonly updatedAt: Scalars['DateTimeImmutable'];
  readonly uuid: Scalars['UUID'];
  readonly snapshot: Scalars['Boolean'];
};

export type TcMaterialGroupItem = {
  readonly __typename?: 'TCMaterialGroupItem';
  readonly projectMaterialGroupItem: ProjectMaterialGroupItem;
  readonly teamCost: Maybe<TeamCost>;
  readonly qty: Maybe<Scalars['Int']>;
  readonly estimated: Maybe<Scalars['Float']>;
  readonly transported: Maybe<Scalars['Float']>;
  readonly inTray: Maybe<Scalars['Int']>;
  readonly inLayer: Maybe<Scalars['Int']>;
  readonly inPalet: Maybe<Scalars['Int']>;
  readonly inChecklist: Scalars['Boolean'];
  readonly iceBoxes: Maybe<Scalars['Int']>;
  readonly layersOnPallet: Maybe<Scalars['Int']>;
  readonly iceCubes: Maybe<Scalars['Int']>;
  readonly createdAt: Scalars['DateTimeImmutable'];
  readonly updatedAt: Scalars['DateTimeImmutable'];
  readonly uuid: Scalars['UUID'];
};

export type TcScheduleAssignmentTag = {
  readonly __typename?: 'TCScheduleAssignmentTag';
  readonly name: Scalars['String'];
  readonly code: Maybe<TcScheduleAssignmentTagCode>;
  readonly color: Maybe<Scalars['String']>;
  readonly position: Scalars['Int'];
  readonly createdAt: Scalars['DateTimeImmutable'];
  readonly updatedAt: Scalars['DateTimeImmutable'];
  readonly uuid: Scalars['UUID'];
  readonly snapshot: Scalars['Boolean'];
};

export enum TcScheduleAssignmentTagCode {
  PickUp = 'PICK_UP',
  TravelToEvent = 'TRAVEL_TO_EVENT',
  Build = 'BUILD',
  StartEvent = 'START_EVENT',
  CleanUp = 'CLEAN_UP',
  TravelToCompany = 'TRAVEL_TO_COMPANY',
  UnloadingAndDebriefingCompany = 'UNLOADING_AND_DEBRIEFING_COMPANY'
}

export type TcScheduleStartLocation = {
  readonly __typename?: 'TCScheduleStartLocation';
  readonly name: Scalars['String'];
  readonly address: Maybe<Scalars['String']>;
  readonly teamCost: Maybe<TeamCost>;
  readonly viaCompany: Maybe<TeamCostViaCompany>;
  readonly scheduleAssignments: ReadonlyArray<Maybe<TeamCostScheduleAssignment>>;
  readonly compositionRoles: ReadonlyArray<Maybe<TcCompositionRole>>;
  readonly isDefault: Maybe<Scalars['Boolean']>;
  readonly type: Scalars['String'];
  readonly createdAt: Scalars['DateTimeImmutable'];
  readonly updatedAt: Scalars['DateTimeImmutable'];
  readonly uuid: Scalars['UUID'];
  readonly snapshot: Scalars['Boolean'];
};

export type TcService = {
  readonly __typename?: 'TCService';
  readonly teamCost: TeamCost;
  readonly name: Scalars['String'];
  readonly description: Maybe<Scalars['String']>;
  readonly qty: Maybe<Scalars['Float']>;
  readonly unitPrice: Maybe<Scalars['Int']>;
  readonly billablePrice: Maybe<Scalars['Int']>;
  readonly amount: Maybe<Scalars['Int']>;
  readonly billablePriceMargin: Maybe<Scalars['Float']>;
  readonly dictionaryService: DictionaryService;
  readonly type: Maybe<Scalars['String']>;
  readonly createdAt: Scalars['DateTimeImmutable'];
  readonly updatedAt: Scalars['DateTimeImmutable'];
  readonly uuid: Scalars['UUID'];
  readonly snapshot: Scalars['Boolean'];
};

export type TcTask = {
  readonly __typename?: 'TCTask';
  readonly teamCost: TeamCost;
  readonly name: Scalars['String'];
  readonly description: Maybe<Scalars['String']>;
  readonly qty: Maybe<Scalars['Float']>;
  readonly unitPrice: Maybe<Scalars['Int']>;
  readonly billablePrice: Maybe<Scalars['Int']>;
  readonly amount: Maybe<Scalars['Int']>;
  readonly billablePriceMargin: Maybe<Scalars['Float']>;
  readonly task: Task;
  readonly type: Maybe<Scalars['String']>;
  readonly projectTask: Maybe<ProjectTask>;
  readonly createdAt: Scalars['DateTimeImmutable'];
  readonly updatedAt: Scalars['DateTimeImmutable'];
  readonly uuid: Scalars['UUID'];
  readonly snapshot: Scalars['Boolean'];
};

export type TcTransport = {
  readonly __typename?: 'TCTransport';
  readonly isParentTransport: Scalars['Boolean'];
  readonly teamCost: TeamCost;
  readonly qty: Maybe<Scalars['Int']>;
  readonly distance: Maybe<Scalars['Float']>;
  readonly name: Scalars['String'];
  readonly distanceUnitPrice: Maybe<Scalars['Int']>;
  readonly distanceBillablePrice: Maybe<Scalars['Int']>;
  readonly totalUnitPrice: Maybe<Scalars['Int']>;
  readonly totalBillablePrice: Maybe<Scalars['Int']>;
  readonly totalDistanceUnitPrice: Maybe<Scalars['Int']>;
  readonly costUnitPrice: Maybe<Scalars['Int']>;
  readonly costBillablePrice: Maybe<Scalars['Int']>;
  readonly totalDistanceBillablePrice: Maybe<Scalars['Int']>;
  readonly code: Maybe<Scalars['String']>;
  readonly totalCostUnitPrice: Maybe<Scalars['Int']>;
  readonly totalCostBillablePrice: Maybe<Scalars['Int']>;
  readonly dictionaryTransport: DictionaryTransport;
  readonly handlingUnitPrice: Maybe<Scalars['Int']>;
  readonly handlingBillablePrice: Maybe<Scalars['Int']>;
  readonly kms: Maybe<Scalars['Int']>;
  readonly actionDay: Maybe<Scalars['Int']>;
  readonly status: Maybe<Scalars['String']>;
  readonly kmAfter: Maybe<Scalars['Int']>;
  readonly kmBefore: Maybe<Scalars['Int']>;
  readonly distanceTravelled: Maybe<Scalars['Int']>;
  readonly remark: Maybe<Scalars['String']>;
  readonly licensePlate: Maybe<Scalars['String']>;
  readonly invoiceNo: Maybe<Scalars['String']>;
  readonly owner: Maybe<Supplier>;
  readonly driver: Maybe<ExternalUser>;
  readonly own: Scalars['Boolean'];
  readonly createdAt: Scalars['DateTimeImmutable'];
  readonly updatedAt: Scalars['DateTimeImmutable'];
  readonly uuid: Scalars['UUID'];
  readonly snapshot: Scalars['Boolean'];
};

export type Tag = {
  readonly __typename?: 'Tag';
  readonly name: Scalars['String'];
  readonly projects: ReadonlyArray<Maybe<Project>>;
  readonly actions: ReadonlyArray<Maybe<Action>>;
  readonly projectGroups: ReadonlyArray<Maybe<ProjectGroup>>;
  readonly externalUsers: ReadonlyArray<Maybe<ExternalUser>>;
  readonly company: Company;
  readonly uuid: Scalars['UUID'];
  readonly createdAt: Scalars['DateTimeImmutable'];
  readonly updatedAt: Scalars['DateTimeImmutable'];
};

export type TargetGroupsGender = {
  readonly __typename?: 'TargetGroupsGender';
  readonly gender: Maybe<Scalars['String']>;
  readonly targetGroup: Maybe<ChannelTargetGroup>;
  readonly uuid: Scalars['UUID'];
  readonly createdAt: Scalars['DateTimeImmutable'];
  readonly updatedAt: Scalars['DateTimeImmutable'];
};

export type Task = {
  readonly __typename?: 'Task';
  readonly name: Scalars['String'];
  readonly description: Scalars['String'];
  readonly unitPrice: Maybe<Scalars['Int']>;
  readonly billableRate: Maybe<Scalars['Int']>;
  readonly sellPrice: Maybe<Scalars['Int']>;
  readonly hour: Maybe<Scalars['Int']>;
  readonly company: Maybe<Company>;
  readonly defaultHourlyRate: Maybe<Scalars['Int']>;
  readonly defaultBillable: Scalars['Boolean'];
  readonly defaultTask: Maybe<Scalars['Boolean']>;
  readonly status: Scalars['String'];
  readonly taskGroups: ReadonlyArray<Maybe<TaskGroup>>;
  readonly taskRole: Maybe<TaskRole>;
  readonly projectTasks: ReadonlyArray<Maybe<ProjectTask>>;
  readonly taskGroup: Maybe<TaskGroup>;
  readonly ratesheet: Maybe<Ratesheet>;
  readonly ratesheetTasks: ReadonlyArray<Maybe<RatesheetTask>>;
  readonly createdAt: Scalars['DateTimeImmutable'];
  readonly updatedAt: Scalars['DateTimeImmutable'];
  readonly uuid: Scalars['UUID'];
};

export type TaskGroup = {
  readonly __typename?: 'TaskGroup';
  readonly name: Scalars['String'];
  readonly description: Scalars['String'];
  readonly type: Maybe<TaskType>;
  readonly company: Maybe<Company>;
  readonly status: Scalars['String'];
  readonly defaultBillable: Scalars['Boolean'];
  readonly defaultTask: Maybe<Scalars['Boolean']>;
  readonly tasks: ReadonlyArray<Maybe<Task>>;
  readonly projectTaskGroup: ReadonlyArray<Maybe<ProjectTaskGroup>>;
  readonly task: Task;
  readonly createdAt: Scalars['DateTimeImmutable'];
  readonly updatedAt: Scalars['DateTimeImmutable'];
  readonly uuid: Scalars['UUID'];
};

export type TaskRole = {
  readonly __typename?: 'TaskRole';
  readonly name: Scalars['String'];
  readonly company: Maybe<Company>;
  readonly status: Scalars['String'];
  readonly tasks: ReadonlyArray<Maybe<Task>>;
  readonly createdAt: Scalars['DateTimeImmutable'];
  readonly updatedAt: Scalars['DateTimeImmutable'];
  readonly uuid: Scalars['UUID'];
};

export type TaskType = {
  readonly __typename?: 'TaskType';
  readonly name: Scalars['String'];
  readonly uuid: Scalars['UUID'];
  readonly createdAt: Scalars['DateTimeImmutable'];
  readonly updatedAt: Scalars['DateTimeImmutable'];
};

export type TaxRate = {
  readonly __typename?: 'TaxRate';
  readonly getIsUsed: Scalars['Boolean'];
  readonly name: Scalars['String'];
  readonly taxRate: Scalars['Float'];
  readonly code: Scalars['String'];
  readonly company: Company;
  readonly status: Scalars['String'];
  readonly createdAt: Scalars['DateTimeImmutable'];
  readonly updatedAt: Scalars['DateTimeImmutable'];
  readonly uuid: Scalars['UUID'];
};

export type TeamCost = {
  readonly __typename?: 'TeamCost';
  readonly started: Scalars['Boolean'];
  readonly end: Scalars['Boolean'];
  readonly estimateLabel: Scalars['String'];
  readonly scheduleForClient: Maybe<ReadonlyArray<TeamCostScheduleAssignment>>;
  readonly name: Scalars['String'];
  readonly invoiceItem: Maybe<InvoiceItem>;
  readonly materialFiles: ReadonlyArray<Maybe<File>>;
  readonly transports: ReadonlyArray<TcTransport>;
  readonly normalHours: Maybe<Scalars['DateTimeImmutable']>;
  readonly breakHours: Maybe<Scalars['DateTimeImmutable']>;
  readonly substractBreakHours: Maybe<Scalars['Boolean']>;
  readonly services: ReadonlyArray<Maybe<TcService>>;
  readonly tasks: ReadonlyArray<Maybe<TcTask>>;
  readonly scheduleStartLocations: ReadonlyArray<Maybe<TcScheduleStartLocation>>;
  readonly scheduleAssignments: ReadonlyArray<Maybe<TeamCostScheduleAssignment>>;
  readonly compositionReservePercentage: Maybe<Scalars['Float']>;
  readonly compositionRoles: ReadonlyArray<TcCompositionRole>;
  readonly billablePrice: Maybe<Scalars['Int']>;
  readonly unitPrice: Maybe<Scalars['Int']>;
  readonly margin: Maybe<Scalars['Float']>;
  readonly materialGroupItems: Maybe<ReadonlyArray<TcMaterialGroupItem>>;
  readonly totalCost: Maybe<Scalars['Int']>;
  readonly realTeamCost: Maybe<Scalars['Int']>;
  readonly compositionRolesTotalUnitPrice: Maybe<Scalars['Int']>;
  readonly compositionRolesTotalBillablePrice: Maybe<Scalars['Int']>;
  readonly servicesTotalUnitPrice: Maybe<Scalars['Int']>;
  readonly servicesTotalBillablePrice: Maybe<Scalars['Int']>;
  readonly transportsTotalUnitPrice: Maybe<Scalars['Int']>;
  readonly transportsTotalBillablePrice: Maybe<Scalars['Int']>;
  readonly startTime: Maybe<Scalars['Int']>;
  readonly endTime: Maybe<Scalars['Int']>;
  readonly extraCost: Scalars['Int'];
  readonly substractBreakHoursForClient: Maybe<Scalars['Boolean']>;
  readonly substractBreakHoursForHR: Maybe<Scalars['Boolean']>;
  readonly applyHolidayRates: Maybe<Scalars['Boolean']>;
  readonly startDate: Maybe<Scalars['DateTimeImmutable']>;
  readonly endDate: Maybe<Scalars['DateTimeImmutable']>;
  readonly startDateUTC: Maybe<Scalars['DateTimeImmutable']>;
  readonly endDateUTC: Maybe<Scalars['DateTimeImmutable']>;
  readonly viaCompanyStartDate: Maybe<Scalars['DateTimeImmutable']>;
  readonly viaCompanyEndDate: Maybe<Scalars['DateTimeImmutable']>;
  readonly viaCompanyStartDateUTC: Maybe<Scalars['DateTimeImmutable']>;
  readonly viaCompanyEndDateUTC: Maybe<Scalars['DateTimeImmutable']>;
  readonly directToEventStartDate: Maybe<Scalars['DateTimeImmutable']>;
  readonly directToEventEndDate: Maybe<Scalars['DateTimeImmutable']>;
  readonly directToEventStartDateUTC: Maybe<Scalars['DateTimeImmutable']>;
  readonly directToEventEndDateUTC: Maybe<Scalars['DateTimeImmutable']>;
  readonly tzOffset: Scalars['Int'];
  readonly actions: Maybe<ReadonlyArray<Action>>;
  readonly action: Action;
  readonly type: ActionTeamType;
  readonly scheduleAssignmentsWithTags: Maybe<ReadonlyArray<TeamCostScheduleAssignment>>;
  readonly projectedSamples: Maybe<Scalars['Int']>;
  readonly projectedContacts: Maybe<Scalars['Int']>;
  readonly debriefing: Maybe<Form>;
  readonly clientForm: Maybe<Form>;
  readonly companyForm: Maybe<Form>;
  readonly createdAt: Scalars['DateTimeImmutable'];
  readonly updatedAt: Scalars['DateTimeImmutable'];
  readonly uuid: Scalars['UUID'];
  readonly snapshot: Scalars['Boolean'];
};

export type TeamCostBudgetItem = {
  readonly __typename?: 'TeamCostBudgetItem';
  readonly actionTeam: ActionTeam;
  readonly project: Project;
  readonly name: Scalars['String'];
  readonly qty: Scalars['Int'];
  readonly discount: Scalars['Int'];
  readonly unitPrice: Scalars['Int'];
  readonly billablePrice: Scalars['Int'];
  readonly description: Maybe<Scalars['String']>;
  readonly createdAt: Scalars['DateTimeImmutable'];
  readonly updatedAt: Scalars['DateTimeImmutable'];
  readonly uuid: Scalars['UUID'];
};

export type TeamCostJointCommittee = {
  readonly __typename?: 'TeamCostJointCommittee';
  readonly status: Scalars['String'];
  readonly name: Scalars['String'];
  readonly code: Maybe<Scalars['String']>;
  readonly isRegular: Scalars['Boolean'];
  readonly isStudent: Scalars['Boolean'];
  readonly isFlex: Scalars['Boolean'];
  readonly isFreelance: Scalars['Boolean'];
  readonly uuid: Scalars['UUID'];
};

export type TeamCostLevel = {
  readonly __typename?: 'TeamCostLevel';
  readonly status: Scalars['String'];
  readonly teamCostRoles: ReadonlyArray<Maybe<TeamCostRole>>;
  readonly name: Scalars['String'];
  readonly costPrice: Maybe<Scalars['Int']>;
  readonly regularRate: Maybe<Scalars['Int']>;
  readonly studentRate: Maybe<Scalars['Int']>;
  readonly flexRate: Maybe<Scalars['Int']>;
  readonly freelanceRate: Maybe<Scalars['Int']>;
  readonly uuid: Scalars['UUID'];
};

export type TeamCostRole = {
  readonly __typename?: 'TeamCostRole';
  readonly status: Scalars['String'];
  readonly name: Scalars['String'];
  readonly company: Company;
  readonly compositionRole: ReadonlyArray<Maybe<TcCompositionRole>>;
  readonly ratesheetTcRoles: ReadonlyArray<Maybe<RatesheetTcRole>>;
  readonly teamCostLevel: Maybe<TeamCostLevel>;
  readonly regularJc: Maybe<TeamCostJointCommittee>;
  readonly studentJc: Maybe<TeamCostJointCommittee>;
  readonly flexJc: Maybe<TeamCostJointCommittee>;
  readonly freelanceJc: Maybe<TeamCostJointCommittee>;
  readonly color: Maybe<Scalars['String']>;
  readonly uuid: Scalars['UUID'];
  readonly createdAt: Scalars['DateTimeImmutable'];
  readonly updatedAt: Scalars['DateTimeImmutable'];
};

export type TeamCostScheduleAssignment = {
  readonly __typename?: 'TeamCostScheduleAssignment';
  readonly name: Scalars['String'];
  readonly startDay: Maybe<Scalars['Int']>;
  readonly startTime: Scalars['Int'];
  readonly endDay: Maybe<Scalars['Int']>;
  readonly endTime: Scalars['Int'];
  readonly type: Maybe<Scalars['String']>;
  readonly teamCost: Maybe<TeamCost>;
  readonly color: Maybe<Scalars['String']>;
  readonly scheduleStartLocations: ReadonlyArray<Maybe<TcScheduleStartLocation>>;
  readonly duration: Scalars['Int'];
  readonly startViaCompany: Scalars['Boolean'];
  readonly directToEvent: Scalars['Boolean'];
  readonly position: Scalars['Int'];
  readonly tag: Maybe<TcScheduleAssignmentTag>;
  readonly peopleCount: Scalars['Int'];
  readonly createdAt: Scalars['DateTimeImmutable'];
  readonly updatedAt: Scalars['DateTimeImmutable'];
  readonly uuid: Scalars['UUID'];
  readonly snapshot: Scalars['Boolean'];
};

export type TeamCostTeamType = {
  readonly __typename?: 'TeamCostTeamType';
  readonly name: Scalars['String'];
  readonly status: Scalars['String'];
  readonly createdAt: Scalars['DateTimeImmutable'];
  readonly updatedAt: Scalars['DateTimeImmutable'];
  readonly uuid: Scalars['UUID'];
};

export type TeamCostViaCompany = {
  readonly __typename?: 'TeamCostViaCompany';
  readonly isDefault: Scalars['Boolean'];
  readonly name: Scalars['String'];
  readonly address: Scalars['String'];
  readonly company: Company;
  readonly status: Scalars['String'];
  readonly location: Maybe<TeamCostViaCompanyLocation>;
  readonly uuid: Scalars['UUID'];
  readonly createdAt: Scalars['DateTimeImmutable'];
  readonly updatedAt: Scalars['DateTimeImmutable'];
};

export type TeamCostViaCompanyLocation = {
  readonly __typename?: 'TeamCostViaCompanyLocation';
  readonly cityName: Maybe<Scalars['String']>;
  readonly viaCompany: TeamCostViaCompany;
  readonly name: Maybe<Scalars['String']>;
  readonly address: Maybe<Scalars['String']>;
  readonly lat: Maybe<Scalars['Float']>;
  readonly lng: Maybe<Scalars['Float']>;
  readonly rawDataType: Scalars['String'];
  readonly rawData: Scalars['JSON'];
  readonly uuid: Scalars['UUID'];
  readonly createdAt: Scalars['DateTimeImmutable'];
  readonly updatedAt: Scalars['DateTimeImmutable'];
};

export type TimeTrack = {
  readonly __typename?: 'TimeTrack';
  readonly name: Maybe<Scalars['String']>;
  readonly description: Maybe<Scalars['String']>;
  readonly date: Scalars['DateTimeImmutable'];
  readonly lastStartedDate: Scalars['DateTimeImmutable'];
  readonly amountOfTimeSeconds: Maybe<Scalars['Float']>;
  readonly person: Maybe<User>;
  readonly projectTask: Maybe<ProjectTask>;
  readonly status: TimeTrackStatus;
  readonly note: Maybe<Scalars['String']>;
  readonly project: Maybe<Project>;
  readonly projectTeamMember: Maybe<ProjectTeamMember>;
  readonly billableRate: Scalars['Int'];
  readonly billableCost: Scalars['Int'];
  readonly realCost: Scalars['Int'];
  readonly type: TimeTrackType;
  readonly createdAt: Scalars['DateTimeImmutable'];
  readonly updatedAt: Scalars['DateTimeImmutable'];
  readonly uuid: Scalars['UUID'];
};

export type TimeTrackPaginator = {
  readonly __typename?: 'TimeTrackPaginator';
  readonly items: ReadonlyArray<TimeTrack>;
  readonly page: Scalars['Int'];
  readonly limit: Scalars['Int'];
  readonly total: Scalars['Int'];
  /**
   * *     Hash of query parameters.
   * *
   */
  readonly hash: Scalars['String'];
  readonly hasMore: Scalars['Boolean'];
};

export type TimeTrackQueryInput = {
  readonly sort?: Maybe<ReadonlyArray<TimeTrackSortItem>>;
  readonly uuids?: Maybe<ReadonlyArray<Scalars['UUID']>>;
  readonly dateLTE?: Maybe<Scalars['DateImmutable']>;
  readonly dateGTE?: Maybe<Scalars['DateImmutable']>;
  readonly dates?: Maybe<ReadonlyArray<Scalars['DateImmutable']>>;
  readonly excludeDates?: Maybe<ReadonlyArray<Scalars['DateImmutable']>>;
  /**
   * *      User UUIDs filter. If present, will return entries for specified
   * *      users instead of own ones.
   * *
   */
  readonly userUUIDs?: Maybe<ReadonlyArray<Scalars['UUID']>>;
  /**
   * *    Will load all entries.
   * *    Can be used only with dates field, and dates field must contain only one element.
   * *
   */
  readonly loadAll?: Maybe<Scalars['Boolean']>;
  readonly type?: Maybe<TimeTrackType>;
  readonly excludeNonProjectLevelTasksWhenTrackingByProject?: Maybe<Scalars['Boolean']>;
  /**
   * *    Accepts positive number, maximum `1000`.
   * *    Default `1`.
   * *
   */
  readonly page?: Maybe<Scalars['Int']>;
  /**
   * *    Accepts any positive number or zero, maximum `1000`.
   * *    Zero can be used for calculate totals.
   * *    Default `20`.
   * *
   */
  readonly limit?: Maybe<Scalars['Int']>;
};

export type TimeTrackSortItem = {
  readonly by?: Maybe<TimeTrackSortType>;
  readonly direction?: Maybe<SortDirection>;
};

export enum TimeTrackSortType {
  Date = 'DATE',
  CreatedAt = 'CREATED_AT'
}

export type TimeTrackStatByDate = {
  readonly __typename?: 'TimeTrackStatByDate';
  readonly date: Scalars['DateImmutable'];
  readonly trackedSeconds: Scalars['Int'];
  readonly totalEntries: Scalars['Int'];
};

export type TimeTrackStatByDatePaginator = {
  readonly __typename?: 'TimeTrackStatByDatePaginator';
  readonly items: ReadonlyArray<TimeTrackStatByDate>;
  readonly page: Scalars['Int'];
  readonly limit: Scalars['Int'];
  readonly total: Scalars['Int'];
  /**
   * *     Hash of query parameters.
   * *
   */
  readonly hash: Scalars['String'];
  readonly hasMore: Scalars['Boolean'];
};

export enum TimeTrackStatus {
  Started = 'STARTED',
  Stopped = 'STOPPED'
}

export enum TimeTrackType {
  Default = 'DEFAULT',
  WeekViewStub = 'WEEK_VIEW_STUB'
}

export enum TimeslotType {
  TypeTask = 'TYPE_TASK',
  TypeLeaveHoliday = 'TYPE_LEAVE_HOLIDAY'
}

export type Timezone = {
  readonly __typename?: 'Timezone';
  readonly name: Scalars['String'];
  readonly gmt: Maybe<Scalars['Int']>;
  readonly clients: ReadonlyArray<Maybe<Client>>;
  readonly users: ReadonlyArray<Maybe<User>>;
  readonly uuid: Scalars['UUID'];
  readonly createdAt: Scalars['DateTimeImmutable'];
  readonly updatedAt: Scalars['DateTimeImmutable'];
};

export type ToggleTimeTrackInput = {
  readonly uuid: Scalars['UUID'];
  readonly state: TimeTrackStatus;
};

export type Transport = {
  readonly __typename?: 'Transport';
  readonly actionTeam: Maybe<ActionTeam>;
  readonly qty: Maybe<Scalars['Int']>;
  readonly distance: Maybe<Scalars['Float']>;
  readonly ratesheet: Maybe<Ratesheet>;
  readonly name: Scalars['String'];
  readonly distanceUnitPrice: Maybe<Scalars['Int']>;
  readonly distanceBillablePrice: Maybe<Scalars['Int']>;
  readonly totalUnitPrice: Maybe<Scalars['Int']>;
  readonly totalBillablePrice: Maybe<Scalars['Int']>;
  readonly totalDistanceUnitPrice: Maybe<Scalars['Int']>;
  readonly costUnitPrice: Maybe<Scalars['Int']>;
  readonly costBillablePrice: Maybe<Scalars['Int']>;
  readonly totalDistanceBillablePrice: Maybe<Scalars['Int']>;
  readonly code: Maybe<Scalars['String']>;
  readonly totalCostUnitPrice: Maybe<Scalars['Int']>;
  readonly totalCostBillablePrice: Maybe<Scalars['Int']>;
  readonly dictionaryTransport: Maybe<DictionaryTransport>;
  readonly handlingUnitPrice: Maybe<Scalars['Int']>;
  readonly handlingBillablePrice: Maybe<Scalars['Int']>;
  readonly kms: Maybe<Scalars['Int']>;
  readonly actionDay: Maybe<Scalars['Int']>;
  readonly status: Maybe<Scalars['String']>;
  readonly kmAfter: Maybe<Scalars['Int']>;
  readonly kmBefore: Maybe<Scalars['Int']>;
  readonly distanceTravelled: Maybe<Scalars['Int']>;
  readonly remark: Maybe<Scalars['String']>;
  readonly licensePlate: Maybe<Scalars['String']>;
  readonly invoiceNo: Maybe<Scalars['String']>;
  readonly owner: Maybe<Supplier>;
  readonly driver: Maybe<ExternalUser>;
  readonly own: Scalars['Boolean'];
  readonly createdAt: Scalars['DateTimeImmutable'];
  readonly updatedAt: Scalars['DateTimeImmutable'];
  readonly uuid: Scalars['UUID'];
};

export type Types = {
  readonly __typename?: 'Types';
  readonly permission: Maybe<Permission>;
  readonly projectPermission: Maybe<ProjectPermission>;
  readonly spoPermission: Maybe<SpoPermission>;
  readonly invoicePermission: Maybe<InvoicePermission>;
  readonly event: Maybe<Event>;
  readonly userActivityAction: Maybe<UserActivityAction>;
  readonly invoiceEvent: Maybe<InvoiceEvent>;
  readonly contarctTemplateTags: Maybe<ContractDocumentTemplateTag>;
  readonly contractTariffBase: Maybe<ContractTariffBase>;
  readonly tcScheduleAssignmentTagCode: Maybe<TcScheduleAssignmentTagCode>;
  readonly actionSettings: Maybe<AppSettings>;
  readonly formElementTypes: Maybe<FormElementTypes>;
  readonly startLocationType: Maybe<StartLocationType>;
  readonly professionalStatusForPointHr: Maybe<ProfessionalStatusForPointHr>;
  readonly degree: Maybe<Degree>;
  readonly availabilityStatus: Maybe<AvailabilityStatus>;
};


export type UnpublishActionInput = {
  readonly uuid: Scalars['UUID'];
};

export type UpdateActionByClientActionLocationInput = {
  readonly name?: Maybe<Scalars['String']>;
  readonly address?: Maybe<Scalars['String']>;
  readonly lat?: Maybe<Scalars['Float']>;
  readonly lng?: Maybe<Scalars['Float']>;
  readonly rawDataType: Scalars['String'];
  readonly rawData: Scalars['String'];
};

export type UpdateActionByClientActionPlanningDateInput = {
  readonly date: Scalars['DateImmutable'];
};

export type UpdateActionByClientInput = {
  readonly uuid: Scalars['UUID'];
  readonly actionPlanningDate?: Maybe<UpdateActionByClientActionPlanningDateInput>;
  readonly actionLocation?: Maybe<UpdateActionByClientActionLocationInput>;
  readonly locationContact?: Maybe<UpdateActionByClientLocationContactInput>;
  readonly startTime?: Maybe<Scalars['Int']>;
  readonly clientUserSignature?: Maybe<Scalars['String']>;
  readonly locationContactSignature?: Maybe<Scalars['String']>;
  readonly transition?: Maybe<ActionFlowTransition>;
  readonly declineReason?: Maybe<Scalars['String']>;
};

export type UpdateActionByClientLocationContactInput = {
  readonly firstName: Scalars['String'];
  readonly lastName: Scalars['String'];
  readonly phone: Scalars['String'];
  readonly email: Scalars['String'];
};

export type UpdateLeaveHolidayAssignmentInput = {
  readonly uuid: Scalars['UUID'];
  readonly timeslotUUID?: Maybe<Scalars['UUID']>;
  readonly userUUID?: Maybe<Scalars['UUID']>;
  readonly leaveHolidayTypeUUID?: Maybe<Scalars['UUID']>;
  readonly date?: Maybe<Scalars['DateTimeImmutable']>;
  readonly startTime?: Maybe<Scalars['DateTimeImmutable']>;
  /** Duration in seconds */
  readonly duration?: Maybe<Scalars['Float']>;
};

export type UpdateProjectTaskAssignmentInput = {
  readonly uuid: Scalars['UUID'];
  readonly timeslotUUID?: Maybe<Scalars['UUID']>;
  readonly userUUID?: Maybe<Scalars['UUID']>;
  readonly projectTaskUUID?: Maybe<Scalars['UUID']>;
  readonly date?: Maybe<Scalars['DateTimeImmutable']>;
  readonly startTime?: Maybe<Scalars['DateTimeImmutable']>;
  /** Duration in seconds */
  readonly duration?: Maybe<Scalars['Float']>;
  readonly note?: Maybe<Scalars['String']>;
  readonly addToProject?: Maybe<Scalars['Boolean']>;
};

export type UpdateProjectTaskInput = {
  readonly uuid: Scalars['UUID'];
};

export type UpdateTimeTrackInput = {
  readonly uuid: Scalars['UUID'];
  readonly projectTaskUUID?: Maybe<Scalars['UUID']>;
  readonly note?: Maybe<Scalars['String']>;
  readonly trackedSeconds?: Maybe<Scalars['Int']>;
  readonly date?: Maybe<Scalars['DateTimeImmutable']>;
};

export type User = {
  readonly __typename?: 'User';
  readonly username: Scalars['String'];
  readonly password: Maybe<Scalars['String']>;
  readonly permissionRoles: ReadonlyArray<Maybe<Role>>;
  readonly firstName: Maybe<Scalars['String']>;
  readonly lastName: Maybe<Scalars['String']>;
  readonly occupationTypes: ReadonlyArray<Maybe<OccupationType>>;
  readonly notifications: ReadonlyArray<Maybe<UserNotification>>;
  readonly birthDate: Maybe<Scalars['DateImmutable']>;
  readonly contactPhotoFilename: Maybe<Scalars['String']>;
  readonly phones: ReadonlyArray<Maybe<UserPhone>>;
  readonly title: Maybe<Scalars['String']>;
  readonly emails: ReadonlyArray<Maybe<UserEmail>>;
  readonly status: Scalars['String'];
  readonly language: Maybe<Scalars['String']>;
  readonly roleUnits: ReadonlyArray<Maybe<RoleUnit>>;
  readonly timezone: Maybe<Timezone>;
  readonly projectTeamMembers: ReadonlyArray<Maybe<ProjectTeamMember>>;
  readonly billableRates: ReadonlyArray<Maybe<UserBillableRate>>;
  readonly costRate: Maybe<Scalars['Int']>;
  readonly type: Maybe<Scalars['String']>;
  readonly capacity: Maybe<Scalars['Float']>;
  readonly joinedAt: Maybe<Scalars['DateTimeImmutable']>;
  readonly archivedAt: Maybe<Scalars['DateTimeImmutable']>;
  readonly invoices: ReadonlyArray<Maybe<Invoice>>;
  readonly totalHours: Maybe<Scalars['Float']>;
  readonly billableHours: Maybe<Scalars['Float']>;
  readonly tokens: ReadonlyArray<Maybe<UserToken>>;
  readonly timeTracks: ReadonlyArray<Maybe<TimeTrack>>;
  readonly socialSecurityNumber: Maybe<Scalars['String']>;
  readonly tankCode: Maybe<Scalars['String']>;
  readonly bookedPersons: ReadonlyArray<Maybe<BookingPerson>>;
  readonly clientUsers: ReadonlyArray<Maybe<ClientUser>>;
  readonly companyUser: Scalars['Boolean'];
  readonly clientUser: Scalars['Boolean'];
  readonly phone: Maybe<Scalars['String']>;
  readonly contacts: ReadonlyArray<Maybe<Contact>>;
  readonly createdAt: Scalars['DateTimeImmutable'];
  readonly updatedAt: Scalars['DateTimeImmutable'];
  readonly uuid: Scalars['UUID'];
};

export enum UserActivityAction {
  Unknown = 'UNKNOWN',
  EstimateCreated = 'ESTIMATE_CREATED',
  EstimateEdited = 'ESTIMATE_EDITED',
  EstimateApproved = 'ESTIMATE_APPROVED',
  EstimateSentForReview = 'ESTIMATE_SENT_FOR_REVIEW',
  EstimateDenied = 'ESTIMATE_DENIED',
  EstimateSentToClient = 'ESTIMATE_SENT_TO_CLIENT',
  EstimateConfirmedByClient = 'ESTIMATE_CONFIRMED_BY_CLIENT',
  EstimateDeclinedByClient = 'ESTIMATE_DECLINED_BY_CLIENT',
  EstimateConfirmedInternally = 'ESTIMATE_CONFIRMED_INTERNALLY',
  EstimateDeclinedInternally = 'ESTIMATE_DECLINED_INTERNALLY',
  InvoiceCreated = 'INVOICE_CREATED',
  InvoiceEdited = 'INVOICE_EDITED',
  InvoiceSentForReview = 'INVOICE_SENT_FOR_REVIEW',
  InvoiceDenied = 'INVOICE_DENIED',
  InvoiceSentToClient = 'INVOICE_SENT_TO_CLIENT',
  InvoiceRequestSubmitted = 'INVOICE_REQUEST_SUBMITTED',
  InvoiceConfirmedByClient = 'INVOICE_CONFIRMED_BY_CLIENT',
  InvoiceDeclinedByClient = 'INVOICE_DECLINED_BY_CLIENT',
  InvoiceConfirmedInternally = 'INVOICE_CONFIRMED_INTERNALLY',
  InvoiceDeclinedInternally = 'INVOICE_DECLINED_INTERNALLY',
  SpoCreated = 'SPO_CREATED',
  SpoEdited = 'SPO_EDITED',
  SpoApproved = 'SPO_APPROVED',
  SpoSentForReview = 'SPO_SENT_FOR_REVIEW',
  ActionCreated = 'ACTION_CREATED',
  ActionEdited = 'ACTION_EDITED',
  ActionCancelled = 'ACTION_CANCELLED',
  ActionCancelledBy = 'ACTION_CANCELLED_BY',
  ActionRestored = 'ACTION_RESTORED',
  ActionLocationEdited = 'ACTION_LOCATION_EDITED',
  ActionTeamcostEdited = 'ACTION_TEAMCOST_EDITED',
  ActionResultsPublished = 'ACTION_RESULTS_PUBLISHED',
  ActionResultsUnpublished = 'ACTION_RESULTS_UNPUBLISHED',
  ActionPersonBooked = 'ACTION_PERSON_BOOKED',
  ActionPersonBookedManually = 'ACTION_PERSON_BOOKED_MANUALLY',
  ActionPersonCancelled = 'ACTION_PERSON_CANCELLED',
  ContractEdited = 'CONTRACT_EDITED'
}

export type UserBillableRate = {
  readonly __typename?: 'UserBillableRate';
  readonly applyFrom: Maybe<Scalars['DateImmutable']>;
  readonly rate: Scalars['Int'];
  readonly user: Maybe<User>;
  readonly createdAt: Scalars['DateTimeImmutable'];
  readonly updatedAt: Scalars['DateTimeImmutable'];
  readonly uuid: Scalars['UUID'];
};

export type UserEmail = {
  readonly __typename?: 'UserEmail';
  readonly user: Maybe<User>;
  readonly label: Maybe<Scalars['String']>;
  readonly email: Scalars['String'];
  readonly createdAt: Scalars['DateTimeImmutable'];
  readonly updatedAt: Scalars['DateTimeImmutable'];
  readonly uuid: Scalars['UUID'];
};

export type UserNotification = {
  readonly __typename?: 'UserNotification';
  readonly title: Maybe<Scalars['String']>;
  readonly content: Maybe<Scalars['String']>;
  readonly isRead: Scalars['Boolean'];
  readonly link: Maybe<Scalars['String']>;
  readonly user: Maybe<User>;
  readonly uuid: Scalars['UUID'];
  readonly createdAt: Scalars['DateTimeImmutable'];
  readonly updatedAt: Scalars['DateTimeImmutable'];
};

export type UserPhone = {
  readonly __typename?: 'UserPhone';
  readonly user: Maybe<User>;
  readonly label: Maybe<Scalars['String']>;
  readonly number: Scalars['String'];
  readonly createdAt: Scalars['DateTimeImmutable'];
  readonly updatedAt: Scalars['DateTimeImmutable'];
  readonly uuid: Scalars['UUID'];
};

export type UserToken = {
  readonly __typename?: 'UserToken';
  readonly type: Maybe<Scalars['String']>;
  readonly expiration: Maybe<Scalars['DateTimeImmutable']>;
  readonly token: Maybe<Scalars['String']>;
  readonly user: Maybe<User>;
  readonly uuid: Scalars['UUID'];
  readonly createdAt: Scalars['DateTimeImmutable'];
  readonly updatedAt: Scalars['DateTimeImmutable'];
};

export type Warehouse = {
  readonly __typename?: 'Warehouse';
  readonly actionTeam: Maybe<ActionTeam>;
  readonly name: Maybe<Scalars['String']>;
  readonly description: Maybe<Scalars['String']>;
  readonly qty: Maybe<Scalars['Float']>;
  readonly unitPrice: Maybe<Scalars['Int']>;
  readonly billablePrice: Maybe<Scalars['Int']>;
  readonly amount: Maybe<Scalars['Int']>;
  readonly billablePriceMargin: Maybe<Scalars['Float']>;
  readonly ratesheet: Maybe<Ratesheet>;
  readonly dictionaryWarehouse: Maybe<Warehouse>;
  readonly project: Maybe<Project>;
  readonly months: Maybe<Scalars['Int']>;
  readonly budgetItem: Maybe<WarehouseBudgetItem>;
  readonly createdAt: Scalars['DateTimeImmutable'];
  readonly updatedAt: Scalars['DateTimeImmutable'];
  readonly uuid: Scalars['UUID'];
};

export type WarehouseBudgetItem = {
  readonly __typename?: 'WarehouseBudgetItem';
  readonly warehouse: Warehouse;
  readonly project: Project;
  readonly name: Scalars['String'];
  readonly qty: Scalars['Int'];
  readonly discount: Scalars['Int'];
  readonly unitPrice: Scalars['Int'];
  readonly billablePrice: Scalars['Int'];
  readonly description: Maybe<Scalars['String']>;
  readonly createdAt: Scalars['DateTimeImmutable'];
  readonly updatedAt: Scalars['DateTimeImmutable'];
  readonly uuid: Scalars['UUID'];
};

export type ClientSimpleListQueryVariables = Exact<{
  q?: Maybe<ClientQueryInput>;
}>;


export type ClientSimpleListQuery = { readonly __typename?: 'Query', readonly clients: { readonly __typename?: 'ClientPaginator', readonly page: number, readonly limit: number, readonly total: number, readonly items: ReadonlyArray<{ readonly __typename?: 'Client', readonly uuid: UUID, readonly name: string, readonly logo: Maybe<string> }> } };

export type FormListQueryVariables = Exact<{
  q: FormsQueryInput;
}>;


export type FormListQuery = { readonly __typename?: 'Query', readonly forms: { readonly __typename?: 'FormsPaginator', readonly page: number, readonly limit: number, readonly total: number, readonly items: ReadonlyArray<(
      { readonly __typename?: 'Form' }
      & FormListItemFragment
    )> } };

export type FormListItemFragment = { readonly __typename?: 'Form', readonly uuid: UUID, readonly name: Maybe<string>, readonly createdAt: AppDateTime, readonly status: Maybe<FormStatus>, readonly type: Maybe<FormTypes> };

export type ClientActionDetailsQueryVariables = Exact<{
  q?: Maybe<ActionsQueryInput>;
}>;


export type ClientActionDetailsQuery = { readonly __typename?: 'Query', readonly actions: { readonly __typename?: 'ActionsPaginator', readonly items: ReadonlyArray<(
      { readonly __typename?: 'Action' }
      & ClientActionDetailsFragment
    )> } };

export type ClientActionDetailsFragment = { readonly __typename?: 'Action', readonly uuid: UUID, readonly clientStatus: Maybe<ActionClientStatus>, readonly name: Maybe<string>, readonly clientUserSignature: Maybe<string>, readonly locationContactSignature: Maybe<string>, readonly eventDuration: number, readonly flowContext: Maybe<{ readonly __typename?: 'ActionFlowContext', readonly isEditable: boolean, readonly canApprove: boolean, readonly canConfirm: boolean, readonly canRequestApproval: boolean }>, readonly confirmedByClientUser: Maybe<{ readonly __typename?: 'User', readonly uuid: UUID, readonly firstName: Maybe<string>, readonly lastName: Maybe<string> }>, readonly actionPlanningDate: Maybe<{ readonly __typename?: 'ActionPlanningDate', readonly date: Maybe<AppDate> }>, readonly actionLocation: Maybe<{ readonly __typename?: 'ActionLocation', readonly name: Maybe<string>, readonly address: Maybe<string>, readonly lat: Maybe<number>, readonly lng: Maybe<number>, readonly rawDataType: string, readonly rawData: any }>, readonly locationContact: Maybe<{ readonly __typename?: 'ContactClientRole', readonly uuid: UUID, readonly contact: Maybe<{ readonly __typename?: 'Contact', readonly uuid: UUID, readonly firstName: Maybe<string>, readonly lastName: Maybe<string>, readonly emails: ReadonlyArray<Maybe<{ readonly __typename?: 'ContactEmail', readonly email: string }>>, readonly phones: ReadonlyArray<Maybe<{ readonly __typename?: 'ContactPhone', readonly number: string }>> }> }>, readonly project: Maybe<{ readonly __typename?: 'Project', readonly client: { readonly __typename?: 'Client', readonly uuid: UUID } }>, readonly teamCost: Maybe<{ readonly __typename?: 'TeamCost', readonly scheduleForClient: Maybe<ReadonlyArray<{ readonly __typename?: 'TeamCostScheduleAssignment', readonly uuid: UUID, readonly startTime: number, readonly duration: number, readonly peopleCount: number, readonly tag: Maybe<{ readonly __typename?: 'TCScheduleAssignmentTag', readonly uuid: UUID, readonly name: string, readonly color: Maybe<string>, readonly code: Maybe<TcScheduleAssignmentTagCode> }> }>> }> };

export type UpdateActionByClientMutationVariables = Exact<{
  input: UpdateActionByClientInput;
}>;


export type UpdateActionByClientMutation = { readonly __typename?: 'Mutation', readonly update_action_by_client: (
    { readonly __typename?: 'Action' }
    & ClientActionDetailsFragment
  ) };

export type ClientsPlannerFiltersQueryVariables = Exact<{
  client?: Maybe<ReadonlyArray<Scalars['UUID']> | Scalars['UUID']>;
  listType?: Maybe<ActionListType>;
}>;


export type ClientsPlannerFiltersQuery = { readonly __typename?: 'Query', readonly projects: { readonly __typename?: 'SimpleEntityPaginator', readonly items: ReadonlyArray<(
      { readonly __typename?: 'SimpleEntity' }
      & ClientsPlannerFilterItemFragment
    )> }, readonly locations: { readonly __typename?: 'SimpleEntityPaginator', readonly items: ReadonlyArray<(
      { readonly __typename?: 'SimpleEntity' }
      & ClientsPlannerFilterItemFragment
    )> }, readonly statuses: { readonly __typename?: 'SimpleEntityPaginator', readonly items: ReadonlyArray<(
      { readonly __typename?: 'SimpleEntity' }
      & ClientsPlannerFilterItemFragment
    )> }, readonly action_types: { readonly __typename?: 'SimpleEntityPaginator', readonly items: ReadonlyArray<(
      { readonly __typename?: 'SimpleEntity' }
      & ClientsPlannerFilterItemFragment
    )> }, readonly action_planners: { readonly __typename?: 'SimpleEntityPaginator', readonly items: ReadonlyArray<(
      { readonly __typename?: 'SimpleEntity' }
      & ClientsPlannerFilterItemFragment
    )> } };

export type ClientsPlannerFilterItemFragment = { readonly __typename?: 'SimpleEntity', readonly uuid: UUID, readonly name: string };

export type ClientsPlannerListQueryVariables = Exact<{
  q?: Maybe<ActionsQueryInput>;
}>;


export type ClientsPlannerListQuery = { readonly __typename?: 'Query', readonly actions: (
    { readonly __typename?: 'ActionsPaginator', readonly items: ReadonlyArray<(
      { readonly __typename?: 'Action' }
      & ClientsPlannerListActionFragment
    )> }
    & ClientsPlannerListPaginatorFragment
  ) };

export type ClientsPlannerListPaginatorFragment = { readonly __typename?: 'ActionsPaginator', readonly page: number, readonly limit: number, readonly total: number };

export type ClientsPlannerListActionFragment = { readonly __typename?: 'Action', readonly uuid: UUID, readonly clientStatus: Maybe<ActionClientStatus>, readonly name: Maybe<string>, readonly firstScheduleStartTime: Maybe<AppDateTime>, readonly lastScheduleEndTime: Maybe<AppDateTime>, readonly bookedBookingPersonsCount: number, readonly projectLeader: Maybe<{ readonly __typename?: 'ProjectTeamMember', readonly user: Maybe<{ readonly __typename?: 'User', readonly firstName: Maybe<string>, readonly lastName: Maybe<string> }> }>, readonly project: Maybe<{ readonly __typename?: 'Project', readonly name: string }>, readonly actionPlanningDate: Maybe<{ readonly __typename?: 'ActionPlanningDate', readonly date: Maybe<AppDate> }>, readonly actionLocation: Maybe<{ readonly __typename?: 'ActionLocation', readonly name: Maybe<string>, readonly address: Maybe<string> }>, readonly parentTeamCost: Maybe<{ readonly __typename?: 'TeamCost', readonly invoiceItem: Maybe<{ readonly __typename?: 'InvoiceItem', readonly teamType: Maybe<{ readonly __typename?: 'TeamCostTeamType', readonly name: string }> }> }> };

export type ProjectTaskAssignmentsQueryVariables = Exact<{
  q?: Maybe<ProjectTaskAssignmentQueryInput>;
}>;


export type ProjectTaskAssignmentsQuery = { readonly __typename?: 'Query', readonly project_task_assignments: { readonly __typename?: 'ProjectTaskAssignmentPaginator', readonly page: number, readonly hasMore: boolean, readonly total: number, readonly items: ReadonlyArray<{ readonly __typename?: 'FlatProjectTaskAssignment', readonly assignmentUuid: Maybe<UUID>, readonly timeslotUuid: UUID, readonly duration: Maybe<number>, readonly type: TimeslotType, readonly date: Maybe<AppDate>, readonly createdAt: Maybe<AppDateTime>, readonly updatedAt: Maybe<AppDateTime>, readonly startTime: Maybe<AppDateTime>, readonly note: Maybe<string>, readonly isConfirmed: Maybe<boolean>, readonly events: ReadonlyArray<Maybe<{ readonly __typename?: 'ProjectTaskAssignmentEvent', readonly uuid: UUID, readonly comment: string, readonly updatedAt: AppDateTime, readonly createdAt: AppDateTime, readonly user: Maybe<{ readonly __typename?: 'User', readonly uuid: UUID, readonly username: string, readonly firstName: Maybe<string>, readonly lastName: Maybe<string> }> }>>, readonly projectTask: Maybe<(
        { readonly __typename?: 'ProjectTask', readonly projectTaskAssignments: ReadonlyArray<Maybe<{ readonly __typename?: 'ProjectTaskAssignment', readonly timeslots: ReadonlyArray<Maybe<{ readonly __typename?: 'ProjectTaskAssignmentTimeslot', readonly createdBy: Maybe<{ readonly __typename?: 'User', readonly username: string, readonly firstName: Maybe<string>, readonly lastName: Maybe<string> }> }>> }>>, readonly project: { readonly __typename?: 'Project', readonly projectId: string, readonly name: string } }
        & TimeTrackerProjectTaskFragment
      )>, readonly leaveHolidayAssignment: Maybe<{ readonly __typename?: 'LeaveHolidayAssignment', readonly uuid: UUID, readonly type: Maybe<{ readonly __typename?: 'LeaveHolidayType', readonly uuid: UUID, readonly title: string, readonly description: Maybe<string> }> }>, readonly user: Maybe<{ readonly __typename?: 'User', readonly uuid: UUID, readonly username: string }> }> } };

export type TimeslotsFragment = { readonly __typename?: 'ProjectTaskAssignmentTimeslot', readonly uuid: UUID };

export type LeaveHolidayAssignmentFragment = { readonly __typename?: 'LeaveHolidayAssignment', readonly uuid: UUID };

export type TaskAssignmentsFragment = { readonly __typename?: 'ProjectTaskAssignment', readonly uuid: UUID };

export type AddProjectTaskAssignmentMutationVariables = Exact<{
  input: AddProjectTaskAssignmentInput;
}>;


export type AddProjectTaskAssignmentMutation = { readonly __typename?: 'Mutation', readonly add_project_task_assignment: (
    { readonly __typename?: 'ProjectTaskAssignment' }
    & TaskAssignmentsFragment
  ) };

export type UpdateProjectTaskAssignmentMutationVariables = Exact<{
  input: UpdateProjectTaskAssignmentInput;
}>;


export type UpdateProjectTaskAssignmentMutation = { readonly __typename?: 'Mutation', readonly update_project_task_assignment: (
    { readonly __typename?: 'ProjectTaskAssignment' }
    & TaskAssignmentsFragment
  ) };

export type DeleteProjectTaskAssignmentMutationVariables = Exact<{
  input: DeleteProjectTaskAssignmentInput;
}>;


export type DeleteProjectTaskAssignmentMutation = { readonly __typename?: 'Mutation', readonly delete_project_task_assignment: ReadonlyArray<UUID> };

export type AddLeaveHolidayAssignmentMutationVariables = Exact<{
  input: AddLeaveHolidayAssignmentInput;
}>;


export type AddLeaveHolidayAssignmentMutation = { readonly __typename?: 'Mutation', readonly add_leave_holiday_assignment: (
    { readonly __typename?: 'ProjectTaskAssignmentTimeslot' }
    & TimeslotsFragment
  ) };

export type UpdateLeaveHolidayAssignmentMutationVariables = Exact<{
  input: UpdateLeaveHolidayAssignmentInput;
}>;


export type UpdateLeaveHolidayAssignmentMutation = { readonly __typename?: 'Mutation', readonly update_leave_holiday_assignment: (
    { readonly __typename?: 'LeaveHolidayAssignment' }
    & LeaveHolidayAssignmentFragment
  ) };

export type DeleteLeaveHolidayAssignmentMutationVariables = Exact<{
  input: DeleteLeaveHolidayAssignmentInput;
}>;


export type DeleteLeaveHolidayAssignmentMutation = { readonly __typename?: 'Mutation', readonly delete_leave_holiday_assignment: ReadonlyArray<UUID> };

export type ItemsOverviewQuantityTypesQueryVariables = Exact<{
  page?: Maybe<Scalars['Int']>;
  limit?: Maybe<Scalars['Int']>;
  search?: Maybe<Scalars['String']>;
}>;


export type ItemsOverviewQuantityTypesQuery = { readonly __typename?: 'Query', readonly quantity_types: { readonly __typename?: 'QuantityTypePaginator', readonly total: number, readonly items: ReadonlyArray<{ readonly __typename?: 'QuantityType', readonly name: string, readonly uuid: UUID }> } };

export type ItemsOverviewAddQuantityTypeMutationVariables = Exact<{
  input: AddQuantityTypeInput;
}>;


export type ItemsOverviewAddQuantityTypeMutation = { readonly __typename?: 'Mutation', readonly add_quantity_type: { readonly __typename?: 'QuantityType', readonly name: string, readonly uuid: UUID } };

export type DefaultQuantityTypesQueryVariables = Exact<{ [key: string]: never; }>;


export type DefaultQuantityTypesQuery = { readonly __typename?: 'Query', readonly blank: (
    { readonly __typename?: 'QuantityTypePaginator' }
    & DefaultQuantityTypesFragment
  ), readonly hours: (
    { readonly __typename?: 'QuantityTypePaginator' }
    & DefaultQuantityTypesFragment
  ), readonly days: (
    { readonly __typename?: 'QuantityTypePaginator' }
    & DefaultQuantityTypesFragment
  ), readonly percentage: (
    { readonly __typename?: 'QuantityTypePaginator' }
    & DefaultQuantityTypesFragment
  ) };

export type DefaultQuantityTypesFragment = { readonly __typename?: 'QuantityTypePaginator', readonly items: ReadonlyArray<{ readonly __typename?: 'QuantityType', readonly name: string, readonly uuid: UUID, readonly createdAt: AppDateTime, readonly updatedAt: AppDateTime }> };

export type CompanyHolidaysQueryVariables = Exact<{ [key: string]: never; }>;


export type CompanyHolidaysQuery = { readonly __typename?: 'Query', readonly company_holidays: ReadonlyArray<{ readonly __typename?: 'CompanyHoliday', readonly uuid: UUID, readonly date: AppDate, readonly name: string }> };

export type AddCompanyHolidayMutationVariables = Exact<{
  input: AddCompanyHolidayInput;
}>;


export type AddCompanyHolidayMutation = { readonly __typename?: 'Mutation', readonly add_company_holiday: { readonly __typename?: 'CompanyHoliday', readonly uuid: UUID, readonly date: AppDate, readonly name: string } };

export type DeleteCompanyHolidayMutationVariables = Exact<{
  input: DeleteCompanyHolidayInput;
}>;


export type DeleteCompanyHolidayMutation = { readonly __typename?: 'Mutation', readonly delete_company_holiday: UUID };

export type CreateSubActionTeamMutationVariables = Exact<{
  input: CreateSubActionTeamInput;
}>;


export type CreateSubActionTeamMutation = { readonly __typename?: 'Mutation', readonly create_sub_action_team: (
    { readonly __typename?: 'ActionTeam' }
    & CreateSubActionTeamFragment
  ) };

export type CreateSubActionTeamFragment = { readonly __typename?: 'ActionTeam', readonly uuid: UUID, readonly project: Maybe<{ readonly __typename?: 'Project', readonly uuid: UUID }>, readonly channel: { readonly __typename?: 'Channel', readonly uuid: UUID } };

export type FormAnswerDetailsQueryVariables = Exact<{
  q?: Maybe<FormAnswersQueryInput>;
}>;


export type FormAnswerDetailsQuery = { readonly __typename?: 'Query', readonly form_answers: { readonly __typename?: 'FormAnswersPaginator', readonly items: ReadonlyArray<{ readonly __typename?: 'DebriefingAnswerText', readonly uuid: UUID, readonly value: Maybe<string>, readonly formElement: { readonly __typename?: 'FormElement', readonly uuid: UUID, readonly name: Maybe<string>, readonly type: Maybe<FormElementTypes> } } | { readonly __typename?: 'DebriefingAnswerTextarea', readonly uuid: UUID, readonly value: Maybe<string>, readonly formElement: { readonly __typename?: 'FormElement', readonly uuid: UUID, readonly name: Maybe<string>, readonly type: Maybe<FormElementTypes> } } | { readonly __typename?: 'DebriefingAnswerNumber', readonly uuid: UUID, readonly value: Maybe<string>, readonly formElement: { readonly __typename?: 'FormElement', readonly uuid: UUID, readonly name: Maybe<string>, readonly type: Maybe<FormElementTypes> } } | { readonly __typename?: 'DebriefingAnswerFileUpload', readonly uuid: UUID, readonly files: ReadonlyArray<Maybe<{ readonly __typename?: 'DebriefingAnswerFileUploadItem', readonly uuid: UUID, readonly name: string, readonly path: string }>>, readonly formElement: { readonly __typename?: 'FormElement', readonly uuid: UUID, readonly name: Maybe<string>, readonly type: Maybe<FormElementTypes> } } | { readonly __typename?: 'DebriefingAnswerOpinionScale', readonly uuid: UUID, readonly value: Maybe<string>, readonly formElement: { readonly __typename?: 'FormElement', readonly uuid: UUID, readonly name: Maybe<string>, readonly type: Maybe<FormElementTypes>, readonly opinionScale: Maybe<{ readonly __typename?: 'FormElementOpinionScale', readonly minValue: number, readonly maxValue: number, readonly minLabel: string, readonly maxLabel: string }> } } | { readonly __typename?: 'DebriefingAnswerSamples', readonly uuid: UUID, readonly value: Maybe<string>, readonly formElement: { readonly __typename?: 'FormElement', readonly uuid: UUID, readonly name: Maybe<string>, readonly type: Maybe<FormElementTypes> } } | { readonly __typename?: 'DebriefingAnswerContacts', readonly uuid: UUID, readonly value: Maybe<string>, readonly formElement: { readonly __typename?: 'FormElement', readonly uuid: UUID, readonly name: Maybe<string>, readonly type: Maybe<FormElementTypes> } } | { readonly __typename?: 'DebriefingAnswerMultipleChoice', readonly uuid: UUID, readonly choices: ReadonlyArray<Maybe<{ readonly __typename?: 'FormElementChoice', readonly uuid: UUID, readonly name: string }>>, readonly formElement: { readonly __typename?: 'FormElement', readonly uuid: UUID, readonly name: Maybe<string>, readonly type: Maybe<FormElementTypes>, readonly choices: ReadonlyArray<Maybe<{ readonly __typename?: 'FormElementChoice', readonly uuid: UUID, readonly name: string }>> } } | { readonly __typename?: 'DebriefingAnswerDropdown', readonly uuid: UUID, readonly value: Maybe<string>, readonly formElement: { readonly __typename?: 'FormElement', readonly uuid: UUID, readonly name: Maybe<string>, readonly type: Maybe<FormElementTypes>, readonly choices: ReadonlyArray<Maybe<{ readonly __typename?: 'FormElementChoice', readonly uuid: UUID, readonly name: string }>> } } | { readonly __typename?: 'DebriefingAnswerGoodBad', readonly uuid: UUID, readonly value: Maybe<string>, readonly formElement: { readonly __typename?: 'FormElement', readonly uuid: UUID, readonly name: Maybe<string>, readonly type: Maybe<FormElementTypes> } } | { readonly __typename?: 'DebriefingAnswerYesNo', readonly uuid: UUID, readonly value: Maybe<string>, readonly formElement: { readonly __typename?: 'FormElement', readonly uuid: UUID, readonly name: Maybe<string>, readonly type: Maybe<FormElementTypes> } } | { readonly __typename?: 'DebriefingAnswerTime', readonly uuid: UUID, readonly value: Maybe<string>, readonly formElement: { readonly __typename?: 'FormElement', readonly uuid: UUID, readonly name: Maybe<string>, readonly type: Maybe<FormElementTypes> } } | { readonly __typename?: 'DebriefingAnswerDate', readonly uuid: UUID, readonly value: Maybe<string>, readonly formElement: { readonly __typename?: 'FormElement', readonly uuid: UUID, readonly name: Maybe<string>, readonly type: Maybe<FormElementTypes> } } | { readonly __typename?: 'DebriefingAnswerRating', readonly uuid: UUID, readonly value: Maybe<string>, readonly formElement: { readonly __typename?: 'FormElement', readonly uuid: UUID, readonly name: Maybe<string>, readonly type: Maybe<FormElementTypes> } } | { readonly __typename?: 'DebriefingAnswerDegree', readonly uuid: UUID, readonly value: Maybe<string>, readonly formElement: { readonly __typename?: 'FormElement', readonly uuid: UUID, readonly name: Maybe<string>, readonly type: Maybe<FormElementTypes> } }> } };

export type FormAnswersListQueryVariables = Exact<{
  q: FormAnswersListQueryInput;
}>;


export type FormAnswersListQuery = { readonly __typename?: 'Query', readonly form_answers_list: ReadonlyArray<{ readonly __typename?: 'FormAnswerListItem', readonly actionName: string, readonly actionUuid: UUID, readonly userUuid: Maybe<UUID>, readonly externalUserUuid: Maybe<UUID>, readonly firstName: string, readonly lastName: string, readonly date: AppDateTime, readonly type: FormTypes, readonly formUuid: UUID }> };

export type CompanyPayrollCodesQueryVariables = Exact<{ [key: string]: never; }>;


export type CompanyPayrollCodesQuery = { readonly __typename?: 'Query', readonly company_payroll_codes: ReadonlyArray<{ readonly __typename?: 'CompanyPayrollCodeItem', readonly key: string, readonly value: string, readonly defaultValue: string, readonly isCustom: boolean, readonly description: string }> };

export type SetCompanyPayrollCodeMutationVariables = Exact<{
  input: SetCompanyPayrollCodeInput;
}>;


export type SetCompanyPayrollCodeMutation = { readonly __typename?: 'Mutation', readonly set_company_payroll_code: ReadonlyArray<{ readonly __typename?: 'CompanyPayrollCodeItem', readonly key: string, readonly value: string, readonly defaultValue: string, readonly isCustom: boolean, readonly description: string }> };

export type CompanyPayrollRulesQueryVariables = Exact<{ [key: string]: never; }>;


export type CompanyPayrollRulesQuery = { readonly __typename?: 'Query', readonly company_payroll_rules: ReadonlyArray<{ readonly __typename?: 'CompanyPayrollRule', readonly uuid: UUID, readonly externalJcCode: Maybe<string>, readonly functionCategoryCode: Maybe<string>, readonly functionDescription: Maybe<string>, readonly contractType: Maybe<string>, readonly overtimeRatePercentage: number, readonly saturdayOvertimeCode: Maybe<string>, readonly saturdayOvertimeRatePercentage: Maybe<number>, readonly sundayOvertimeCode: Maybe<string>, readonly sundayOvertimeRatePercentage: Maybe<number>, readonly holidayRatePercentage: number, readonly daysPerWeek: number, readonly hoursPerWeek: number, readonly jointCommittee: { readonly __typename?: 'TeamCostJointCommittee', readonly uuid: UUID, readonly name: string, readonly code: Maybe<string> } }> };

export type SetCompanyPayrollRuleMutationVariables = Exact<{
  input: SetCompanyPayrollRuleInput;
}>;


export type SetCompanyPayrollRuleMutation = { readonly __typename?: 'Mutation', readonly set_company_payroll_rule: { readonly __typename?: 'CompanyPayrollRule', readonly uuid: UUID, readonly externalJcCode: Maybe<string>, readonly functionCategoryCode: Maybe<string>, readonly functionDescription: Maybe<string>, readonly contractType: Maybe<string>, readonly overtimeRatePercentage: number, readonly saturdayOvertimeCode: Maybe<string>, readonly saturdayOvertimeRatePercentage: Maybe<number>, readonly sundayOvertimeCode: Maybe<string>, readonly sundayOvertimeRatePercentage: Maybe<number>, readonly holidayRatePercentage: number, readonly daysPerWeek: number, readonly hoursPerWeek: number, readonly jointCommittee: { readonly __typename?: 'TeamCostJointCommittee', readonly uuid: UUID, readonly name: string, readonly code: Maybe<string> } } };

export type DeleteCompanyPayrollRuleMutationVariables = Exact<{
  input: DeleteCompanyPayrollRuleInput;
}>;


export type DeleteCompanyPayrollRuleMutation = { readonly __typename?: 'Mutation', readonly delete_company_payroll_rule: UUID };

export type ContractDataQueryVariables = Exact<{
  contractId: Scalars['UUID'];
}>;


export type ContractDataQuery = { readonly __typename?: 'Query', readonly booking_person_late_movements: (
    { readonly __typename?: 'BookingPersonLateMovements' }
    & BookingPersonLateMovementsFieldsFragment
  ), readonly booking_person_performance: (
    { readonly __typename?: 'BookingPersonPerformance' }
    & BookingPersonPerformanceFieldsFragment
  ) };

export type ForgiveLatenessMutationVariables = Exact<{
  uuid: Scalars['UUID'];
  date?: Maybe<Scalars['DateTimeImmutable']>;
}>;


export type ForgiveLatenessMutation = { readonly __typename?: 'Mutation', readonly update_external_user: { readonly __typename?: 'ExternalUser', readonly uuid: UUID } };

export type BookingPersonPerformanceFieldsFragment = { readonly __typename?: 'BookingPersonPerformance', readonly arrived: Maybe<AppDateTime>, readonly departed: Maybe<AppDateTime>, readonly comment: Maybe<string>, readonly file: Maybe<string>, readonly movements: Maybe<ReadonlyArray<Maybe<{ readonly __typename?: 'BookingPersonMovement', readonly state: string, readonly date: AppDateTime }>>> };

export type BookingPersonLateMovementsFieldsFragment = { readonly __typename?: 'BookingPersonLateMovements', readonly count: number, readonly latenessType: Maybe<string> };

export type SaveBookingPersonPerformanceMutationVariables = Exact<{
  contractId: Scalars['UUID'];
  arrived?: Maybe<Scalars['DateTimeImmutable']>;
  departed?: Maybe<Scalars['DateTimeImmutable']>;
}>;


export type SaveBookingPersonPerformanceMutation = { readonly __typename?: 'Mutation', readonly save_booking_person_performance: (
    { readonly __typename?: 'BookingPersonPerformance' }
    & BookingPersonPerformanceFieldsFragment
  ) };

export type ContractUploadAttentiaCalculationsMutationVariables = Exact<{
  input: ContractUploadAttentiaCalculationsInput;
}>;


export type ContractUploadAttentiaCalculationsMutation = { readonly __typename?: 'Mutation', readonly contract_upload_attentia_calculations: { readonly __typename?: 'ContractUploadAttentiaCalculationsResponse', readonly alreadyImportedContractNumbers: ReadonlyArray<string>, readonly notImportableContractNumbers: ReadonlyArray<string>, readonly importedCalculations: ReadonlyArray<(
      { readonly __typename?: 'ContractAttentiaCalculation' }
      & ContractUploadAttentiaCalculationsFragment
    )> } };

export type ContractUploadAttentiaCalculationsFragment = { readonly __typename?: 'ContractAttentiaCalculation', readonly uuid: UUID, readonly contract: { readonly __typename?: 'Contract', readonly documentNumber: string, readonly uuid: UUID } };

export type PersonSelectListForModalQueryVariables = Exact<{
  q: PersonSelectListQueryInput;
}>;


export type PersonSelectListForModalQuery = { readonly __typename?: 'Query', readonly person_select_list: { readonly __typename?: 'PersonSelectListPaginator', readonly total: number, readonly hasMore: boolean, readonly hash: string, readonly page: number, readonly items: ReadonlyArray<(
      { readonly __typename?: 'PersonSelectListItem' }
      & PersonSelectItemForModalFragment
    )> } };

export type PersonSelectItemForModalFragment = { readonly __typename?: 'PersonSelectListItem', readonly eventDistance: Maybe<number>, readonly viaCompanyDistance: Maybe<number>, readonly compositionRole: Maybe<{ readonly __typename?: 'TCCompositionRole', readonly uuid: UUID }>, readonly externalUser: { readonly __typename?: 'ExternalUser', readonly uuid: UUID, readonly fullName: string, readonly firstName: string, readonly lastName: string, readonly avatar: Maybe<string> } };

export type PersonSelectModalBookingPersonsStatQueryVariables = Exact<{
  q?: Maybe<BookingPersonsQueryInput>;
}>;


export type PersonSelectModalBookingPersonsStatQuery = { readonly __typename?: 'Query', readonly booking_persons_stat: { readonly __typename?: 'BookingPersonsStat', readonly studentWorkdaysMin: number, readonly studentWorkdaysMax: number, readonly weightMin: number, readonly weightMax: number, readonly BMIMin: number, readonly BMIMax: number } };

export type ActualsQueryVariables = Exact<{
  projectUuid: Scalars['UUID'];
}>;


export type ActualsQuery = { readonly __typename?: 'Query', readonly actuals: ReadonlyArray<(
    { readonly __typename?: 'ActualsLine' }
    & ActualsLineFieldsFragment
  )>, readonly actual_totals: (
    { readonly __typename?: 'ActualTotals' }
    & ActualTotalsFieldsFragment
  ) };

export type ActualsLineFieldsFragment = { readonly __typename?: 'ActualsLine', readonly type: string, readonly bookingYear: number, readonly bookingMonth: number, readonly documentDate: AppDateTime, readonly documentReference: string, readonly realCost: number, readonly realSell: number, readonly currency: string, readonly companyName: string, readonly cpReference: string, readonly cpDescription: string };

export type ActualTotalsFieldsFragment = { readonly __typename?: 'ActualTotals', readonly sellPrice: number, readonly costPrice: number };

export type ProjectActionsListQueryVariables = Exact<{
  q?: Maybe<ActionsQueryInput>;
}>;


export type ProjectActionsListQuery = { readonly __typename?: 'Query', readonly actions: (
    { readonly __typename?: 'ActionsPaginator', readonly items: ReadonlyArray<(
      { readonly __typename?: 'Action' }
      & ProjectActionsListItemFragment
    )> }
    & ProjectActionsListPaginatorFragment
  ) };

export type ProjectActionsListPaginatorFragment = { readonly __typename?: 'ActionsPaginator', readonly page: number, readonly limit: number, readonly total: number, readonly statusCounts: Maybe<ReadonlyArray<{ readonly __typename?: 'ActionStatusCount', readonly status: string, readonly count: number }>> };

export type ProjectActionsListItemFragment = { readonly __typename?: 'Action', readonly uuid: UUID, readonly status: Maybe<ActionStatus>, readonly cancellationReason: Maybe<string>, readonly name: Maybe<string>, readonly firstScheduleStartTime: Maybe<AppDateTime>, readonly lastScheduleEndTime: Maybe<AppDateTime>, readonly notes: Maybe<string>, readonly province: Maybe<Province>, readonly actionPlanningDate: Maybe<{ readonly __typename?: 'ActionPlanningDate', readonly date: Maybe<AppDate> }>, readonly actionLocation: Maybe<{ readonly __typename?: 'ActionLocation', readonly name: Maybe<string>, readonly address: Maybe<string> }>, readonly parentTeamCost: Maybe<{ readonly __typename?: 'TeamCost', readonly invoiceItem: Maybe<{ readonly __typename?: 'InvoiceItem', readonly description: string, readonly teamType: Maybe<{ readonly __typename?: 'TeamCostTeamType', readonly name: string }> }> }>, readonly teamCost: Maybe<{ readonly __typename?: 'TeamCost', readonly compositionRoles: ReadonlyArray<{ readonly __typename?: 'TCCompositionRole', readonly roleName: string }>, readonly transports: ReadonlyArray<{ readonly __typename?: 'TCTransport', readonly name: string, readonly licensePlate: Maybe<string>, readonly isParentTransport: boolean }> }> };

export type ProjectDetailsQueryVariables = Exact<{
  project: Scalars['UUID'];
  actionsPage?: Maybe<Scalars['Int']>;
  actionsSearch?: Maybe<Scalars['String']>;
}>;


export type ProjectDetailsQuery = { readonly __typename?: 'Query', readonly action_teams: (
    { readonly __typename?: 'ActionTeamPaginator' }
    & ProjectDetailsActionTeamsFragment
  ), readonly action_teams_total: { readonly __typename?: 'ActionTeamPaginator', readonly total: number } };

export type ProjectDetailsActionTeamsQueryVariables = Exact<{
  project: Scalars['UUID'];
  actionsPage?: Maybe<Scalars['Int']>;
  actionsSearch?: Maybe<Scalars['String']>;
}>;


export type ProjectDetailsActionTeamsQuery = { readonly __typename?: 'Query', readonly action_teams: (
    { readonly __typename?: 'ActionTeamPaginator' }
    & ProjectDetailsActionTeamsFragment
  ), readonly action_teams_total: { readonly __typename?: 'ActionTeamPaginator', readonly total: number } };

export type ProjectDetailsActionTeamsFragment = { readonly __typename?: 'ActionTeamPaginator', readonly total: number, readonly items: ReadonlyArray<(
    { readonly __typename?: 'ActionTeam' }
    & ProjectDetailsActionTeamFragment
  )> };

export type ProjectDetailsActionTeamFragment = { readonly __typename?: 'ActionTeam', readonly uuid: UUID, readonly viaCompanyEndDate: Maybe<AppDateTime>, readonly viaCompanyStartDate: Maybe<AppDateTime>, readonly directToEventStartDate: Maybe<AppDateTime>, readonly directToEventEndDate: Maybe<AppDateTime>, readonly startDate: Maybe<AppDateTime>, readonly endDate: Maybe<AppDateTime>, readonly type: ActionTeamType, readonly customNumber: number, readonly name: string, readonly action: { readonly __typename?: 'Action', readonly uuid: UUID, readonly notes: Maybe<string>, readonly name: Maybe<string>, readonly province: Maybe<Province>, readonly actionLocation: Maybe<{ readonly __typename?: 'ActionLocation', readonly uuid: UUID, readonly address: Maybe<string>, readonly lat: Maybe<number>, readonly lng: Maybe<number>, readonly name: Maybe<string> }>, readonly actionPlanningDate: Maybe<{ readonly __typename?: 'ActionPlanningDate', readonly uuid: UUID, readonly date: Maybe<AppDate> }> }, readonly channel: { readonly __typename?: 'Channel', readonly uuid: UUID, readonly name: string }, readonly compositionRoles: ReadonlyArray<Maybe<{ readonly __typename?: 'CompositionRole', readonly uuid: UUID, readonly roleName: string, readonly quantity: Maybe<number> }>>, readonly transports: ReadonlyArray<{ readonly __typename?: 'Transport', readonly uuid: UUID, readonly name: string }> };

type PublishActionAnswerDebriefingAnswerContactsFragment = { readonly __typename?: 'DebriefingAnswerContacts', readonly uuid: UUID, readonly value: Maybe<string>, readonly updatedAt: AppDateTime, readonly formElement: { readonly __typename?: 'FormElement', readonly uuid: UUID, readonly name: Maybe<string>, readonly type: Maybe<FormElementTypes> }, readonly bookingPerson: Maybe<{ readonly __typename?: 'BookingPerson', readonly uuid: UUID, readonly externalUser: { readonly __typename?: 'ExternalUser', readonly uuid: UUID, readonly firstName: string, readonly lastName: string } }>, readonly user: Maybe<{ readonly __typename?: 'User', readonly uuid: UUID, readonly firstName: Maybe<string>, readonly lastName: Maybe<string> }> };

type PublishActionAnswerDebriefingAnswerDateFragment = { readonly __typename?: 'DebriefingAnswerDate', readonly uuid: UUID, readonly value: Maybe<string>, readonly updatedAt: AppDateTime, readonly formElement: { readonly __typename?: 'FormElement', readonly uuid: UUID, readonly name: Maybe<string>, readonly type: Maybe<FormElementTypes> }, readonly bookingPerson: Maybe<{ readonly __typename?: 'BookingPerson', readonly uuid: UUID, readonly externalUser: { readonly __typename?: 'ExternalUser', readonly uuid: UUID, readonly firstName: string, readonly lastName: string } }>, readonly user: Maybe<{ readonly __typename?: 'User', readonly uuid: UUID, readonly firstName: Maybe<string>, readonly lastName: Maybe<string> }> };

type PublishActionAnswerDebriefingAnswerDegreeFragment = { readonly __typename?: 'DebriefingAnswerDegree', readonly uuid: UUID, readonly value: Maybe<string>, readonly updatedAt: AppDateTime, readonly formElement: { readonly __typename?: 'FormElement', readonly uuid: UUID, readonly name: Maybe<string>, readonly type: Maybe<FormElementTypes> }, readonly bookingPerson: Maybe<{ readonly __typename?: 'BookingPerson', readonly uuid: UUID, readonly externalUser: { readonly __typename?: 'ExternalUser', readonly uuid: UUID, readonly firstName: string, readonly lastName: string } }>, readonly user: Maybe<{ readonly __typename?: 'User', readonly uuid: UUID, readonly firstName: Maybe<string>, readonly lastName: Maybe<string> }> };

type PublishActionAnswerDebriefingAnswerDropdownFragment = { readonly __typename?: 'DebriefingAnswerDropdown', readonly uuid: UUID, readonly value: Maybe<string>, readonly updatedAt: AppDateTime, readonly formElement: { readonly __typename?: 'FormElement', readonly uuid: UUID, readonly name: Maybe<string>, readonly type: Maybe<FormElementTypes> }, readonly bookingPerson: Maybe<{ readonly __typename?: 'BookingPerson', readonly uuid: UUID, readonly externalUser: { readonly __typename?: 'ExternalUser', readonly uuid: UUID, readonly firstName: string, readonly lastName: string } }>, readonly user: Maybe<{ readonly __typename?: 'User', readonly uuid: UUID, readonly firstName: Maybe<string>, readonly lastName: Maybe<string> }> };

type PublishActionAnswerDebriefingAnswerFileUploadFragment = { readonly __typename?: 'DebriefingAnswerFileUpload', readonly uuid: UUID, readonly value: Maybe<string>, readonly updatedAt: AppDateTime, readonly formElement: { readonly __typename?: 'FormElement', readonly uuid: UUID, readonly name: Maybe<string>, readonly type: Maybe<FormElementTypes> }, readonly bookingPerson: Maybe<{ readonly __typename?: 'BookingPerson', readonly uuid: UUID, readonly externalUser: { readonly __typename?: 'ExternalUser', readonly uuid: UUID, readonly firstName: string, readonly lastName: string } }>, readonly user: Maybe<{ readonly __typename?: 'User', readonly uuid: UUID, readonly firstName: Maybe<string>, readonly lastName: Maybe<string> }> };

type PublishActionAnswerDebriefingAnswerGoodBadFragment = { readonly __typename?: 'DebriefingAnswerGoodBad', readonly uuid: UUID, readonly value: Maybe<string>, readonly updatedAt: AppDateTime, readonly formElement: { readonly __typename?: 'FormElement', readonly uuid: UUID, readonly name: Maybe<string>, readonly type: Maybe<FormElementTypes> }, readonly bookingPerson: Maybe<{ readonly __typename?: 'BookingPerson', readonly uuid: UUID, readonly externalUser: { readonly __typename?: 'ExternalUser', readonly uuid: UUID, readonly firstName: string, readonly lastName: string } }>, readonly user: Maybe<{ readonly __typename?: 'User', readonly uuid: UUID, readonly firstName: Maybe<string>, readonly lastName: Maybe<string> }> };

type PublishActionAnswerDebriefingAnswerMultipleChoiceFragment = { readonly __typename?: 'DebriefingAnswerMultipleChoice', readonly uuid: UUID, readonly value: Maybe<string>, readonly updatedAt: AppDateTime, readonly formElement: { readonly __typename?: 'FormElement', readonly uuid: UUID, readonly name: Maybe<string>, readonly type: Maybe<FormElementTypes> }, readonly bookingPerson: Maybe<{ readonly __typename?: 'BookingPerson', readonly uuid: UUID, readonly externalUser: { readonly __typename?: 'ExternalUser', readonly uuid: UUID, readonly firstName: string, readonly lastName: string } }>, readonly user: Maybe<{ readonly __typename?: 'User', readonly uuid: UUID, readonly firstName: Maybe<string>, readonly lastName: Maybe<string> }> };

type PublishActionAnswerDebriefingAnswerNumberFragment = { readonly __typename?: 'DebriefingAnswerNumber', readonly uuid: UUID, readonly value: Maybe<string>, readonly updatedAt: AppDateTime, readonly formElement: { readonly __typename?: 'FormElement', readonly uuid: UUID, readonly name: Maybe<string>, readonly type: Maybe<FormElementTypes> }, readonly bookingPerson: Maybe<{ readonly __typename?: 'BookingPerson', readonly uuid: UUID, readonly externalUser: { readonly __typename?: 'ExternalUser', readonly uuid: UUID, readonly firstName: string, readonly lastName: string } }>, readonly user: Maybe<{ readonly __typename?: 'User', readonly uuid: UUID, readonly firstName: Maybe<string>, readonly lastName: Maybe<string> }> };

type PublishActionAnswerDebriefingAnswerOpinionScaleFragment = { readonly __typename?: 'DebriefingAnswerOpinionScale', readonly uuid: UUID, readonly value: Maybe<string>, readonly updatedAt: AppDateTime, readonly formElement: { readonly __typename?: 'FormElement', readonly uuid: UUID, readonly name: Maybe<string>, readonly type: Maybe<FormElementTypes> }, readonly bookingPerson: Maybe<{ readonly __typename?: 'BookingPerson', readonly uuid: UUID, readonly externalUser: { readonly __typename?: 'ExternalUser', readonly uuid: UUID, readonly firstName: string, readonly lastName: string } }>, readonly user: Maybe<{ readonly __typename?: 'User', readonly uuid: UUID, readonly firstName: Maybe<string>, readonly lastName: Maybe<string> }> };

type PublishActionAnswerDebriefingAnswerRatingFragment = { readonly __typename?: 'DebriefingAnswerRating', readonly uuid: UUID, readonly value: Maybe<string>, readonly updatedAt: AppDateTime, readonly formElement: { readonly __typename?: 'FormElement', readonly uuid: UUID, readonly name: Maybe<string>, readonly type: Maybe<FormElementTypes> }, readonly bookingPerson: Maybe<{ readonly __typename?: 'BookingPerson', readonly uuid: UUID, readonly externalUser: { readonly __typename?: 'ExternalUser', readonly uuid: UUID, readonly firstName: string, readonly lastName: string } }>, readonly user: Maybe<{ readonly __typename?: 'User', readonly uuid: UUID, readonly firstName: Maybe<string>, readonly lastName: Maybe<string> }> };

type PublishActionAnswerDebriefingAnswerSamplesFragment = { readonly __typename?: 'DebriefingAnswerSamples', readonly uuid: UUID, readonly value: Maybe<string>, readonly updatedAt: AppDateTime, readonly formElement: { readonly __typename?: 'FormElement', readonly uuid: UUID, readonly name: Maybe<string>, readonly type: Maybe<FormElementTypes> }, readonly bookingPerson: Maybe<{ readonly __typename?: 'BookingPerson', readonly uuid: UUID, readonly externalUser: { readonly __typename?: 'ExternalUser', readonly uuid: UUID, readonly firstName: string, readonly lastName: string } }>, readonly user: Maybe<{ readonly __typename?: 'User', readonly uuid: UUID, readonly firstName: Maybe<string>, readonly lastName: Maybe<string> }> };

type PublishActionAnswerDebriefingAnswerTextFragment = { readonly __typename?: 'DebriefingAnswerText', readonly uuid: UUID, readonly value: Maybe<string>, readonly updatedAt: AppDateTime, readonly formElement: { readonly __typename?: 'FormElement', readonly uuid: UUID, readonly name: Maybe<string>, readonly type: Maybe<FormElementTypes> }, readonly bookingPerson: Maybe<{ readonly __typename?: 'BookingPerson', readonly uuid: UUID, readonly externalUser: { readonly __typename?: 'ExternalUser', readonly uuid: UUID, readonly firstName: string, readonly lastName: string } }>, readonly user: Maybe<{ readonly __typename?: 'User', readonly uuid: UUID, readonly firstName: Maybe<string>, readonly lastName: Maybe<string> }> };

type PublishActionAnswerDebriefingAnswerTextareaFragment = { readonly __typename?: 'DebriefingAnswerTextarea', readonly uuid: UUID, readonly value: Maybe<string>, readonly updatedAt: AppDateTime, readonly formElement: { readonly __typename?: 'FormElement', readonly uuid: UUID, readonly name: Maybe<string>, readonly type: Maybe<FormElementTypes> }, readonly bookingPerson: Maybe<{ readonly __typename?: 'BookingPerson', readonly uuid: UUID, readonly externalUser: { readonly __typename?: 'ExternalUser', readonly uuid: UUID, readonly firstName: string, readonly lastName: string } }>, readonly user: Maybe<{ readonly __typename?: 'User', readonly uuid: UUID, readonly firstName: Maybe<string>, readonly lastName: Maybe<string> }> };

type PublishActionAnswerDebriefingAnswerTimeFragment = { readonly __typename?: 'DebriefingAnswerTime', readonly uuid: UUID, readonly value: Maybe<string>, readonly updatedAt: AppDateTime, readonly formElement: { readonly __typename?: 'FormElement', readonly uuid: UUID, readonly name: Maybe<string>, readonly type: Maybe<FormElementTypes> }, readonly bookingPerson: Maybe<{ readonly __typename?: 'BookingPerson', readonly uuid: UUID, readonly externalUser: { readonly __typename?: 'ExternalUser', readonly uuid: UUID, readonly firstName: string, readonly lastName: string } }>, readonly user: Maybe<{ readonly __typename?: 'User', readonly uuid: UUID, readonly firstName: Maybe<string>, readonly lastName: Maybe<string> }> };

type PublishActionAnswerDebriefingAnswerYesNoFragment = { readonly __typename?: 'DebriefingAnswerYesNo', readonly uuid: UUID, readonly value: Maybe<string>, readonly updatedAt: AppDateTime, readonly formElement: { readonly __typename?: 'FormElement', readonly uuid: UUID, readonly name: Maybe<string>, readonly type: Maybe<FormElementTypes> }, readonly bookingPerson: Maybe<{ readonly __typename?: 'BookingPerson', readonly uuid: UUID, readonly externalUser: { readonly __typename?: 'ExternalUser', readonly uuid: UUID, readonly firstName: string, readonly lastName: string } }>, readonly user: Maybe<{ readonly __typename?: 'User', readonly uuid: UUID, readonly firstName: Maybe<string>, readonly lastName: Maybe<string> }> };

export type PublishActionAnswerFragment = PublishActionAnswerDebriefingAnswerContactsFragment | PublishActionAnswerDebriefingAnswerDateFragment | PublishActionAnswerDebriefingAnswerDegreeFragment | PublishActionAnswerDebriefingAnswerDropdownFragment | PublishActionAnswerDebriefingAnswerFileUploadFragment | PublishActionAnswerDebriefingAnswerGoodBadFragment | PublishActionAnswerDebriefingAnswerMultipleChoiceFragment | PublishActionAnswerDebriefingAnswerNumberFragment | PublishActionAnswerDebriefingAnswerOpinionScaleFragment | PublishActionAnswerDebriefingAnswerRatingFragment | PublishActionAnswerDebriefingAnswerSamplesFragment | PublishActionAnswerDebriefingAnswerTextFragment | PublishActionAnswerDebriefingAnswerTextareaFragment | PublishActionAnswerDebriefingAnswerTimeFragment | PublishActionAnswerDebriefingAnswerYesNoFragment;

export type PublishActionAnswersQueryVariables = Exact<{
  q?: Maybe<FormAnswersQueryInput>;
}>;


export type PublishActionAnswersQuery = { readonly __typename?: 'Query', readonly form_answers: { readonly __typename?: 'FormAnswersPaginator', readonly items: ReadonlyArray<(
      { readonly __typename?: 'DebriefingAnswerText' }
      & PublishActionAnswerDebriefingAnswerTextFragment
    ) | (
      { readonly __typename?: 'DebriefingAnswerTextarea' }
      & PublishActionAnswerDebriefingAnswerTextareaFragment
    ) | (
      { readonly __typename?: 'DebriefingAnswerNumber' }
      & PublishActionAnswerDebriefingAnswerNumberFragment
    ) | (
      { readonly __typename?: 'DebriefingAnswerFileUpload', readonly files: ReadonlyArray<Maybe<{ readonly __typename?: 'DebriefingAnswerFileUploadItem', readonly uuid: UUID, readonly name: string, readonly path: string }>> }
      & PublishActionAnswerDebriefingAnswerFileUploadFragment
    ) | (
      { readonly __typename?: 'DebriefingAnswerOpinionScale', readonly formElement: { readonly __typename?: 'FormElement', readonly opinionScale: Maybe<{ readonly __typename?: 'FormElementOpinionScale', readonly minValue: number, readonly maxValue: number, readonly minLabel: string, readonly maxLabel: string }> } }
      & PublishActionAnswerDebriefingAnswerOpinionScaleFragment
    ) | (
      { readonly __typename?: 'DebriefingAnswerSamples' }
      & PublishActionAnswerDebriefingAnswerSamplesFragment
    ) | (
      { readonly __typename?: 'DebriefingAnswerContacts' }
      & PublishActionAnswerDebriefingAnswerContactsFragment
    ) | (
      { readonly __typename?: 'DebriefingAnswerMultipleChoice', readonly choices: ReadonlyArray<Maybe<{ readonly __typename?: 'FormElementChoice', readonly uuid: UUID, readonly name: string }>> }
      & PublishActionAnswerDebriefingAnswerMultipleChoiceFragment
    ) | (
      { readonly __typename?: 'DebriefingAnswerDropdown', readonly formElement: { readonly __typename?: 'FormElement', readonly choices: ReadonlyArray<Maybe<{ readonly __typename?: 'FormElementChoice', readonly uuid: UUID, readonly name: string }>> } }
      & PublishActionAnswerDebriefingAnswerDropdownFragment
    ) | (
      { readonly __typename?: 'DebriefingAnswerGoodBad' }
      & PublishActionAnswerDebriefingAnswerGoodBadFragment
    ) | (
      { readonly __typename?: 'DebriefingAnswerYesNo' }
      & PublishActionAnswerDebriefingAnswerYesNoFragment
    ) | (
      { readonly __typename?: 'DebriefingAnswerTime' }
      & PublishActionAnswerDebriefingAnswerTimeFragment
    ) | (
      { readonly __typename?: 'DebriefingAnswerDate' }
      & PublishActionAnswerDebriefingAnswerDateFragment
    ) | (
      { readonly __typename?: 'DebriefingAnswerRating' }
      & PublishActionAnswerDebriefingAnswerRatingFragment
    ) | (
      { readonly __typename?: 'DebriefingAnswerDegree' }
      & PublishActionAnswerDebriefingAnswerDegreeFragment
    )> } };

export type ActionPublicationDetailsFragment = { readonly __typename?: 'ActionPublication', readonly uuid: UUID, readonly publishedAt: AppDateTime, readonly intro: Maybe<string>, readonly publishedBy: Maybe<{ readonly __typename?: 'User', readonly uuid: UUID, readonly firstName: Maybe<string>, readonly lastName: Maybe<string> }>, readonly items: ReadonlyArray<Maybe<{ readonly __typename?: 'ActionPublicationItem', readonly uuid: UUID, readonly position: number, readonly source: ActionPublicationItemSource, readonly label: string, readonly value: Maybe<string>, readonly originalValue: Maybe<string>, readonly overridden: boolean, readonly formElement: Maybe<{ readonly __typename?: 'FormElement', readonly uuid: UUID }> }>>, readonly images: ReadonlyArray<Maybe<{ readonly __typename?: 'ActionPublicationImage', readonly uuid: UUID, readonly position: number, readonly source: ActionPublicationItemSource, readonly name: string, readonly path: string, readonly caption: Maybe<string> }>> };

export type PublishActionContextQueryVariables = Exact<{
  q?: Maybe<ActionsQueryInput>;
}>;


export type PublishActionContextQuery = { readonly __typename?: 'Query', readonly actions: { readonly __typename?: 'ActionsPaginator', readonly items: ReadonlyArray<{ readonly __typename?: 'Action', readonly uuid: UUID, readonly name: Maybe<string>, readonly status: Maybe<ActionStatus>, readonly actualSamples: Maybe<number>, readonly actualContacts: Maybe<number>, readonly actionPlanningDate: Maybe<{ readonly __typename?: 'ActionPlanningDate', readonly date: Maybe<AppDate> }>, readonly project: Maybe<{ readonly __typename?: 'Project', readonly name: string, readonly client: { readonly __typename?: 'Client', readonly name: string } }>, readonly debriefing: Maybe<{ readonly __typename?: 'Form', readonly uuid: UUID }>, readonly companyForm: Maybe<{ readonly __typename?: 'Form', readonly uuid: UUID }>, readonly publication: Maybe<(
        { readonly __typename?: 'ActionPublication' }
        & ActionPublicationDetailsFragment
      )> }> } };

export type PublishActionMutationVariables = Exact<{
  input: PublishActionInput;
}>;


export type PublishActionMutation = { readonly __typename?: 'Mutation', readonly publish_action: { readonly __typename?: 'Action', readonly uuid: UUID, readonly status: Maybe<ActionStatus>, readonly actualSamples: Maybe<number>, readonly actualContacts: Maybe<number>, readonly publication: Maybe<(
      { readonly __typename?: 'ActionPublication' }
      & ActionPublicationDetailsFragment
    )> } };

export type UnpublishActionMutationVariables = Exact<{
  input: UnpublishActionInput;
}>;


export type UnpublishActionMutation = { readonly __typename?: 'Mutation', readonly unpublish_action: { readonly __typename?: 'Action', readonly uuid: UUID, readonly status: Maybe<ActionStatus>, readonly publication: Maybe<(
      { readonly __typename?: 'ActionPublication' }
      & ActionPublicationDetailsFragment
    )> } };

export type TimeTracksQueryVariables = Exact<{
  q?: Maybe<TimeTrackQueryInput>;
}>;


export type TimeTracksQuery = { readonly __typename?: 'Query', readonly time_tracks: { readonly __typename?: 'TimeTrackPaginator', readonly items: ReadonlyArray<(
      { readonly __typename?: 'TimeTrack' }
      & TimeTracksFragment
    )> } };

export type TimeTracksFragment = { readonly __typename?: 'TimeTrack', readonly uuid: UUID, readonly type: TimeTrackType, readonly date: AppDateTime, readonly note: Maybe<string>, readonly name: Maybe<string>, readonly description: Maybe<string>, readonly status: TimeTrackStatus, readonly lastStartedDate: AppDateTime, readonly amountOfTimeSeconds: Maybe<number>, readonly createdAt: AppDateTime, readonly projectTask: Maybe<{ readonly __typename?: 'ProjectTask', readonly createdAt: AppDateTime, readonly uuid: UUID, readonly name: string, readonly description: string, readonly estimateLabel: string, readonly originalTask: Maybe<{ readonly __typename?: 'Task', readonly uuid: UUID, readonly name: string }>, readonly taskGroup: Maybe<{ readonly __typename?: 'ProjectTaskGroup', readonly uuid: UUID, readonly originalTaskGroup: { readonly __typename?: 'TaskGroup', readonly uuid: UUID, readonly name: string } }> }>, readonly project: Maybe<{ readonly __typename?: 'Project', readonly uuid: UUID, readonly name: string, readonly resolvedLogo: Maybe<string>, readonly trackTasksBy: Maybe<ProjectTrackTasksBy>, readonly projectGroup: Maybe<{ readonly __typename?: 'ProjectGroup', readonly uuid: UUID, readonly name: string }>, readonly client: { readonly __typename?: 'Client', readonly uuid: UUID, readonly name: string, readonly resolvedLogo: Maybe<string> } }> };

export type AddTimeTrackMutationVariables = Exact<{
  input: AddTimeTrackInput;
}>;


export type AddTimeTrackMutation = { readonly __typename?: 'Mutation', readonly add_time_track: (
    { readonly __typename?: 'TimeTrack' }
    & TimeTracksFragment
  ) };

export type UpdateTimeTrackMutationVariables = Exact<{
  input: UpdateTimeTrackInput;
}>;


export type UpdateTimeTrackMutation = { readonly __typename?: 'Mutation', readonly update_time_track: (
    { readonly __typename?: 'TimeTrack' }
    & TimeTracksFragment
  ) };

export type DeleteTimeTrackMutationVariables = Exact<{
  input: DeleteTimeTrackInput;
}>;


export type DeleteTimeTrackMutation = { readonly __typename?: 'Mutation', readonly delete_time_track: ReadonlyArray<UUID> };

export type ToggleTimeTrackMutationVariables = Exact<{
  input: ToggleTimeTrackInput;
}>;


export type ToggleTimeTrackMutation = { readonly __typename?: 'Mutation', readonly toggle_time_track: (
    { readonly __typename?: 'TimeTrack' }
    & TimeTracksFragment
  ) };

export type TimeTrackStatByDateQueryVariables = Exact<{
  q?: Maybe<TimeTrackQueryInput>;
}>;


export type TimeTrackStatByDateQuery = { readonly __typename?: 'Query', readonly time_track_stat_by_date: { readonly __typename?: 'TimeTrackStatByDatePaginator', readonly items: ReadonlyArray<(
      { readonly __typename?: 'TimeTrackStatByDate' }
      & TimeTrackStatByDateFragment
    )> } };

export type TimeTrackStatByDateFragment = { readonly __typename?: 'TimeTrackStatByDate', readonly date: AppDate, readonly trackedSeconds: number, readonly totalEntries: number };

export type TimeEntryDialogProjectTasksQueryVariables = Exact<{
  q?: Maybe<ProjectTaskQueryInput>;
}>;


export type TimeEntryDialogProjectTasksQuery = { readonly __typename?: 'Query', readonly time_entry_dialog_project_tasks: { readonly __typename?: 'ProjectTaskPaginator', readonly hasMore: boolean, readonly page: number, readonly total: number, readonly items: ReadonlyArray<(
      { readonly __typename?: 'ProjectTask' }
      & TimeTrackerProjectTaskFragment
    )> } };

export type TimeEntryDialogProjectsQueryVariables = Exact<{
  q?: Maybe<ProjectQueryInput>;
}>;


export type TimeEntryDialogProjectsQuery = { readonly __typename?: 'Query', readonly time_entry_dialog_projects: { readonly __typename?: 'ProjectPaginator', readonly hasMore: boolean, readonly page: number, readonly total: number, readonly items: ReadonlyArray<(
      { readonly __typename?: 'Project' }
      & TimeEntryDialogProjectFragment
    )> } };

export type TimeEntryDialogProjectFragment = { readonly __typename?: 'Project', readonly uuid: UUID, readonly name: string, readonly client: { readonly __typename?: 'Client', readonly uuid: UUID, readonly name: string } };

export type TimeTrackerProjectTaskFragment = { readonly __typename?: 'ProjectTask', readonly uuid: UUID, readonly name: string, readonly description: string, readonly billable: Maybe<boolean>, readonly estimateLabel: string, readonly hasEstimateLink: boolean, readonly budgetHours: Maybe<number>, readonly approvedBudgetHours: Maybe<number>, readonly trackedHours: Maybe<number>, readonly plannedHours: Maybe<number>, readonly timeTracks: ReadonlyArray<Maybe<{ readonly __typename?: 'TimeTrack', readonly date: AppDateTime, readonly uuid: UUID, readonly amountOfTimeSeconds: Maybe<number>, readonly type: TimeTrackType, readonly person: Maybe<{ readonly __typename?: 'User', readonly lastName: Maybe<string>, readonly firstName: Maybe<string> }> }>>, readonly projectLeads: Maybe<ReadonlyArray<{ readonly __typename?: 'User', readonly uuid: UUID, readonly firstName: Maybe<string>, readonly lastName: Maybe<string> }>>, readonly originalTask: Maybe<{ readonly __typename?: 'Task', readonly uuid: UUID, readonly name: string, readonly taskRole: Maybe<{ readonly __typename?: 'TaskRole', readonly uuid: UUID, readonly name: string }> }>, readonly taskGroup: Maybe<{ readonly __typename?: 'ProjectTaskGroup', readonly uuid: UUID, readonly originalTaskGroup: { readonly __typename?: 'TaskGroup', readonly uuid: UUID, readonly name: string } }>, readonly projectTaskAssignments: ReadonlyArray<Maybe<{ readonly __typename?: 'ProjectTaskAssignment', readonly uuid: UUID, readonly createdAt: AppDateTime, readonly updatedAt: AppDateTime, readonly projectTask: Maybe<{ readonly __typename?: 'ProjectTask', readonly uuid: UUID }>, readonly timeslots: ReadonlyArray<Maybe<{ readonly __typename?: 'ProjectTaskAssignmentTimeslot', readonly uuid: UUID, readonly date: Maybe<AppDate>, readonly startTime: Maybe<AppDateTime>, readonly duration: Maybe<number>, readonly createdBy: Maybe<{ readonly __typename?: 'User', readonly lastName: Maybe<string>, readonly firstName: Maybe<string>, readonly uuid: UUID, readonly username: string }> }>>, readonly user: Maybe<{ readonly __typename?: 'User', readonly firstName: Maybe<string>, readonly lastName: Maybe<string>, readonly uuid: UUID }> }>>, readonly project: { readonly __typename?: 'Project', readonly uuid: UUID, readonly name: string, readonly resolvedLogo: Maybe<string>, readonly trackTasksBy: Maybe<ProjectTrackTasksBy>, readonly projectGroup: Maybe<{ readonly __typename?: 'ProjectGroup', readonly uuid: UUID, readonly name: string }>, readonly client: { readonly __typename?: 'Client', readonly uuid: UUID, readonly name: string, readonly resolvedLogo: Maybe<string> } } };

export type CurrentCompanyForClientQueryVariables = Exact<{ [key: string]: never; }>;


export type CurrentCompanyForClientQuery = { readonly __typename?: 'Query', readonly current_company: (
    { readonly __typename?: 'Company' }
    & CompanyForClientFragment
  ) };

export type CompanyForClientFragment = { readonly __typename?: 'Company', readonly uuid: UUID, readonly name: string, readonly currencyFormat: Maybe<string>, readonly numberFormat: Maybe<string>, readonly timeFormat: Maybe<string>, readonly timeDisplay: Maybe<string>, readonly dateFormat: Maybe<string>, readonly currency: Maybe<{ readonly __typename?: 'Currency', readonly name: string, readonly code: string, readonly sign: Maybe<string>, readonly uuid: UUID }> };

export const FormListItemFragmentDoc = gql`
    fragment form_list_item on Form {
  uuid
  name
  createdAt
  status
  type
}
    `;
export const ClientActionDetailsFragmentDoc = gql`
    fragment client_action_details_fragment on Action {
  uuid
  clientStatus
  name
  clientUserSignature
  locationContactSignature
  eventDuration
  flowContext {
    isEditable
    canApprove
    canConfirm
    canRequestApproval
  }
  confirmedByClientUser {
    uuid
    firstName
    lastName
  }
  actionPlanningDate {
    date
  }
  actionLocation {
    name
    address
    lat
    lng
    rawDataType
    rawData
  }
  locationContact {
    uuid
    contact {
      uuid
      firstName
      lastName
      emails {
        email
      }
      phones {
        number
      }
    }
  }
  project {
    client {
      uuid
    }
  }
  teamCost {
    scheduleForClient {
      uuid
      startTime
      duration
      peopleCount
      tag {
        uuid
        name
        color
        code
      }
    }
  }
}
    `;
export const ClientsPlannerFilterItemFragmentDoc = gql`
    fragment clients_planner_filter_item_fragment on SimpleEntity {
  uuid
  name
}
    `;
export const ClientsPlannerListPaginatorFragmentDoc = gql`
    fragment clients_planner_list_paginator on ActionsPaginator {
  page
  limit
  total
}
    `;
export const ClientsPlannerListActionFragmentDoc = gql`
    fragment clients_planner_list_action_fragment on Action {
  uuid
  clientStatus
  name
  firstScheduleStartTime
  lastScheduleEndTime
  bookedBookingPersonsCount
  projectLeader {
    user {
      firstName
      lastName
    }
  }
  project {
    name
  }
  actionPlanningDate {
    date
  }
  actionLocation {
    name
    address
  }
  parentTeamCost {
    invoiceItem {
      teamType {
        name
      }
    }
  }
}
    `;
export const TimeslotsFragmentDoc = gql`
    fragment timeslots on ProjectTaskAssignmentTimeslot {
  uuid
}
    `;
export const LeaveHolidayAssignmentFragmentDoc = gql`
    fragment leave_holiday_assignment on LeaveHolidayAssignment {
  uuid
}
    `;
export const TaskAssignmentsFragmentDoc = gql`
    fragment task_assignments on ProjectTaskAssignment {
  uuid
}
    `;
export const DefaultQuantityTypesFragmentDoc = gql`
    fragment default_quantity_types on QuantityTypePaginator {
  items {
    name
    uuid
    createdAt
    updatedAt
  }
}
    `;
export const CreateSubActionTeamFragmentDoc = gql`
    fragment create_sub_action_team on ActionTeam {
  uuid
  project {
    uuid
  }
  channel {
    uuid
  }
}
    `;
export const BookingPersonPerformanceFieldsFragmentDoc = gql`
    fragment booking_person_performance_fields on BookingPersonPerformance {
  arrived
  departed
  comment
  file
  movements {
    state
    date
  }
}
    `;
export const BookingPersonLateMovementsFieldsFragmentDoc = gql`
    fragment booking_person_late_movements_fields on BookingPersonLateMovements {
  count
  latenessType
}
    `;
export const ContractUploadAttentiaCalculationsFragmentDoc = gql`
    fragment contract_upload_attentia_calculations on ContractAttentiaCalculation {
  uuid
  contract {
    documentNumber
    uuid
  }
}
    `;
export const PersonSelectItemForModalFragmentDoc = gql`
    fragment person_select_item_for_modal on PersonSelectListItem {
  compositionRole {
    uuid
  }
  eventDistance
  viaCompanyDistance
  externalUser {
    uuid
    fullName
    firstName
    lastName
    avatar
  }
}
    `;
export const ActualsLineFieldsFragmentDoc = gql`
    fragment actuals_line_fields on ActualsLine {
  type
  bookingYear
  bookingMonth
  documentDate
  documentReference
  realCost
  realSell
  currency
  companyName
  cpReference
  cpDescription
}
    `;
export const ActualTotalsFieldsFragmentDoc = gql`
    fragment actual_totals_fields on ActualTotals {
  sellPrice
  costPrice
}
    `;
export const ProjectActionsListPaginatorFragmentDoc = gql`
    fragment project_actions_list_paginator on ActionsPaginator {
  page
  limit
  total
  statusCounts {
    status
    count
  }
}
    `;
export const ProjectActionsListItemFragmentDoc = gql`
    fragment project_actions_list_item on Action {
  uuid
  status
  cancellationReason
  name
  actionPlanningDate {
    date
  }
  firstScheduleStartTime
  lastScheduleEndTime
  notes
  province
  actionLocation {
    name
    address
  }
  parentTeamCost {
    invoiceItem {
      description
      teamType {
        name
      }
    }
  }
  teamCost {
    compositionRoles {
      roleName
    }
    transports {
      name
      licensePlate
      isParentTransport
    }
  }
}
    `;
export const ProjectDetailsActionTeamFragmentDoc = gql`
    fragment project_details_action_team_fragment on ActionTeam {
  uuid
  viaCompanyEndDate
  viaCompanyStartDate
  directToEventStartDate
  directToEventEndDate
  startDate
  endDate
  type
  customNumber
  name
  action {
    uuid
    notes
    name
    uuid
    province
    actionLocation {
      uuid
      address
      lat
      lng
      name
    }
    actionPlanningDate {
      uuid
      date
    }
  }
  channel {
    uuid
    name
  }
  compositionRoles {
    uuid
    roleName
    quantity
  }
  transports {
    uuid
    name
  }
}
    `;
export const ProjectDetailsActionTeamsFragmentDoc = gql`
    fragment project_details_action_teams_fragment on ActionTeamPaginator {
  total
  items {
    ...project_details_action_team_fragment
  }
}
    ${ProjectDetailsActionTeamFragmentDoc}`;
export const PublishActionAnswerFragmentDoc = gql`
    fragment publish_action_answer on DebriefingAnswerInterface {
  uuid
  value
  updatedAt
  formElement {
    uuid
    name
    type
  }
  bookingPerson {
    uuid
    externalUser {
      uuid
      firstName
      lastName
    }
  }
  user {
    uuid
    firstName
    lastName
  }
}
    `;
export const ActionPublicationDetailsFragmentDoc = gql`
    fragment action_publication_details on ActionPublication {
  uuid
  publishedAt
  intro
  publishedBy {
    uuid
    firstName
    lastName
  }
  items {
    uuid
    position
    source
    label
    value
    originalValue
    overridden
    formElement {
      uuid
    }
  }
  images {
    uuid
    position
    source
    name
    path
    caption
  }
}
    `;
export const TimeTracksFragmentDoc = gql`
    fragment time_tracks on TimeTrack {
  uuid
  type
  date
  note
  name
  description
  status
  lastStartedDate
  amountOfTimeSeconds
  createdAt
  projectTask {
    createdAt
    uuid
    name
    description
    estimateLabel
    originalTask {
      uuid
      name
    }
    taskGroup {
      uuid
      originalTaskGroup {
        uuid
        name
      }
    }
  }
  project {
    uuid
    name
    resolvedLogo
    trackTasksBy
    projectGroup {
      uuid
      name
    }
    client {
      uuid
      name
      resolvedLogo
    }
  }
}
    `;
export const TimeTrackStatByDateFragmentDoc = gql`
    fragment time_track_stat_by_date on TimeTrackStatByDate {
  date
  trackedSeconds
  totalEntries
}
    `;
export const TimeEntryDialogProjectFragmentDoc = gql`
    fragment time_entry_dialog_project on Project {
  uuid
  name
  client {
    uuid
    name
  }
}
    `;
export const TimeTrackerProjectTaskFragmentDoc = gql`
    fragment time_tracker_project_task on ProjectTask {
  uuid
  name
  description
  billable
  estimateLabel
  hasEstimateLink
  budgetHours
  approvedBudgetHours
  trackedHours
  plannedHours
  timeTracks {
    date
    uuid
    amountOfTimeSeconds
    type
    person {
      lastName
      firstName
    }
  }
  projectLeads {
    uuid
    firstName
    lastName
  }
  originalTask {
    uuid
    name
    taskRole {
      uuid
      name
    }
  }
  taskGroup {
    uuid
    originalTaskGroup {
      uuid
      name
    }
  }
  projectTaskAssignments {
    uuid
    projectTask {
      uuid
    }
    timeslots {
      uuid
      date
      startTime
      duration
      createdBy {
        lastName
        firstName
        uuid
        username
      }
    }
    createdAt
    updatedAt
    user {
      firstName
      lastName
      uuid
    }
  }
  projectTaskAssignments {
    timeslots {
      createdBy {
        lastName
        firstName
        uuid
        username
      }
    }
  }
  project {
    uuid
    name
    resolvedLogo
    trackTasksBy
    projectGroup {
      uuid
      name
    }
    client {
      uuid
      name
      resolvedLogo
    }
  }
}
    `;
export const CompanyForClientFragmentDoc = gql`
    fragment company_for_client on Company {
  uuid
  name
  currencyFormat
  numberFormat
  timeFormat
  timeDisplay
  dateFormat
  currency {
    name
    code
    sign
    uuid
  }
}
    `;
export const ClientSimpleListDocument = gql`
    query client_simple_list($q: ClientQueryInput) {
  clients(q: $q) {
    page
    limit
    total
    items {
      uuid
      name
      logo
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class ClientSimpleListGQL extends Apollo.Query<ClientSimpleListQuery, ClientSimpleListQueryVariables> {
    document = ClientSimpleListDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const FormListDocument = gql`
    query form_list($q: FormsQueryInput!) {
  forms(q: $q) {
    page
    limit
    total
    items {
      ...form_list_item
    }
  }
}
    ${FormListItemFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class FormListGQL extends Apollo.Query<FormListQuery, FormListQueryVariables> {
    document = FormListDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const ClientActionDetailsDocument = gql`
    query client_action_details($q: ActionsQueryInput) {
  actions(q: $q) {
    items {
      ...client_action_details_fragment
    }
  }
}
    ${ClientActionDetailsFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class ClientActionDetailsGQL extends Apollo.Query<ClientActionDetailsQuery, ClientActionDetailsQueryVariables> {
    document = ClientActionDetailsDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const UpdateActionByClientDocument = gql`
    mutation update_action_by_client($input: UpdateActionByClientInput!) {
  update_action_by_client(input: $input) {
    ...client_action_details_fragment
  }
}
    ${ClientActionDetailsFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class UpdateActionByClientGQL extends Apollo.Mutation<UpdateActionByClientMutation, UpdateActionByClientMutationVariables> {
    document = UpdateActionByClientDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const ClientsPlannerFiltersDocument = gql`
    query clients_planner_filters($client: [UUID!], $listType: ActionListType) {
  projects: actions_filter(
    q: {client: $client, listType: $listType, filterType: PROJECT}
  ) {
    items {
      ...clients_planner_filter_item_fragment
    }
  }
  locations: actions_filter(
    q: {client: $client, listType: $listType, filterType: LOCATION}
  ) {
    items {
      ...clients_planner_filter_item_fragment
    }
  }
  statuses: actions_filter(
    q: {client: $client, listType: $listType, filterType: STATUS}
  ) {
    items {
      ...clients_planner_filter_item_fragment
    }
  }
  action_types: actions_filter(
    q: {client: $client, listType: $listType, filterType: ACTION_TYPE}
  ) {
    items {
      ...clients_planner_filter_item_fragment
    }
  }
  action_planners: actions_filter(
    q: {client: $client, listType: $listType, filterType: ACTION_PLANNER}
  ) {
    items {
      ...clients_planner_filter_item_fragment
    }
  }
}
    ${ClientsPlannerFilterItemFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class ClientsPlannerFiltersGQL extends Apollo.Query<ClientsPlannerFiltersQuery, ClientsPlannerFiltersQueryVariables> {
    document = ClientsPlannerFiltersDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const ClientsPlannerListDocument = gql`
    query clients_planner_list($q: ActionsQueryInput) {
  actions(q: $q) {
    ...clients_planner_list_paginator
    items {
      ...clients_planner_list_action_fragment
    }
  }
}
    ${ClientsPlannerListPaginatorFragmentDoc}
${ClientsPlannerListActionFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class ClientsPlannerListGQL extends Apollo.Query<ClientsPlannerListQuery, ClientsPlannerListQueryVariables> {
    document = ClientsPlannerListDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const ProjectTaskAssignmentsDocument = gql`
    query project_task_assignments($q: ProjectTaskAssignmentQueryInput) {
  project_task_assignments(q: $q) {
    items {
      assignmentUuid
      timeslotUuid
      duration
      type
      date
      createdAt
      updatedAt
      startTime
      note
      isConfirmed
      events {
        uuid
        user {
          uuid
          username
          firstName
          lastName
        }
        comment
        updatedAt
        createdAt
      }
      projectTask {
        ...time_tracker_project_task
        projectTaskAssignments {
          timeslots {
            createdBy {
              username
              firstName
              lastName
            }
          }
        }
        project {
          projectId
          name
        }
      }
      leaveHolidayAssignment {
        uuid
        type {
          uuid
          title
          description
        }
      }
      user {
        uuid
        username
      }
    }
    page
    hasMore
    total
  }
}
    ${TimeTrackerProjectTaskFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class ProjectTaskAssignmentsGQL extends Apollo.Query<ProjectTaskAssignmentsQuery, ProjectTaskAssignmentsQueryVariables> {
    document = ProjectTaskAssignmentsDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const AddProjectTaskAssignmentDocument = gql`
    mutation add_project_task_assignment($input: AddProjectTaskAssignmentInput!) {
  add_project_task_assignment(input: $input) {
    ...task_assignments
  }
}
    ${TaskAssignmentsFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class AddProjectTaskAssignmentGQL extends Apollo.Mutation<AddProjectTaskAssignmentMutation, AddProjectTaskAssignmentMutationVariables> {
    document = AddProjectTaskAssignmentDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const UpdateProjectTaskAssignmentDocument = gql`
    mutation update_project_task_assignment($input: UpdateProjectTaskAssignmentInput!) {
  update_project_task_assignment(input: $input) {
    ...task_assignments
  }
}
    ${TaskAssignmentsFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class UpdateProjectTaskAssignmentGQL extends Apollo.Mutation<UpdateProjectTaskAssignmentMutation, UpdateProjectTaskAssignmentMutationVariables> {
    document = UpdateProjectTaskAssignmentDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const DeleteProjectTaskAssignmentDocument = gql`
    mutation delete_project_task_assignment($input: DeleteProjectTaskAssignmentInput!) {
  delete_project_task_assignment(input: $input)
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class DeleteProjectTaskAssignmentGQL extends Apollo.Mutation<DeleteProjectTaskAssignmentMutation, DeleteProjectTaskAssignmentMutationVariables> {
    document = DeleteProjectTaskAssignmentDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const AddLeaveHolidayAssignmentDocument = gql`
    mutation add_leave_holiday_assignment($input: AddLeaveHolidayAssignmentInput!) {
  add_leave_holiday_assignment(input: $input) {
    ...timeslots
  }
}
    ${TimeslotsFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class AddLeaveHolidayAssignmentGQL extends Apollo.Mutation<AddLeaveHolidayAssignmentMutation, AddLeaveHolidayAssignmentMutationVariables> {
    document = AddLeaveHolidayAssignmentDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const UpdateLeaveHolidayAssignmentDocument = gql`
    mutation update_leave_holiday_assignment($input: UpdateLeaveHolidayAssignmentInput!) {
  update_leave_holiday_assignment(input: $input) {
    ...leave_holiday_assignment
  }
}
    ${LeaveHolidayAssignmentFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class UpdateLeaveHolidayAssignmentGQL extends Apollo.Mutation<UpdateLeaveHolidayAssignmentMutation, UpdateLeaveHolidayAssignmentMutationVariables> {
    document = UpdateLeaveHolidayAssignmentDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const DeleteLeaveHolidayAssignmentDocument = gql`
    mutation delete_leave_holiday_assignment($input: DeleteLeaveHolidayAssignmentInput!) {
  delete_leave_holiday_assignment(input: $input)
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class DeleteLeaveHolidayAssignmentGQL extends Apollo.Mutation<DeleteLeaveHolidayAssignmentMutation, DeleteLeaveHolidayAssignmentMutationVariables> {
    document = DeleteLeaveHolidayAssignmentDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const ItemsOverviewQuantityTypesDocument = gql`
    query items_overview_quantity_types($page: Int, $limit: Int, $search: String) {
  quantity_types(
    q: {sort: [{by: CREATED_AT}], page: $page, limit: $limit, search: $search}
  ) {
    total
    items {
      name
      uuid
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class ItemsOverviewQuantityTypesGQL extends Apollo.Query<ItemsOverviewQuantityTypesQuery, ItemsOverviewQuantityTypesQueryVariables> {
    document = ItemsOverviewQuantityTypesDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const ItemsOverviewAddQuantityTypeDocument = gql`
    mutation items_overview_add_quantity_type($input: AddQuantityTypeInput!) {
  add_quantity_type(input: $input) {
    name
    uuid
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class ItemsOverviewAddQuantityTypeGQL extends Apollo.Mutation<ItemsOverviewAddQuantityTypeMutation, ItemsOverviewAddQuantityTypeMutationVariables> {
    document = ItemsOverviewAddQuantityTypeDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const DefaultQuantityTypesDocument = gql`
    query default_quantity_types {
  blank: quantity_types(
    q: {sort: [{by: CREATED_AT}], page: 1, limit: 1, name: "Blank"}
  ) {
    ...default_quantity_types
  }
  hours: quantity_types(
    q: {sort: [{by: CREATED_AT}], page: 1, limit: 1, name: "Hours"}
  ) {
    ...default_quantity_types
  }
  days: quantity_types(
    q: {sort: [{by: CREATED_AT}], page: 1, limit: 1, name: "Days"}
  ) {
    ...default_quantity_types
  }
  percentage: quantity_types(
    q: {sort: [{by: CREATED_AT}], page: 1, limit: 1, name: "%"}
  ) {
    ...default_quantity_types
  }
}
    ${DefaultQuantityTypesFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class DefaultQuantityTypesGQL extends Apollo.Query<DefaultQuantityTypesQuery, DefaultQuantityTypesQueryVariables> {
    document = DefaultQuantityTypesDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const CompanyHolidaysDocument = gql`
    query company_holidays {
  company_holidays {
    uuid
    date
    name
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class CompanyHolidaysGQL extends Apollo.Query<CompanyHolidaysQuery, CompanyHolidaysQueryVariables> {
    document = CompanyHolidaysDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const AddCompanyHolidayDocument = gql`
    mutation add_company_holiday($input: AddCompanyHolidayInput!) {
  add_company_holiday(input: $input) {
    uuid
    date
    name
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class AddCompanyHolidayGQL extends Apollo.Mutation<AddCompanyHolidayMutation, AddCompanyHolidayMutationVariables> {
    document = AddCompanyHolidayDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const DeleteCompanyHolidayDocument = gql`
    mutation delete_company_holiday($input: DeleteCompanyHolidayInput!) {
  delete_company_holiday(input: $input)
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class DeleteCompanyHolidayGQL extends Apollo.Mutation<DeleteCompanyHolidayMutation, DeleteCompanyHolidayMutationVariables> {
    document = DeleteCompanyHolidayDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const CreateSubActionTeamDocument = gql`
    mutation create_sub_action_team($input: CreateSubActionTeamInput!) {
  create_sub_action_team(input: $input) {
    ...create_sub_action_team
  }
}
    ${CreateSubActionTeamFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class CreateSubActionTeamGQL extends Apollo.Mutation<CreateSubActionTeamMutation, CreateSubActionTeamMutationVariables> {
    document = CreateSubActionTeamDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const FormAnswerDetailsDocument = gql`
    query form_answer_details($q: FormAnswersQueryInput) {
  form_answers(q: $q) {
    items {
      ... on DebriefingAnswerText {
        uuid
        value
        formElement {
          uuid
          name
          type
        }
      }
      ... on DebriefingAnswerTextarea {
        uuid
        value
        formElement {
          uuid
          name
          type
        }
      }
      ... on DebriefingAnswerNumber {
        uuid
        value
        formElement {
          uuid
          name
          type
        }
      }
      ... on DebriefingAnswerSamples {
        uuid
        value
        formElement {
          uuid
          name
          type
        }
      }
      ... on DebriefingAnswerContacts {
        uuid
        value
        formElement {
          uuid
          name
          type
        }
      }
      ... on DebriefingAnswerRating {
        uuid
        value
        formElement {
          uuid
          name
          type
        }
      }
      ... on DebriefingAnswerGoodBad {
        uuid
        value
        formElement {
          uuid
          name
          type
        }
      }
      ... on DebriefingAnswerYesNo {
        uuid
        value
        formElement {
          uuid
          name
          type
        }
      }
      ... on DebriefingAnswerTime {
        uuid
        value
        formElement {
          uuid
          name
          type
        }
      }
      ... on DebriefingAnswerDate {
        uuid
        value
        formElement {
          uuid
          name
          type
        }
      }
      ... on DebriefingAnswerDegree {
        uuid
        value
        formElement {
          uuid
          name
          type
        }
      }
      ... on DebriefingAnswerOpinionScale {
        uuid
        value
        formElement {
          uuid
          name
          type
          opinionScale {
            minValue
            maxValue
            minLabel
            maxLabel
          }
        }
      }
      ... on DebriefingAnswerMultipleChoice {
        uuid
        choices {
          uuid
          name
        }
        formElement {
          uuid
          name
          type
          choices {
            uuid
            name
          }
        }
      }
      ... on DebriefingAnswerFileUpload {
        uuid
        files {
          uuid
          name
          path
        }
        formElement {
          uuid
          name
          type
        }
      }
      ... on DebriefingAnswerDropdown {
        uuid
        value
        formElement {
          uuid
          name
          type
          choices {
            uuid
            name
          }
        }
      }
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class FormAnswerDetailsGQL extends Apollo.Query<FormAnswerDetailsQuery, FormAnswerDetailsQueryVariables> {
    document = FormAnswerDetailsDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const FormAnswersListDocument = gql`
    query form_answers_list($q: FormAnswersListQueryInput!) {
  form_answers_list(q: $q) {
    actionName
    actionUuid
    userUuid
    externalUserUuid
    firstName
    lastName
    date
    type
    formUuid
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class FormAnswersListGQL extends Apollo.Query<FormAnswersListQuery, FormAnswersListQueryVariables> {
    document = FormAnswersListDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const CompanyPayrollCodesDocument = gql`
    query company_payroll_codes {
  company_payroll_codes {
    key
    value
    defaultValue
    isCustom
    description
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class CompanyPayrollCodesGQL extends Apollo.Query<CompanyPayrollCodesQuery, CompanyPayrollCodesQueryVariables> {
    document = CompanyPayrollCodesDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const SetCompanyPayrollCodeDocument = gql`
    mutation set_company_payroll_code($input: SetCompanyPayrollCodeInput!) {
  set_company_payroll_code(input: $input) {
    key
    value
    defaultValue
    isCustom
    description
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class SetCompanyPayrollCodeGQL extends Apollo.Mutation<SetCompanyPayrollCodeMutation, SetCompanyPayrollCodeMutationVariables> {
    document = SetCompanyPayrollCodeDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const CompanyPayrollRulesDocument = gql`
    query company_payroll_rules {
  company_payroll_rules {
    uuid
    jointCommittee {
      uuid
      name
      code
    }
    externalJcCode
    functionCategoryCode
    functionDescription
    contractType
    overtimeRatePercentage
    saturdayOvertimeCode
    saturdayOvertimeRatePercentage
    sundayOvertimeCode
    sundayOvertimeRatePercentage
    holidayRatePercentage
    daysPerWeek
    hoursPerWeek
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class CompanyPayrollRulesGQL extends Apollo.Query<CompanyPayrollRulesQuery, CompanyPayrollRulesQueryVariables> {
    document = CompanyPayrollRulesDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const SetCompanyPayrollRuleDocument = gql`
    mutation set_company_payroll_rule($input: SetCompanyPayrollRuleInput!) {
  set_company_payroll_rule(input: $input) {
    uuid
    jointCommittee {
      uuid
      name
      code
    }
    externalJcCode
    functionCategoryCode
    functionDescription
    contractType
    overtimeRatePercentage
    saturdayOvertimeCode
    saturdayOvertimeRatePercentage
    sundayOvertimeCode
    sundayOvertimeRatePercentage
    holidayRatePercentage
    daysPerWeek
    hoursPerWeek
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class SetCompanyPayrollRuleGQL extends Apollo.Mutation<SetCompanyPayrollRuleMutation, SetCompanyPayrollRuleMutationVariables> {
    document = SetCompanyPayrollRuleDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const DeleteCompanyPayrollRuleDocument = gql`
    mutation delete_company_payroll_rule($input: DeleteCompanyPayrollRuleInput!) {
  delete_company_payroll_rule(input: $input)
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class DeleteCompanyPayrollRuleGQL extends Apollo.Mutation<DeleteCompanyPayrollRuleMutation, DeleteCompanyPayrollRuleMutationVariables> {
    document = DeleteCompanyPayrollRuleDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const ContractDataDocument = gql`
    query contract_data($contractId: UUID!) {
  booking_person_late_movements(q: {contractId: $contractId}) {
    ...booking_person_late_movements_fields
  }
  booking_person_performance(q: {contractId: $contractId}) {
    ...booking_person_performance_fields
  }
}
    ${BookingPersonLateMovementsFieldsFragmentDoc}
${BookingPersonPerformanceFieldsFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class ContractDataGQL extends Apollo.Query<ContractDataQuery, ContractDataQueryVariables> {
    document = ContractDataDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const ForgiveLatenessDocument = gql`
    mutation forgive_lateness($uuid: UUID!, $date: DateTimeImmutable) {
  update_external_user(input: {uuid: $uuid, latenessForgivenDate: $date}) {
    uuid
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class ForgiveLatenessGQL extends Apollo.Mutation<ForgiveLatenessMutation, ForgiveLatenessMutationVariables> {
    document = ForgiveLatenessDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const SaveBookingPersonPerformanceDocument = gql`
    mutation save_booking_person_performance($contractId: UUID!, $arrived: DateTimeImmutable, $departed: DateTimeImmutable) {
  save_booking_person_performance(
    input: {contractId: $contractId, arrived: $arrived, departed: $departed}
  ) {
    ...booking_person_performance_fields
  }
}
    ${BookingPersonPerformanceFieldsFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class SaveBookingPersonPerformanceGQL extends Apollo.Mutation<SaveBookingPersonPerformanceMutation, SaveBookingPersonPerformanceMutationVariables> {
    document = SaveBookingPersonPerformanceDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const ContractUploadAttentiaCalculationsDocument = gql`
    mutation contract_upload_attentia_calculations($input: ContractUploadAttentiaCalculationsInput!) {
  contract_upload_attentia_calculations(input: $input) {
    importedCalculations {
      ...contract_upload_attentia_calculations
    }
    alreadyImportedContractNumbers
    notImportableContractNumbers
  }
}
    ${ContractUploadAttentiaCalculationsFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class ContractUploadAttentiaCalculationsGQL extends Apollo.Mutation<ContractUploadAttentiaCalculationsMutation, ContractUploadAttentiaCalculationsMutationVariables> {
    document = ContractUploadAttentiaCalculationsDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const PersonSelectListForModalDocument = gql`
    query person_select_list_for_modal($q: PersonSelectListQueryInput!) {
  person_select_list(q: $q) {
    total
    hasMore
    hash
    page
    items {
      ...person_select_item_for_modal
    }
  }
}
    ${PersonSelectItemForModalFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class PersonSelectListForModalGQL extends Apollo.Query<PersonSelectListForModalQuery, PersonSelectListForModalQueryVariables> {
    document = PersonSelectListForModalDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const PersonSelectModalBookingPersonsStatDocument = gql`
    query person_select_modal_booking_persons_stat($q: BookingPersonsQueryInput) {
  booking_persons_stat(q: $q) {
    studentWorkdaysMin
    studentWorkdaysMax
    weightMin
    weightMax
    BMIMin
    BMIMax
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class PersonSelectModalBookingPersonsStatGQL extends Apollo.Query<PersonSelectModalBookingPersonsStatQuery, PersonSelectModalBookingPersonsStatQueryVariables> {
    document = PersonSelectModalBookingPersonsStatDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const ActualsDocument = gql`
    query actuals($projectUuid: UUID!) {
  actuals(q: {projectUUIDs: [$projectUuid]}) {
    ...actuals_line_fields
  }
  actual_totals(q: {projectUUIDs: [$projectUuid]}) {
    ...actual_totals_fields
  }
}
    ${ActualsLineFieldsFragmentDoc}
${ActualTotalsFieldsFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class ActualsGQL extends Apollo.Query<ActualsQuery, ActualsQueryVariables> {
    document = ActualsDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const ProjectActionsListDocument = gql`
    query project_actions_list($q: ActionsQueryInput) {
  actions(q: $q) {
    ...project_actions_list_paginator
    items {
      ...project_actions_list_item
    }
  }
}
    ${ProjectActionsListPaginatorFragmentDoc}
${ProjectActionsListItemFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class ProjectActionsListGQL extends Apollo.Query<ProjectActionsListQuery, ProjectActionsListQueryVariables> {
    document = ProjectActionsListDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const ProjectDetailsDocument = gql`
    query project_details($project: UUID!, $actionsPage: Int, $actionsSearch: String) {
  action_teams(
    q: {projects: [$project], childrenOnly: true, page: $actionsPage, search: $actionsSearch}
  ) {
    ...project_details_action_teams_fragment
  }
  action_teams_total: action_teams(q: {projects: [$project], childrenOnly: true}) {
    total
  }
}
    ${ProjectDetailsActionTeamsFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class ProjectDetailsGQL extends Apollo.Query<ProjectDetailsQuery, ProjectDetailsQueryVariables> {
    document = ProjectDetailsDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const ProjectDetailsActionTeamsDocument = gql`
    query project_details_action_teams($project: UUID!, $actionsPage: Int, $actionsSearch: String) {
  action_teams(
    q: {projects: [$project], childrenOnly: true, page: $actionsPage, search: $actionsSearch}
  ) {
    ...project_details_action_teams_fragment
  }
  action_teams_total: action_teams(q: {projects: [$project], childrenOnly: true}) {
    total
  }
}
    ${ProjectDetailsActionTeamsFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class ProjectDetailsActionTeamsGQL extends Apollo.Query<ProjectDetailsActionTeamsQuery, ProjectDetailsActionTeamsQueryVariables> {
    document = ProjectDetailsActionTeamsDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const PublishActionAnswersDocument = gql`
    query publish_action_answers($q: FormAnswersQueryInput) {
  form_answers(q: $q) {
    items {
      ...publish_action_answer
      ... on DebriefingAnswerMultipleChoice {
        choices {
          uuid
          name
        }
      }
      ... on DebriefingAnswerFileUpload {
        files {
          uuid
          name
          path
        }
      }
      ... on DebriefingAnswerDropdown {
        formElement {
          choices {
            uuid
            name
          }
        }
      }
      ... on DebriefingAnswerOpinionScale {
        formElement {
          opinionScale {
            minValue
            maxValue
            minLabel
            maxLabel
          }
        }
      }
    }
  }
}
    ${PublishActionAnswerFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class PublishActionAnswersGQL extends Apollo.Query<PublishActionAnswersQuery, PublishActionAnswersQueryVariables> {
    document = PublishActionAnswersDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const PublishActionContextDocument = gql`
    query publish_action_context($q: ActionsQueryInput) {
  actions(q: $q) {
    items {
      uuid
      name
      status
      actualSamples
      actualContacts
      actionPlanningDate {
        date
      }
      project {
        name
        client {
          name
        }
      }
      debriefing {
        uuid
      }
      companyForm {
        uuid
      }
      publication {
        ...action_publication_details
      }
    }
  }
}
    ${ActionPublicationDetailsFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class PublishActionContextGQL extends Apollo.Query<PublishActionContextQuery, PublishActionContextQueryVariables> {
    document = PublishActionContextDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const PublishActionDocument = gql`
    mutation publish_action($input: PublishActionInput!) {
  publish_action(input: $input) {
    uuid
    status
    actualSamples
    actualContacts
    publication {
      ...action_publication_details
    }
  }
}
    ${ActionPublicationDetailsFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class PublishActionGQL extends Apollo.Mutation<PublishActionMutation, PublishActionMutationVariables> {
    document = PublishActionDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const UnpublishActionDocument = gql`
    mutation unpublish_action($input: UnpublishActionInput!) {
  unpublish_action(input: $input) {
    uuid
    status
    publication {
      ...action_publication_details
    }
  }
}
    ${ActionPublicationDetailsFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class UnpublishActionGQL extends Apollo.Mutation<UnpublishActionMutation, UnpublishActionMutationVariables> {
    document = UnpublishActionDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const TimeTracksDocument = gql`
    query time_tracks($q: TimeTrackQueryInput) {
  time_tracks(q: $q) {
    items {
      ...time_tracks
    }
  }
}
    ${TimeTracksFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class TimeTracksGQL extends Apollo.Query<TimeTracksQuery, TimeTracksQueryVariables> {
    document = TimeTracksDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const AddTimeTrackDocument = gql`
    mutation add_time_track($input: AddTimeTrackInput!) {
  add_time_track(input: $input) {
    ...time_tracks
  }
}
    ${TimeTracksFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class AddTimeTrackGQL extends Apollo.Mutation<AddTimeTrackMutation, AddTimeTrackMutationVariables> {
    document = AddTimeTrackDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const UpdateTimeTrackDocument = gql`
    mutation update_time_track($input: UpdateTimeTrackInput!) {
  update_time_track(input: $input) {
    ...time_tracks
  }
}
    ${TimeTracksFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class UpdateTimeTrackGQL extends Apollo.Mutation<UpdateTimeTrackMutation, UpdateTimeTrackMutationVariables> {
    document = UpdateTimeTrackDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const DeleteTimeTrackDocument = gql`
    mutation delete_time_track($input: DeleteTimeTrackInput!) {
  delete_time_track(input: $input)
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class DeleteTimeTrackGQL extends Apollo.Mutation<DeleteTimeTrackMutation, DeleteTimeTrackMutationVariables> {
    document = DeleteTimeTrackDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const ToggleTimeTrackDocument = gql`
    mutation toggle_time_track($input: ToggleTimeTrackInput!) {
  toggle_time_track(input: $input) {
    ...time_tracks
  }
}
    ${TimeTracksFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class ToggleTimeTrackGQL extends Apollo.Mutation<ToggleTimeTrackMutation, ToggleTimeTrackMutationVariables> {
    document = ToggleTimeTrackDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const TimeTrackStatByDateDocument = gql`
    query time_track_stat_by_date($q: TimeTrackQueryInput) {
  time_track_stat_by_date(q: $q) {
    items {
      ...time_track_stat_by_date
    }
  }
}
    ${TimeTrackStatByDateFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class TimeTrackStatByDateGQL extends Apollo.Query<TimeTrackStatByDateQuery, TimeTrackStatByDateQueryVariables> {
    document = TimeTrackStatByDateDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const TimeEntryDialogProjectTasksDocument = gql`
    query time_entry_dialog_project_tasks($q: ProjectTaskQueryInput) {
  time_entry_dialog_project_tasks: project_tasks(q: $q) {
    items {
      ...time_tracker_project_task
    }
    hasMore
    page
    total
  }
}
    ${TimeTrackerProjectTaskFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class TimeEntryDialogProjectTasksGQL extends Apollo.Query<TimeEntryDialogProjectTasksQuery, TimeEntryDialogProjectTasksQueryVariables> {
    document = TimeEntryDialogProjectTasksDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const TimeEntryDialogProjectsDocument = gql`
    query time_entry_dialog_projects($q: ProjectQueryInput) {
  time_entry_dialog_projects: projects(q: $q) {
    items {
      ...time_entry_dialog_project
    }
    hasMore
    page
    total
  }
}
    ${TimeEntryDialogProjectFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class TimeEntryDialogProjectsGQL extends Apollo.Query<TimeEntryDialogProjectsQuery, TimeEntryDialogProjectsQueryVariables> {
    document = TimeEntryDialogProjectsDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const CurrentCompanyForClientDocument = gql`
    query current_company_for_client {
  current_company {
    ...company_for_client
  }
}
    ${CompanyForClientFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class CurrentCompanyForClientGQL extends Apollo.Query<CurrentCompanyForClientQuery, CurrentCompanyForClientQueryVariables> {
    document = CurrentCompanyForClientDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }